// // import React, { useState, useEffect, useRef } from 'react';
// // import { useLocation, useNavigate } from 'react-router-dom';
// // import { useAuth } from '../context/AuthContext';
// // import './AnalysisPage.css';
// // import { BASE_URL } from '../constants';
// // import ReactDOM from 'react-dom';
// // import ErrorComponent from '../components/ErrorComponent';

// // const StreetAnalysis = () => {
// //   useEffect(() => { window.scrollTo(0, 0); }, []);

// //   const navigate = useNavigate();
// //   const location = useLocation();
// //   const { user } = useAuth();

// //   // Primary data
// //   const [streetData, setStreetData] = useState(null);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);

// //   // UI / comparison state
// //   const [activeCategory, setActiveCategory] = useState(null);
// //   const [compareInput, setCompareInput] = useState('');
// //   const [compareSuggestions, setCompareSuggestions] = useState([]);
// //   const [showCompareSuggestions, setShowCompareSuggestions] = useState(false);
// //   const [compareLoading, setCompareLoading] = useState(false);
// //   const [compareSelectedId, setCompareSelectedId] = useState(null); // id selected from suggestions
// //   const [comparisonData, setComparisonData] = useState(null);
// //   const [comparisonAmenities, setComparisonAmenities] = useState(null);
// //   const [showComparison, setShowComparison] = useState(false);

// //   // modal state
// //   const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
// //   const [modalCategory, setModalCategory] = useState(null);
// //   const [modalStreetName, setModalStreetName] = useState('');

// //   const compareRef = useRef(null); // to close suggestions on outside click

// //   // accept both 'street_id' and 'id' query params for compatibility
// //   const queryParams = new URLSearchParams(location.search);
// //   const streetIdFromUrl = queryParams.get('street_id') || queryParams.get('id') || null;

// //   const BAR_COLORS = {
// //     Education: '#34D169',
// //     Transport: '#3B82F6',
// //     'Parks & Recreation': '#F59E0B',
// //   };

// //   const amenityCategories = [
// //     { id: 'school', name: 'School', icon: '🏫' },
// //     { id: 'university', name: 'University', icon: '🎓' },
// //     { id: 'library', name: 'Library', icon: '📚' },
// //     { id: 'hospital', name: 'Hospital', icon: '🏥' },
// //     { id: 'doctor', name: 'Doctor', icon: '👨‍⚕️' },
// //     { id: 'pharmacy', name: 'Pharmacy', icon: '💊' },
// //     { id: 'restaurant', name: 'Restaurant', icon: '🍽️' },
// //     { id: 'cafe', name: 'Café', icon: '☕' },
// //     { id: 'bakery', name: 'Bakery', icon: '🥐' },
// //     { id: 'bar', name: 'Bar', icon: '🍻' },
// //     { id: 'grocery_or_supermarket', name: 'Grocery Store', icon: '🛒' },
// //     { id: 'supermarket', name: 'Supermarket', icon: '🛍️' },
// //     { id: 'bank', name: 'Bank', icon: '🏦' },
// //     { id: 'atm', name: 'ATM', icon: '💳' },
// //     { id: 'post_office', name: 'Post Office', icon: '📮' },
// //     { id: 'gas_station', name: 'Petrol Station', icon: '⛽' },
// //     { id: 'airport', name: 'Airport', icon: '✈️' },
// //     { id: 'electric_vehicle_charging_station', name: 'EV Charging', icon: '🔌' },
// //     { id: 'transport', name: 'Transport', icon: '🚆' },
// //     { id: 'park', name: 'Park', icon: '🌳' },
// //     { id: 'gym', name: 'Gym', icon: '💪' },
// //     { id: 'stadium', name: 'Stadium', icon: '🏟️' },
// //     { id: 'museum', name: 'Museum', icon: '🏛️' },
// //     { id: 'art_gallery', name: 'Art Gallery', icon: '🎨' },
// //     { id: 'movie_theater', name: 'Cinema', icon: '🎬' },
// //   ];

// //   const categoryToApiKey = {
// //     school: 'schools',
// //     university: 'university',
// //     library: 'library',
// //     hospital: 'hospitals',
// //     doctor: 'doctor',
// //     pharmacy: 'pharmacies',
// //     restaurant: 'restaurants',
// //     cafe: 'cafe',
// //     bakery: 'bakery',
// //     bar: 'bar',
// //     grocery_or_supermarket: 'grocery_or_supermarket',
// //     supermarket: 'supermarket',
// //     bank: 'banks',
// //     atm: 'atm',
// //     post_office: 'post_office',
// //     gas_station: 'gas_station',
// //     park: 'park',
// //     gym: 'gym',
// //     stadium: 'stadium',
// //     museum: 'museum',
// //     art_gallery: 'art_gallery',
// //     movie_theater: 'movie_theater',
// //     airport: 'airport',
// //     electric_vehicle_charging_station: 'electric_vehicle_charging_station',
// //     transport: 'transports'
// //   };

// //   const transportIcons = {
// //     bikepoint: '🚲', bus: '🚌', dlr: '🚈',
// //     'national-rail': '🚆', overground: '🚇', tube: '🚇',
// //     tram: '🚊', ferry: '⛴️', cable_car: '🚡', default: '📍'
// //   };

// //   // Close compare suggestions when clicking outside
// //   useEffect(() => {
// //     const handleClickOutside = (e) => {
// //       if (compareRef.current && !compareRef.current.contains(e.target)) {
// //         setShowCompareSuggestions(false);
// //       }
// //     };
// //     document.addEventListener('mousedown', handleClickOutside);
// //     return () => document.removeEventListener('mousedown', handleClickOutside);
// //   }, []);

// //   // Fetch main street rating + amenities using street_id
// //   useEffect(() => {
// //     const fetchStreet = async () => {
// //       if (!streetIdFromUrl) {
// //         navigate('/');
// //         return;
// //       }
// //       setLoading(true);
// //       setError(null);

// //       try {
// //         const token = localStorage.getItem('token');
// //         const headers = token ? { Authorization: `Token ${token}` } : {};

// //         // rating-summary expects street_id param (your backend)
// //         const ratingRes = await fetch(
// //           `${BASE_URL}api/streets/rating-summary/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
// //           { headers }
// //         );
// //         if (!ratingRes.ok) throw new Error('Failed to fetch rating summary');
// //         const ratingJson = await ratingRes.json();

// //         // places-by-name supports street_id (preferred)
// //         const placesRes = await fetch(
// //           `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
// //           { headers }
// //         );
// //         if (!placesRes.ok) throw new Error('Failed to fetch amenities');
// //         const placesJson = await placesRes.json();

// //         // Combine and keep rating id too
// //         setStreetData({
// //           id: ratingJson.id ?? streetIdFromUrl,
// //           ...ratingJson,
// //           amenities: placesJson,
// //         });

// //         if (ratingJson.top_3_attributes?.length > 0) {
// //           setActiveCategory(ratingJson.top_3_attributes[0].name);
// //         }
// //       } catch (err) {
// //         console.error(err);
// //         setError(err.message || 'Failed to load street data');
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     // only fetch when user is present (your pattern) — if you want public access, remove user guard
// //     if (user && streetIdFromUrl) fetchStreet();
// //     else setLoading(false);
// //   }, [user, streetIdFromUrl, navigate]);

// //   // Helper: fetch amenities by street id (uses street_id param)
// //   const fetchAmenitiesById = async (id) => {
// //     try {
// //       const token = localStorage.getItem('token');
// //       const headers = token ? { Authorization: `Token ${token}` } : {};
// //       const res = await fetch(
// //         `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(id)}`,
// //         { headers }
// //       );
// //       if (!res.ok) throw new Error('Failed to fetch amenities');
// //       return await res.json();
// //     } catch (err) {
// //       console.error('fetchAmenitiesById error:', err);
// //       return { transports: {}, categories: {} };
// //     }
// //   };

// //   // Helper: search streets for compare suggestions
// //   const searchStreets = async (q) => {
// //     try {
// //       if (!q || !q.trim()) return [];
// //       setCompareLoading(true);
// //       const res = await fetch(`${BASE_URL}api/streets/search-streets/?q=${encodeURIComponent(q.trim())}`);
// //       if (!res.ok) return [];
// //       const data = await res.json(); // expects [{id,name,postcode}, ...]
// //       return Array.isArray(data) ? data : [];
// //     } catch (err) {
// //       console.error('searchStreets error:', err);
// //       return [];
// //     } finally {
// //       setCompareLoading(false);
// //     }
// //   };

// //   // Debounce compare input to fetch suggestions
// //   useEffect(() => {
// //     if (!compareInput) {
// //       setCompareSuggestions([]);
// //       setShowCompareSuggestions(false);
// //       setCompareSelectedId(null);
// //       return;
// //     }
// //     const t = setTimeout(async () => {
// //       const results = await searchStreets(compareInput);
// //       setCompareSuggestions(results);
// //       setShowCompareSuggestions(results.length > 0);
// //     }, 300);
// //     return () => clearTimeout(t);
// //   }, [compareInput]);

// //   // When user clicks a suggestion — set input, set selected id and immediately compare
// //   const handleCompareSuggestionClick = async (suggestion) => {
// //     setCompareInput(suggestion.name);
// //     setCompareSelectedId(suggestion.id);
// //     setShowCompareSuggestions(false);

// //     // trigger compare by id (preferred)
// //     await performCompareByIds(streetData?.id, suggestion.id);
// //   };

// //   // Perform compare with preferred id1/id2. If ids not available, fallback to q1/q2 name based compare
// //   const performCompareByIds = async (id1, id2) => {
// //     if (!id1 || !id2) {
// //       setError('Both street IDs are required for comparison.');
// //       return;
// //     }
// //     setLoading(true);
// //     setError(null);

// //     try {
// //       const token = localStorage.getItem('token');
// //       const headers = token ? { Authorization: `Token ${token}` } : {};

// //       const res = await fetch(`${BASE_URL}api/streets/compare/?id1=${encodeURIComponent(id1)}&id2=${encodeURIComponent(id2)}`, { headers });
// //       if (!res.ok) {
// //         // fallback: if backend returns 404 or bad request, try name-based compare as a last resort
// //         if (res.status === 404) throw new Error('One of the streets was not found for comparison.');
// //         throw new Error('Failed to fetch comparison data');
// //       }
// //       const comp = await res.json();

// //       // fetch amenities for both sides using returned ids (backend returns area1.id/area2.id)
// //       const area1Id = comp?.area1?.id ?? id1;
// //       const area2Id = comp?.area2?.id ?? id2;

// //       const [amen1, amen2] = await Promise.all([fetchAmenitiesById(area1Id), fetchAmenitiesById(area2Id)]);

// //       setComparisonData(comp);
// //       setComparisonAmenities({ area1: amen1, area2: amen2 });
// //       setShowComparison(true);

// //       // scroll to results
// //       window.scrollTo({ top: 0, behavior: 'smooth' });
// //     } catch (err) {
// //       console.error('performCompareByIds error:', err);
// //       setError(err.message || 'Comparison failed');
// //       setShowComparison(false);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   // User pressed Enter in compare input — prefer selectedId, else attempt to find first match and compare by id,
// //   // else fallback to name-based compare using q1/q2 endpoint.
// //   const handleCompareSubmit = async (e) => {
// //     e?.preventDefault?.();
// //     if (!compareInput?.trim()) {
// //       setError('Please enter a street name or pick a suggestion to compare.');
// //       return;
// //     }
// //     setError(null);

// //     if (compareSelectedId) {
// //       return performCompareByIds(streetData?.id, compareSelectedId);
// //     }

// //     // Try to find a suggestion programmatically
// //     const results = await searchStreets(compareInput);
// //     if (results.length > 0) {
// //       return performCompareByIds(streetData?.id, results[0].id);
// //     }

// //     // Last resort: name-based compare (q1/q2) — backend still supports this for backward compat
// //     try {
// //       setLoading(true);
// //       const token = localStorage.getItem('token');
// //       const headers = token ? { Authorization: `Token ${token}` } : {};
// //       const res = await fetch(`${BASE_URL}api/streets/compare/?q1=${encodeURIComponent(streetData.street)}&q2=${encodeURIComponent(compareInput.trim())}`, { headers });
// //       if (!res.ok) {
// //         if (res.status === 404) throw new Error('Comparison street not found');
// //         throw new Error('Comparison failed');
// //       }
// //       const comp = await res.json();
// //       // fetch amenities using area names returned by compare (fallback)
// //       const [amen1, amen2] = await Promise.all([fetchAmenitiesById(comp.area1.id || streetData.id), fetchAmenitiesById(comp.area2.id)]);
// //       setComparisonData(comp);
// //       setComparisonAmenities({ area1: amen1, area2: amen2 });
// //       setShowComparison(true);
// //       window.scrollTo({ top: 0, behavior: 'smooth' });
// //     } catch (err) {
// //       console.error('fallback name compare error:', err);
// //       setError(err.message || 'Comparison failed');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   // Utilities used by UI (counts, ratings, places lists)
// //   const countAmenities = (category) => {
// //     if (!streetData?.amenities) return 0;
// //     if (category === 'transport') {
// //       const transport = streetData.amenities.transports || {};
// //       return Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
// //     }
// //     const apiKey = categoryToApiKey[category];
// //     if (!apiKey) return 0;
// //     return streetData.amenities[apiKey]?.length || 0;
// //   };

// //   const getCategoryRating = (categoryId, data = streetData) => {
// //     if (!data?.attributes || !data.attributes[0]) return 0;
// //     return data.attributes[0][categoryId] || 0;
// //   };

// //   const getNearbyPlaces = (category) => {
// //     if (!streetData?.amenities) return [];
// //     if (category === 'transport') {
// //       const transport = streetData.amenities.transports || {};
// //       return Object.values(transport).flat().slice(0, 5);
// //     }
// //     const apiKey = categoryToApiKey[category];
// //     if (!apiKey) return [];
// //     return streetData.amenities[apiKey]?.slice(0, 5) || [];
// //   };

// //   const getAllPlacesForCategory = (category, streetNameParam) => {
// //     // If streetNameParam === streetData.street => return from streetData
// //     if (!streetNameParam) return [];
// //     if (streetNameParam === streetData?.street) {
// //       if (category === 'transport') {
// //         const transport = streetData.amenities?.transports || {};
// //         return Object.values(transport).flat();
// //       }
// //       const apiKey = categoryToApiKey[category];
// //       if (!apiKey) return [];
// //       return streetData.amenities?.[apiKey] || [];
// //     }

// //     // If comparisonAmenities present, pick the correct one
// //     if (comparisonAmenities) {
// //       const amenities = streetNameParam === comparisonData?.area1.street ? comparisonAmenities.area1 : comparisonAmenities.area2;
// //       if (category === 'transport') {
// //         const transport = amenities?.transports || {};
// //         return Object.values(transport).flat();
// //       }
// //       const apiKey = categoryToApiKey[category];
// //       if (!apiKey) return [];
// //       return amenities?.[apiKey] || [];
// //     }

// //     return [];
// //   };

// //   // Modals and UI helpers
// //   const openCategoryModal = (category, streetName = '') => {
// //     setModalCategory(category);
// //     setModalStreetName(streetName || streetData?.street || '');
// //     setIsCategoryModalOpen(true);
// //   };

// //   const closeCategoryModal = () => {
// //     setIsCategoryModalOpen(false);
// //     setModalCategory(null);
// //   };

// //   useEffect(() => {
// //     if (isCategoryModalOpen) document.body.classList.add('modal-open');
// //     else document.body.classList.remove('modal-open');
// //     return () => document.body.classList.remove('modal-open');
// //   }, [isCategoryModalOpen]);

// //   useEffect(() => {
// //     if (showComparison) window.scrollTo({ top: 0, behavior: 'smooth' });
// //   }, [showComparison]);

// //   function getScoreClass(score) {
// //     if (score < 8) return 'low';
// //     if (score < 9) return 'medium';
// //     return 'high';
// //   }

// //   // UI components: PlaceItem, StreetDetailCard, modal renderer
// //   const PlaceItem = ({ place, category }) => (
// //     <div className="place-item">
// //       <div className="place-name">
// //         {category === 'transport' && place.stop_type && (
// //           <span className="transport-icon">{transportIcons[place.stop_type] || transportIcons.default}</span>
// //         )}
// //         {place.name}
// //       </div>
// //       {place.final_rating && <div className="place-rating">Rating: {place.final_rating}</div>}
// //       {place.latitude && place.longitude && (
// //         <a href={`https://maps.google.com/?q=${place.latitude},${place.longitude}`} target="_blank" rel="noopener noreferrer" className="map-link">View on Map</a>
// //       )}
// //     </div>
// //   );

// //   const StreetDetailCard = ({ street, amenities, overallScore, top3 }) => {
// //     const streetNameShort = (typeof street === 'string') ? street.split(',')[0] : '';
// //     const postcode = amenities?.street?.postcode || 'London';

// //     const totalAmenities = Object.keys(amenities || {})
// //       .filter(key => key !== 'street')
// //       .reduce((total, key) => {
// //         if (key === 'transports') {
// //           const transport = amenities.transports || {};
// //           return total + Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
// //         }
// //         return total + (amenities[key]?.length || 0);
// //       }, 0);

// //     return (
// //       <div className="street-detail-card">
// //         <div className="location-info">
// //           <h2>{streetNameShort}</h2>
// //           <p>{postcode}</p>
// //         </div>

// //         <div className="scores-container">
// //           <div className="score-item main-score">
// //             <div className="score-value">{overallScore}/100</div>
// //             <div className="score-label">Lifestyle Score</div>
// //           </div>
// //         </div>

// //         <div className="top-3-inline">
// //           <h3 className="subsection-title">Top 3 Amenity Categories</h3>
// //           <ul className="top3-list">
// //             {(top3 || []).map((attr, i) => {
// //               const key = attr.name.toLowerCase();
// //               const cat = amenityCategories.find(c => c.id === key);
// //               const icon = cat ? cat.icon : '📍';
// //               const label = cat ? cat.name : attr.name;
// //               const score = +attr.score.toFixed(1);
// //               const pct = (score / 10) * 100;
// //               const cls = getScoreClass(score);

// //               return (
// //                 <li key={i} className="top3-item" style={{ '--i': i }}>
// //                   <span className="top3-icon">{icon}</span>
// //                   <span className="top3-label">{label}</span>
// //                   <div className="top3-bar">
// //                     <div className={`top3-fill ${cls}`} style={{ width: `${pct}%` }} />
// //                   </div>
// //                   <span className="top3-score">{score}/10</span>
// //                 </li>
// //               );
// //             })}
// //           </ul>
// //         </div>

// //         <div className="stats-container">
// //           <div className="stat-item">
// //             <div className="stat-value">{totalAmenities}</div>
// //             <div className="stat-label">Total Amenities</div>
// //           </div>
// //         </div>
// //       </div>
// //     );
// //   };

// //   const renderModal = () => {
// //     if (!isCategoryModalOpen || !modalCategory) return null;

// //     return ReactDOM.createPortal(
// //       <div className="modal-overlay" onClick={closeCategoryModal}>
// //         <div className="places-modal compare" onClick={(e) => e.stopPropagation()}>
// //           <div className="modal-header">
// //             <h3>{amenityCategories.find(cat => cat.id === modalCategory)?.name || modalCategory}<span className="modal-street-name"> Comparison</span></h3>
// //             <button className="close-detail" onClick={closeCategoryModal} aria-label="Close">×</button>
// //           </div>

// //           <div className="modal-stats">
// //             <div className="stat-group">
// //               <div className="stat-label">Performance Score</div>
// //               <div className="stat-value">{getCategoryRating(modalCategory).toFixed(1)}/10</div>
// //             </div>
// //           </div>

// //           <div className="modal-content compare">
// //             <div className="modal-column">
// //               <h4>{streetData?.street?.split(',')[0]}</h4>
// //               <div className="places-scrollable">
// //                 {getAllPlacesForCategory(modalCategory, streetData?.street).map((place, index) => (
// //                   <PlaceItem key={index} place={place} category={modalCategory} />
// //                 ))}
// //               </div>
// //             </div>

// //             {showComparison && comparisonData && (
// //               <div className="modal-column">
// //                 <h4>{comparisonData.area2.street.split(',')[0]}</h4>
// //                 <div className="places-scrollable">
// //                   {getAllPlacesForCategory(modalCategory, comparisonData.area2.street).map((place, index) => (
// //                     <PlaceItem key={index} place={place} category={modalCategory} />
// //                   ))}
// //                 </div>
// //               </div>
// //             )}
// //           </div>
// //         </div>
// //       </div>,
// //       document.body
// //     );
// //   };

// //   // Loading & error handling
// //   if (loading) {
// //     return (
// //       <div className="loading-container">
// //         <div className="loading-spinner" />
// //         <p>Loading street data...</p>
// //       </div>
// //     );
// //   }

// //   if (error) {
// //     return <ErrorComponent error={error} onRetry={() => { setError(null); setLoading(true); }} />;
// //   }

// //   if (!streetData) {
// //     return <ErrorComponent error="No Data Available" onRetry={() => { setError(null); setLoading(true); }} />;
// //   }

// //   // Main render
// //   return (
// //     <>
// //       {!isCategoryModalOpen && (
// //         <div className="analysis-container">
// //           <header className="analysis-header">
// //             <button onClick={() => {
// //               if (showComparison) {
// //                 setShowComparison(false);
// //                 navigate(`/analysis?street_id=${encodeURIComponent(streetData.id)}`, { replace: true });
// //               } else {
// //                 navigate(-1);
// //               }
// //             }} className="back-button">← Back</button>
// //           </header>

// //           <section className={`detailed-analysis-compare ${showComparison ? 'two-cards' : ''}`}>
// //             <StreetDetailCard
// //               street={streetData.street}
// //               amenities={streetData.amenities}
// //               overallScore={streetData.overall_score}
// //               top3={streetData.top_3_attributes}
// //             />

// //             {showComparison && comparisonData && (
// //               <StreetDetailCard
// //                 street={comparisonData.area2.street}
// //                 amenities={comparisonAmenities?.area2}
// //                 overallScore={comparisonData.area2.overall_score}
// //                 top3={comparisonData.area2.top_3_attributes}
// //               />
// //             )}
// //           </section>

// //           <section className="compare-area">
// //             <h2 className="section-title">Compare with Another Area</h2>
// //             <div className="compare-card">
// //               <div className="input-group" ref={compareRef} style={{ position: 'relative' }}>
// //                 <input
// //                   type="text"
// //                   placeholder="Enter street name"
// //                   className="compare-input"
// //                   value={compareInput}
// //                   onChange={(e) => {
// //                     setCompareInput(e.target.value);
// //                     setCompareSelectedId(null);
// //                     setShowCompareSuggestions(true);
// //                     setError(null);
// //                   }}
// //                   onKeyDown={(e) => {
// //                     if (e.key === 'Enter') handleCompareSubmit(e);
// //                     if (e.key === 'Escape') {
// //                       setShowCompareSuggestions(false);
// //                     }
// //                   }}
// //                 />
// //                 <button className="compare-button" onClick={handleCompareSubmit}>Compare Areas</button>

// //                 {/* Suggestions dropdown */}
// //                 {showCompareSuggestions && compareSuggestions.length > 0 && (
// //                   <div className="suggestions-dropdown compare-suggestions">
// //                     {compareSuggestions.map(s => (
// //                       <div key={s.id} className="suggestion-item" onClick={() => handleCompareSuggestionClick(s)}>
// //                         <div className="suggestion-name">{s.name}</div>
// //                         <div className="suggestion-postcode">{s.postcode}</div>
// //                       </div>
// //                     ))}
// //                   </div>
// //                 )}
// //               </div>

// //               <p className="compare-description">Compare {streetData.street.split(',')[0]} with any other area to see side-by-side amenity analysis</p>
// //             </div>
// //           </section>

// //           {showComparison && comparisonData && (
// //             <>
// //               <section className="comparison-results">
// //                 <h2 className="section-title">Comparison Results</h2>

// //                 <div className="attribute-comparison">
// //                   <h3>Attribute Scores</h3>
// //                   <div className="attribute-grid">
// //                     {Object.entries(comparisonData.area1.attributes).map(([attr, score]) => (
// //                       <div key={attr} className="attribute-item">
// //                         <div className="attribute-name">{amenityCategories.find(c => c.id === attr)?.name || attr}</div>
// //                         <div className="attribute-scores">
// //                           <span className="score1">{score}</span>
// //                           <span className="score-divider">:</span>
// //                           <span className="score2">{comparisonData.area2.attributes[attr]}</span>
// //                         </div>
// //                       </div>
// //                     ))}
// //                   </div>
// //                 </div>

// //                 <button className="close-comparison" onClick={() => setShowComparison(false)}>Close Comparison</button>
// //               </section>

// //               <section className="amenity-comparison-container">
// //                 <h2 className="section-title comparison-title">Amenity Comparison</h2>
// //                 <div className="categories-grid comparison">
// //                   {amenityCategories.map(category => {
// //                     const street1Count = countAmenities(category.id);
// //                     const street1Score = getCategoryRating(category.id);
// //                     const street2Count = comparisonData.area2.category_counts[category.id] || 0;
// //                     const street2Score = comparisonData.area2.attributes[category.id] || 0;

// //                     if (street1Count === 0 && street2Count === 0) return null;

// //                     return (
// //                       <div key={category.id} className="category-card comparison" onClick={() => openCategoryModal(category.id)}>
// //                         <div className="category-header">
// //                           <div className="category-icon">{category.icon}</div>
// //                           <h3 className="category-name">{category.name}</h3>
// //                         </div>

// //                         <div className="street-comparison">
// //                           <div className="street-row">
// //                             <div className="street-name">{comparisonData.area1.street.split(',')[0]}</div>
// //                             <div className="score-display">
// //                               <div className="street-score">{street1Score.toFixed(1)}/10</div>
// //                               <div className="street-count">({street1Count} locations)</div>
// //                             </div>
// //                           </div>

// //                           <div className="street-row">
// //                             <div className="street-name">{comparisonData.area2.street.split(',')[0]}</div>
// //                             <div className="score-display">
// //                               <div className="street-score">{street2Score.toFixed(1)}/10</div>
// //                               <div className="street-count">({street2Count} locations)</div>
// //                             </div>
// //                           </div>
// //                         </div>
// //                       </div>
// //                     );
// //                   })}
// //                 </div>
// //               </section>
// //             </>
// //           )}

// //           {!showComparison && (
// //             <section className="amenity-categories">
// //               <h2 className="section-title">All Amenity Categories</h2>
// //               <div className="categories-grid">
// //                 {amenityCategories.map(category => {
// //                   const count = countAmenities(category.id);
// //                   if (count === 0) return null;
// //                   const score = getCategoryRating(category.id);

// //                   return (
// //                     <div key={category.id} className="category-card" onClick={() => openCategoryModal(category.id)}>
// //                       <div className="category-header">
// //                         <div className="category-icon">{category.icon}</div>
// //                         <h3 className="category-name">{category.name}</h3>
// //                       </div>
// //                       <div className="street-row">
// //                         <div className="score-display">
// //                           <div className="street-score">{score.toFixed(1)}/10</div>
// //                           <div className="street-count">({count} {count === 1 ? 'location' : 'locations'})</div>
// //                         </div>
// //                       </div>
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             </section>
// //           )}

// //           <section className="recommendations">
// //             <h2 className="section-title">Area Insights & Recommendations</h2>
// //             <h3 className="subsection-title">Best Suited For</h3>

// //             <div className="recommendation-cards">
// //               <div className="recommendation-card">
// //                 <div className="card-icon">🚆</div>
// //                 <h4>Excellent for Commuters</h4>
// //                 <p>AI-generated insights coming soon</p>
// //               </div>

// //               <div className="recommendation-card">
// //                 <div className="card-icon">🍽️</div>
// //                 <h4>Food & Entertainment Hub</h4>
// //                 <p>AI-generated insights coming soon</p>
// //               </div>

// //               <div className="recommendation-card">
// //                 <div className="card-icon">🛍️</div>
// //                 <h4>Shopping Destination</h4>
// //                 <p>AI-generated insights coming soon</p>
// //               </div>
// //             </div>
// //           </section>
// //         </div>
// //       )}
// //       {renderModal()}
// //     </>
// //   );
// // };

// // export default StreetAnalysis;

















// // import React, { useState, useEffect, useRef } from 'react';
// // import { useLocation, useNavigate } from 'react-router-dom';
// // import { useAuth } from '../context/AuthContext';
// // import './AnalysisPage.css';
// // import { BASE_URL } from '../constants';
// // import ReactDOM from 'react-dom';
// // import ErrorComponent from '../components/ErrorComponent';

// // const StreetAnalysis = () => {
// //   useEffect(() => { window.scrollTo(0, 0); }, []);

// //   const navigate = useNavigate();
// //   const location = useLocation();
// //   const { user } = useAuth();

// //   // Primary data
// //   const [streetData, setStreetData] = useState(null);
// //   const [loading, setLoading] = useState(true);
// //   const [error, setError] = useState(null);

// //   // UI / comparison state
// //   const [activeCategory, setActiveCategory] = useState(null);
// //   const [compareInput, setCompareInput] = useState('');
// //   const [compareSuggestions, setCompareSuggestions] = useState([]);
// //   const [showCompareSuggestions, setShowCompareSuggestions] = useState(false);
// //   const [compareLoading, setCompareLoading] = useState(false);
// //   const [compareSelectedId, setCompareSelectedId] = useState(null); // id selected from suggestions
// //   const [comparisonData, setComparisonData] = useState(null);
// //   const [comparisonAmenities, setComparisonAmenities] = useState(null);
// //   const [showComparison, setShowComparison] = useState(false);

// //   // modal state
// //   const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
// //   const [modalCategory, setModalCategory] = useState(null);
// //   const [modalStreetName, setModalStreetName] = useState('');

// //   const compareRef = useRef(null); // to close suggestions on outside click

// //   // accept both 'street_id' and 'id' query params for compatibility
// //   const queryParams = new URLSearchParams(location.search);
// //   const streetIdFromUrl = queryParams.get('street_id') || queryParams.get('id') || null;

// //   const BAR_COLORS = {
// //     Education: '#34D169',
// //     Transport: '#3B82F6',
// //     'Parks & Recreation': '#F59E0B',
// //   };

// //   const amenityCategories = [
// //     { id: 'school', name: 'School', icon: '🏫' },
// //     { id: 'university', name: 'University', icon: '🎓' },
// //     { id: 'library', name: 'Library', icon: '📚' },
// //     { id: 'hospital', name: 'Hospital', icon: '🏥' },
// //     { id: 'doctor', name: 'Doctor', icon: '👨‍⚕️' },
// //     { id: 'pharmacy', name: 'Pharmacy', icon: '💊' },
// //     { id: 'restaurant', name: 'Restaurant', icon: '🍽️' },
// //     { id: 'cafe', name: 'Café', icon: '☕' },
// //     { id: 'bakery', name: 'Bakery', icon: '🥐' },
// //     { id: 'bar', name: 'Bar', icon: '🍻' },
// //     { id: 'grocery_or_supermarket', name: 'Grocery Store', icon: '🛒' },
// //     { id: 'supermarket', name: 'Supermarket', icon: '🛍️' },
// //     { id: 'bank', name: 'Bank', icon: '🏦' },
// //     { id: 'atm', name: 'ATM', icon: '💳' },
// //     { id: 'post_office', name: 'Post Office', icon: '📮' },
// //     { id: 'gas_station', name: 'Petrol Station', icon: '⛽' },
// //     { id: 'airport', name: 'Airport', icon: '✈️' },
// //     { id: 'electric_vehicle_charging_station', name: 'EV Charging', icon: '🔌' },
// //     { id: 'transport', name: 'Transport', icon: '🚆' },
// //     { id: 'park', name: 'Park', icon: '🌳' },
// //     { id: 'gym', name: 'Gym', icon: '💪' },
// //     { id: 'stadium', name: 'Stadium', icon: '🏟️' },
// //     { id: 'museum', name: 'Museum', icon: '🏛️' },
// //     { id: 'art_gallery', name: 'Art Gallery', icon: '🎨' },
// //     { id: 'movie_theater', name: 'Cinema', icon: '🎬' },
// //   ];

// //   const categoryToApiKey = {
// //     school: 'schools',
// //     university: 'university',
// //     library: 'library',
// //     hospital: 'hospitals',
// //     doctor: 'doctor',
// //     pharmacy: 'pharmacies',
// //     restaurant: 'restaurants',
// //     cafe: 'cafe',
// //     bakery: 'bakery',
// //     bar: 'bar',
// //     grocery_or_supermarket: 'grocery_or_supermarket',
// //     supermarket: 'supermarket',
// //     bank: 'banks',
// //     atm: 'atm',
// //     post_office: 'post_office',
// //     gas_station: 'gas_station',
// //     park: 'park',
// //     gym: 'gym',
// //     stadium: 'stadium',
// //     museum: 'museum',
// //     art_gallery: 'art_gallery',
// //     movie_theater: 'movie_theater',
// //     airport: 'airport',
// //     electric_vehicle_charging_station: 'electric_vehicle_charging_station',
// //     transport: 'transports'
// //   };

// //   const transportIcons = {
// //     bikepoint: '🚲', bus: '🚌', dlr: '🚈',
// //     'national-rail': '🚆', overground: '🚇', tube: '🚇',
// //     tram: '🚊', ferry: '⛴️', cable_car: '🚡', default: '📍'
// //   };

// //   // Close compare suggestions when clicking outside
// //   useEffect(() => {
// //     const handleClickOutside = (e) => {
// //       if (compareRef.current && !compareRef.current.contains(e.target)) {
// //         setShowCompareSuggestions(false);
// //       }
// //     };
// //     document.addEventListener('mousedown', handleClickOutside);
// //     return () => document.removeEventListener('mousedown', handleClickOutside);
// //   }, []);

// //   // Fetch main street rating + amenities using street_id
// //   useEffect(() => {
// //     const fetchStreet = async () => {
// //       if (!streetIdFromUrl) {
// //         navigate('/');
// //         return;
// //       }
// //       setLoading(true);
// //       setError(null);

// //       try {
// //         const token = localStorage.getItem('token');
// //         const headers = token ? { Authorization: `Token ${token}` } : {};

// //         // rating-summary expects street_id param (your backend)
// //         const ratingRes = await fetch(
// //           `${BASE_URL}api/streets/rating-summary/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
// //           { headers }
// //         );
// //         if (!ratingRes.ok) throw new Error('Failed to fetch rating summary');
// //         const ratingJson = await ratingRes.json();

// //         // places-by-name supports street_id (preferred)
// //         const placesRes = await fetch(
// //           `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
// //           { headers }
// //         );
// //         if (!placesRes.ok) throw new Error('Failed to fetch amenities');
// //         const placesJson = await placesRes.json();

// //         // Combine and keep rating id too
// //         setStreetData({
// //           id: ratingJson.id ?? streetIdFromUrl,
// //           ...ratingJson,
// //           amenities: placesJson,
// //         });

// //         if (ratingJson.top_3_attributes?.length > 0) {
// //           setActiveCategory(ratingJson.top_3_attributes[0].name);
// //         }
// //       } catch (err) {
// //         console.error(err);
// //         setError(err.message || 'Failed to load street data');
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     // only fetch when user is present (your pattern) — if you want public access, remove user guard
// //     if (user && streetIdFromUrl) fetchStreet();
// //     else setLoading(false);
// //   }, [user, streetIdFromUrl, navigate]);

// //   // Helper: fetch amenities by street id (uses street_id param)
// //   const fetchAmenitiesById = async (id) => {
// //     try {
// //       const token = localStorage.getItem('token');
// //       const headers = token ? { Authorization: `Token ${token}` } : {};
// //       const res = await fetch(
// //         `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(id)}`,
// //         { headers }
// //       );
// //       if (!res.ok) throw new Error('Failed to fetch amenities');
// //       return await res.json();
// //     } catch (err) {
// //       console.error('fetchAmenitiesById error:', err);
// //       return { transports: {}, categories: {} };
// //     }
// //   };

// //   // Helper: search streets for compare suggestions
// //   const searchStreets = async (q) => {
// //     try {
// //       if (!q || !q.trim()) return [];
// //       setCompareLoading(true);
// //       const res = await fetch(`${BASE_URL}api/streets/search-streets/?q=${encodeURIComponent(q.trim())}`);
// //       if (!res.ok) return [];
// //       const data = await res.json(); // expects [{id,name,postcode}, ...]
// //       return Array.isArray(data) ? data : [];
// //     } catch (err) {
// //       console.error('searchStreets error:', err);
// //       return [];
// //     } finally {
// //       setCompareLoading(false);
// //     }
// //   };

// //   // Debounce compare input to fetch suggestions
// //   useEffect(() => {
// //     if (!compareInput) {
// //       setCompareSuggestions([]);
// //       setShowCompareSuggestions(false);
// //       setCompareSelectedId(null);
// //       return;
// //     }
// //     const t = setTimeout(async () => {
// //       const results = await searchStreets(compareInput);
// //       setCompareSuggestions(results);
// //       setShowCompareSuggestions(results.length > 0);
// //     }, 300);
// //     return () => clearTimeout(t);
// //   }, [compareInput]);

// //   // When user clicks a suggestion — set input, set selected id and immediately compare
// //   const handleCompareSuggestionClick = async (suggestion) => {
// //     setCompareInput(suggestion.name);
// //     setCompareSelectedId(suggestion.id);
// //     setShowCompareSuggestions(false);

// //     // trigger compare by id (preferred)
// //     await performCompareByIds(streetData?.id, suggestion.id);
// //   };

// //   // Perform compare with preferred id1/id2. If ids not available, fallback to q1/q2 name based compare
// //   const performCompareByIds = async (id1, id2) => {
// //     if (!id1 || !id2) {
// //       setError('Both street IDs are required for comparison.');
// //       return;
// //     }
// //     setLoading(true);
// //     setError(null);

// //     try {
// //       const token = localStorage.getItem('token');
// //       const headers = token ? { Authorization: `Token ${token}` } : {};

// //       const res = await fetch(`${BASE_URL}api/streets/compare/?id1=${encodeURIComponent(id1)}&id2=${encodeURIComponent(id2)}`, { headers });
// //       if (!res.ok) {
// //         // fallback: if backend returns 404 or bad request, try name-based compare as a last resort
// //         if (res.status === 404) throw new Error('One of the streets was not found for comparison.');
// //         throw new Error('Failed to fetch comparison data');
// //       }
// //       const comp = await res.json();

// //       // fetch amenities for both sides using returned ids (backend returns area1.id/area2.id)
// //       const area1Id = comp?.area1?.id ?? id1;
// //       const area2Id = comp?.area2?.id ?? id2;

// //       const [amen1, amen2] = await Promise.all([fetchAmenitiesById(area1Id), fetchAmenitiesById(area2Id)]);

// //       setComparisonData(comp);
// //       setComparisonAmenities({ area1: amen1, area2: amen2 });
// //       setShowComparison(true);

// //       // scroll to results
// //       window.scrollTo({ top: 0, behavior: 'smooth' });
// //     } catch (err) {
// //       console.error('performCompareByIds error:', err);
// //       setError(err.message || 'Comparison failed');
// //       setShowComparison(false);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   // User pressed Enter in compare input — prefer selectedId, else attempt to find first match and compare by id,
// //   // else fallback to name-based compare using q1/q2 endpoint.
// //   const handleCompareSubmit = async (e) => {
// //     e?.preventDefault?.();
// //     if (!compareInput?.trim()) {
// //       setError('Please enter a street name or pick a suggestion to compare.');
// //       return;
// //     }
// //     setError(null);

// //     if (compareSelectedId) {
// //       return performCompareByIds(streetData?.id, compareSelectedId);
// //     }

// //     // Try to find a suggestion programmatically
// //     const results = await searchStreets(compareInput);
// //     if (results.length > 0) {
// //       return performCompareByIds(streetData?.id, results[0].id);
// //     }

// //     // Last resort: name-based compare (q1/q2) — backend still supports this for backward compat
// //     try {
// //       setLoading(true);
// //       const token = localStorage.getItem('token');
// //       const headers = token ? { Authorization: `Token ${token}` } : {};
// //       const res = await fetch(`${BASE_URL}api/streets/compare/?q1=${encodeURIComponent(streetData.street)}&q2=${encodeURIComponent(compareInput.trim())}`, { headers });
// //       if (!res.ok) {
// //         if (res.status === 404) throw new Error('Comparison street not found');
// //         throw new Error('Comparison failed');
// //       }
// //       const comp = await res.json();
// //       // fetch amenities using area names returned by compare (fallback)
// //       const [amen1, amen2] = await Promise.all([fetchAmenitiesById(comp.area1.id || streetData.id), fetchAmenitiesById(comp.area2.id)]);
// //       setComparisonData(comp);
// //       setComparisonAmenities({ area1: amen1, area2: amen2 });
// //       setShowComparison(true);
// //       window.scrollTo({ top: 0, behavior: 'smooth' });
// //     } catch (err) {
// //       console.error('fallback name compare error:', err);
// //       setError(err.message || 'Comparison failed');
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   // Utilities used by UI (counts, ratings, places lists)
// //   const countAmenities = (category) => {
// //     if (!streetData?.amenities) return 0;
// //     if (category === 'transport') {
// //       const transport = streetData.amenities.transports || {};
// //       return Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
// //     }
// //     const apiKey = categoryToApiKey[category];
// //     if (!apiKey) return 0;
// //     return streetData.amenities[apiKey]?.length || 0;
// //   };

// //   const getCategoryRating = (categoryId, data = streetData) => {
// //     if (!data?.attributes || !data.attributes[0]) return 0;
// //     return data.attributes[0][categoryId] || 0;
// //   };

// //   const getNearbyPlaces = (category) => {
// //     if (!streetData?.amenities) return [];
// //     if (category === 'transport') {
// //       const transport = streetData.amenities.transports || {};
// //       return Object.values(transport).flat().slice(0, 5);
// //     }
// //     const apiKey = categoryToApiKey[category];
// //     if (!apiKey) return [];
// //     return streetData.amenities[apiKey]?.slice(0, 5) || [];
// //   };

// //   const getAllPlacesForCategory = (category, streetNameParam) => {
// //     // If streetNameParam === streetData.street => return from streetData
// //     if (!streetNameParam) return [];
// //     if (streetNameParam === streetData?.street) {
// //       if (category === 'transport') {
// //         const transport = streetData.amenities?.transports || {};
// //         return Object.values(transport).flat();
// //       }
// //       const apiKey = categoryToApiKey[category];
// //       if (!apiKey) return [];
// //       return streetData.amenities?.[apiKey] || [];
// //     }

// //     // If comparisonAmenities present, pick the correct one
// //     if (comparisonAmenities) {
// //       const amenities = streetNameParam === comparisonData?.area1.street ? comparisonAmenities.area1 : comparisonAmenities.area2;
// //       if (category === 'transport') {
// //         const transport = amenities?.transports || {};
// //         return Object.values(transport).flat();
// //       }
// //       const apiKey = categoryToApiKey[category];
// //       if (!apiKey) return [];
// //       return amenities?.[apiKey] || [];
// //     }

// //     return [];
// //   };

// //   // Modals and UI helpers
// //   const openCategoryModal = (category, streetName = '') => {
// //     setModalCategory(category);
// //     setModalStreetName(streetName || streetData?.street || '');
// //     setIsCategoryModalOpen(true);
// //   };

// //   const closeCategoryModal = () => {
// //     setIsCategoryModalOpen(false);
// //     setModalCategory(null);
// //   };

// //   useEffect(() => {
// //     if (isCategoryModalOpen) document.body.classList.add('modal-open');
// //     else document.body.classList.remove('modal-open');
// //     return () => document.body.classList.remove('modal-open');
// //   }, [isCategoryModalOpen]);

// //   useEffect(() => {
// //     if (showComparison) window.scrollTo({ top: 0, behavior: 'smooth' });
// //   }, [showComparison]);

// //   function getScoreClass(score) {
// //     if (score < 8) return 'low';
// //     if (score < 9) return 'medium';
// //     return 'high';
// //   }

// //   // UI components: PlaceItem, StreetDetailCard, modal renderer
// //   const PlaceItem = ({ place, category }) => (
// //     <div className="place-item">
// //       <div className="place-name">
// //         {category === 'transport' && place.stop_type && (
// //           <span className="transport-icon">{transportIcons[place.stop_type] || transportIcons.default}</span>
// //         )}
// //         {place.name}
// //       </div>
// //       {place.final_rating && <div className="place-rating">Rating: {place.final_rating}</div>}
// //       {place.latitude && place.longitude && (
// //         <a href={`https://maps.google.com/?q=${place.latitude},${place.longitude}`} target="_blank" rel="noopener noreferrer" className="map-link">View on Map</a>
// //       )}
// //     </div>
// //   );

// //   const StreetDetailCard = ({ street, amenities, overallScore, top3, streetType = 'primary' }) => {
// //     const streetNameShort = (typeof street === 'string') ? street.split(',')[0] : '';
// //     const postcode = amenities?.street?.postcode || 'London';

// //     const totalAmenities = Object.keys(amenities || {})
// //       .filter(key => key !== 'street')
// //       .reduce((total, key) => {
// //         if (key === 'transports') {
// //           const transport = amenities.transports || {};
// //           return total + Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
// //         }
// //         return total + (amenities[key]?.length || 0);
// //       }, 0);

// //     // Determine CSS class based on streetType
// //     const streetColorClass = streetType === 'primary' ? 'primary-street' : 'comparison-street';

// //     return (
// //       <div className="street-detail-card">
// //         <div className="location-info">
// //           <h2 className={streetColorClass}>{streetNameShort}</h2> {/* Add color class here */}
// //           <p>{postcode}</p>
// //         </div>

// //         <div className="scores-container">
// //           <div className="score-item main-score">
// //             <div className={`score-value ${streetColorClass}`}>{overallScore}/100</div> {/* Add color class here */}
// //             <div className="score-label">Lifestyle Score</div>
// //           </div>
// //         </div>

// //         <div className="top-3-inline">
// //           <h3 className="subsection-title">Top 3 Amenity Categories</h3>
// //           <ul className="top3-list">
// //             {(top3 || []).map((attr, i) => {
// //               const key = attr.name.toLowerCase();
// //               const cat = amenityCategories.find(c => c.id === key);
// //               const icon = cat ? cat.icon : '📍';
// //               const label = cat ? cat.name : attr.name;
// //               const score = +attr.score.toFixed(1);
// //               const pct = (score / 10) * 100;
// //               const cls = getScoreClass(score);

// //               return (
// //                 <li key={i} className="top3-item" style={{ '--i': i }}>
// //                   <span className="top3-icon">{icon}</span>
// //                   <span className="top3-label">{label}</span>
// //                   <div className="top3-bar">
// //                     <div className={`top3-fill ${cls}`} style={{ width: `${pct}%` }} />
// //                   </div>
// //                   <span className="top3-score">{score}/10</span>
// //                 </li>
// //               );
// //             })}
// //           </ul>
// //         </div>

// //         <div className="stats-container">
// //           <div className="stat-item">
// //             <div className="stat-value">{totalAmenities}</div>
// //             <div className="stat-label">Total Amenities</div>
// //           </div>
// //         </div>
// //       </div>
// //     );
// //   };

// //   const renderModal = () => {
// //     if (!isCategoryModalOpen || !modalCategory) return null;

// //     return ReactDOM.createPortal(
// //       <div className="modal-overlay" onClick={closeCategoryModal}>
// //         <div className="places-modal compare" onClick={(e) => e.stopPropagation()}>
// //           <div className="modal-header">
// //             <h3>{amenityCategories.find(cat => cat.id === modalCategory)?.name || modalCategory}</h3>
// //             {/* <div className="modal-subtitle">
// //               <span className={`modal-street-name primary-street`}>{streetData?.street?.split(',')[0]}</span>
// //               {showComparison && comparisonData && (
// //                 <>
// //                   <span className="modal-vs"> vs </span>
// //                   <span className={`modal-street-name comparison-street`}>{comparisonData.area2.street.split(',')[0]}</span>
// //                 </>
// //               )}
// //             </div> */}
// //             <button className="close-detail" onClick={closeCategoryModal} aria-label="Close">×</button>
// //           </div>

// //           <div className="modal-stats">
// //             <div className="stat-group">
// //               <div className="stat-label">Performance Score</div>
// //               <div className="stat-value">{getCategoryRating(modalCategory).toFixed(1)}/10</div>
// //             </div>
// //           </div>

// //           <div className="modal-content compare">
// //             <div className="modal-column">
// //               <h4 className="primary-street">{streetData?.street?.split(',')[0]}</h4>
// //               <div className="places-scrollable">
// //                 {getAllPlacesForCategory(modalCategory, streetData?.street).map((place, index) => (
// //                   <PlaceItem key={index} place={place} category={modalCategory} />
// //                 ))}
// //               </div>
// //             </div>

// //             {showComparison && comparisonData && (
// //               <div className="modal-column">
// //                 <h4 className="comparison-street">{comparisonData.area2.street.split(',')[0]}</h4>
// //                 <div className="places-scrollable">
// //                   {getAllPlacesForCategory(modalCategory, comparisonData.area2.street).map((place, index) => (
// //                     <PlaceItem key={index} place={place} category={modalCategory} />
// //                   ))}
// //                 </div>
// //               </div>
// //             )}
// //           </div>
// //         </div>
// //       </div>,
// //       document.body
// //     );
// //   };

// //   // Loading & error handling
// //   if (loading) {
// //     return (
// //       <div className="loading-container">
// //         <div className="loading-spinner" />
// //         <p>Loading street data...</p>
// //       </div>
// //     );
// //   }

// //   if (error) {
// //     return <ErrorComponent error={error} onRetry={() => { setError(null); setLoading(true); }} />;
// //   }

// //   if (!streetData) {
// //     return <ErrorComponent error="No Data Available" onRetry={() => { setError(null); setLoading(true); }} />;
// //   }

// //   // Main render
// //   return (
// //     <>
// //       {!isCategoryModalOpen && (
// //         <div className="analysis-container">
// //           <header className="analysis-header">
// //             <button onClick={() => {
// //               if (showComparison) {
// //                 setShowComparison(false);
// //                 navigate(`/analysis?street_id=${encodeURIComponent(streetData.id)}`, { replace: true });
// //               } else {
// //                 navigate(-1);
// //               }
// //             }} className="back-button">← Back</button>
// //           </header>

// //           <section className={`detailed-analysis-compare ${showComparison ? 'two-cards' : ''}`}>
// //             <StreetDetailCard
// //               street={streetData.street}
// //               amenities={streetData.amenities}
// //               overallScore={streetData.overall_score}
// //               top3={streetData.top_3_attributes}
// //               streetType="primary" // This makes it blue
// //             />

// //             {showComparison && comparisonData && (
// //               <StreetDetailCard
// //                 street={comparisonData.area2.street}
// //                 amenities={comparisonAmenities?.area2}
// //                 overallScore={comparisonData.area2.overall_score}
// //                 top3={comparisonData.area2.top_3_attributes}
// //                 streetType="comparison" // This makes it green
// //               />
// //             )}
// //           </section>

// //           <section className="compare-area">
// //             <h2 className="section-title">Compare with Another Area</h2>
// //             <div className="compare-card">
// //               <div className="input-group" ref={compareRef} style={{ position: 'relative' }}>
// //                 <input
// //                   type="text"
// //                   placeholder="Enter street name"
// //                   className="compare-input"
// //                   value={compareInput}
// //                   onChange={(e) => {
// //                     setCompareInput(e.target.value);
// //                     setCompareSelectedId(null);
// //                     setShowCompareSuggestions(true);
// //                     setError(null);
// //                   }}
// //                   onKeyDown={(e) => {
// //                     if (e.key === 'Enter') handleCompareSubmit(e);
// //                     if (e.key === 'Escape') {
// //                       setShowCompareSuggestions(false);
// //                     }
// //                   }}
// //                 />
// //                 <button className="compare-button" onClick={handleCompareSubmit}>Compare Areas</button>

// //                 {/* Suggestions dropdown */}
// //                 {showCompareSuggestions && compareSuggestions.length > 0 && (
// //                   <div className="suggestions-dropdown compare-suggestions">
// //                     {compareSuggestions.map(s => (
// //                       <div key={s.id} className="suggestion-item" onClick={() => handleCompareSuggestionClick(s)}>
// //                         <div className="suggestion-name">{s.name}</div>
// //                         <div className="suggestion-postcode">{s.postcode}</div>
// //                       </div>
// //                     ))}
// //                   </div>
// //                 )}
// //               </div>

// //               <p className="compare-description">Compare {streetData.street.split(',')[0]} with any other area to see side-by-side amenity analysis</p>
// //             </div>
// //           </section>

// //           {showComparison && comparisonData && (
// //             <>
// //               <section className="comparison-results">
// //                 <h2 className="section-title">Comparison Results</h2>

// //                 <div className="attribute-comparison">
// //                   <h3>Attribute Scores</h3>
// //                   <div className="attribute-grid">
// //                     {Object.entries(comparisonData.area1.attributes).map(([attr, score]) => (
// //                       <div key={attr} className="attribute-item">
// //                         <div className="attribute-name">{amenityCategories.find(c => c.id === attr)?.name || attr}</div>
// //                         <div className="attribute-scores">
// //                           <span className="score1 primary-street">{score}</span> {/* Add class */}
// //                           <span className="score-divider">:</span>
// //                           <span className="score2 comparison-street">{comparisonData.area2.attributes[attr]}</span> {/* Add class */}
// //                         </div>
// //                       </div>
// //                     ))}
// //                   </div>
// //                 </div>

// //                 <button className="close-comparison" onClick={() => setShowComparison(false)}>Close Comparison</button>
// //               </section>

// //               <section className="amenity-comparison-container">
// //                 <h2 className="section-title comparison-title">Amenity Comparison</h2>
// //                 <div className="categories-grid comparison">
// //                   {amenityCategories.map(category => {
// //                     const street1Count = countAmenities(category.id);
// //                     const street1Score = getCategoryRating(category.id);
// //                     const street2Count = comparisonData.area2.category_counts[category.id] || 0;
// //                     const street2Score = comparisonData.area2.attributes[category.id] || 0;

// //                     if (street1Count === 0 && street2Count === 0) return null;

// //                     return (
// //                       <div key={category.id} className="category-card comparison" onClick={() => openCategoryModal(category.id)}>
// //                         <div className="category-header">
// //                           <div className="category-icon">{category.icon}</div>
// //                           <h3 className="category-name">{category.name}</h3>
// //                         </div>

// //                         <div className="street-comparison">
// //                           <div className="street-row">
// //                             <div className="street-name primary-street">{comparisonData.area1.street.split(',')[0]}</div> {/* Add class */}
// //                             <div className="score-display">
// //                               <div className="street-score primary-street">{street1Score.toFixed(1)}/10</div> {/* Add class */}
// //                               <div className="street-count">({street1Count} locations)</div>
// //                             </div>
// //                           </div>

// //                           <div className="street-row">
// //                             <div className="street-name comparison-street">{comparisonData.area2.street.split(',')[0]}</div> {/* Add class */}
// //                             <div className="score-display">
// //                               <div className="street-score comparison-street">{street2Score.toFixed(1)}/10</div> {/* Add class */}
// //                               <div className="street-count">({street2Count} locations)</div>
// //                             </div>
// //                           </div>
// //                         </div>
// //                       </div>
// //                     );
// //                   })}
// //                 </div>
// //               </section>
// //             </>
// //           )}

// //           {!showComparison && (
// //             <section className="amenity-categories">
// //               <h2 className="section-title">All Amenity Categories</h2>
// //               <div className="categories-grid">
// //                 {amenityCategories.map(category => {
// //                   const count = countAmenities(category.id);
// //                   if (count === 0) return null;
// //                   const score = getCategoryRating(category.id);

// //                   return (
// //                     <div key={category.id} className="category-card" onClick={() => openCategoryModal(category.id)}>
// //                       <div className="category-header">
// //                         <div className="category-icon">{category.icon}</div>
// //                         <h3 className="category-name">{category.name}</h3>
// //                       </div>
// //                       <div className="street-row">
// //                         <div className="score-display">
// //                           <div className="street-score primary-street">{score.toFixed(1)}/10</div> {/* Add class */}
// //                           <div className="street-count">({count} {count === 1 ? 'location' : 'locations'})</div>
// //                         </div>
// //                       </div>
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             </section>
// //           )}

// //           <section className="recommendations">
// //             <h2 className="section-title">Area Insights & Recommendations</h2>
// //             <h3 className="subsection-title">Best Suited For</h3>

// //             <div className="recommendation-cards">
// //               <div className="recommendation-card">
// //                 <div className="card-icon">🚆</div>
// //                 <h4>Excellent for Commuters</h4>
// //                 <p>AI-generated insights coming soon</p>
// //               </div>

// //               <div className="recommendation-card">
// //                 <div className="card-icon">🍽️</div>
// //                 <h4>Food & Entertainment Hub</h4>
// //                 <p>AI-generated insights coming soon</p>
// //               </div>

// //               <div className="recommendation-card">
// //                 <div className="card-icon">🛍️</div>
// //                 <h4>Shopping Destination</h4>
// //                 <p>AI-generated insights coming soon</p>
// //               </div>
// //             </div>
// //           </section>
// //         </div>
// //       )}
// //       {renderModal()}
// //     </>
// //   );
// // };

// // export default StreetAnalysis;


















// import React, { useState, useEffect, useRef } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
// import './AnalysisPage.css';
// import { BASE_URL } from '../constants';
// import ReactDOM from 'react-dom';
// import ErrorComponent from '../components/ErrorComponent';

// const StreetAnalysis = () => {
//   useEffect(() => { window.scrollTo(0, 0); }, []);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user } = useAuth();

//   // Primary data
//   const [streetData, setStreetData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // UI / comparison state
//   const [activeCategory, setActiveCategory] = useState(null);
//   const [compareInput, setCompareInput] = useState('');
//   const [compareSuggestions, setCompareSuggestions] = useState([]);
//   const [showCompareSuggestions, setShowCompareSuggestions] = useState(false);
//   const [compareLoading, setCompareLoading] = useState(false);
//   const [compareSelectedId, setCompareSelectedId] = useState(null); // id selected from suggestions
//   const [comparisonData, setComparisonData] = useState(null);
//   const [comparisonAmenities, setComparisonAmenities] = useState(null);
//   const [showComparison, setShowComparison] = useState(false);

//   // modal state
//   const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
//   const [modalCategory, setModalCategory] = useState(null);
//   const [modalStreetName, setModalStreetName] = useState('');

//   const compareRef = useRef(null); // to close suggestions on outside click
//   const scrollPositionRef = useRef(0); // to remember scroll position when modal opens

//   // accept both 'street_id' and 'id' query params for compatibility
//   const queryParams = new URLSearchParams(location.search);
//   const streetIdFromUrl = queryParams.get('street_id') || queryParams.get('id') || null;

//   const BAR_COLORS = {
//     Education: '#34D169',
//     Transport: '#3B82F6',
//     'Parks & Recreation': '#F59E0B',
//   };

//   const amenityCategories = [
//     { id: 'school', name: 'School', icon: '🏫' },
//     { id: 'university', name: 'University', icon: '🎓' },
//     { id: 'library', name: 'Library', icon: '📚' },
//     { id: 'hospital', name: 'Hospital', icon: '🏥' },
//     { id: 'doctor', name: 'Doctor', icon: '👨‍⚕️' },
//     { id: 'pharmacy', name: 'Pharmacy', icon: '💊' },
//     { id: 'restaurant', name: 'Restaurant', icon: '🍽️' },
//     { id: 'cafe', name: 'Café', icon: '☕' },
//     { id: 'bakery', name: 'Bakery', icon: '🥐' },
//     { id: 'bar', name: 'Bar', icon: '🍻' },
//     { id: 'grocery_or_supermarket', name: 'Grocery Store', icon: '🛒' },
//     { id: 'supermarket', name: 'Supermarket', icon: '🛍️' },
//     { id: 'bank', name: 'Bank', icon: '🏦' },
//     { id: 'atm', name: 'ATM', icon: '💳' },
//     { id: 'post_office', name: 'Post Office', icon: '📮' },
//     { id: 'gas_station', name: 'Petrol Station', icon: '⛽' },
//     { id: 'airport', name: 'Airport', icon: '✈️' },
//     { id: 'electric_vehicle_charging_station', name: 'EV Charging', icon: '🔌' },
//     { id: 'transport', name: 'Transport', icon: '🚆' },
//     { id: 'park', name: 'Park', icon: '🌳' },
//     { id: 'gym', name: 'Gym', icon: '💪' },
//     { id: 'stadium', name: 'Stadium', icon: '🏟️' },
//     { id: 'museum', name: 'Museum', icon: '🏛️' },
//     { id: 'art_gallery', name: 'Art Gallery', icon: '🎨' },
//     { id: 'movie_theater', name: 'Cinema', icon: '🎬' },
//   ];

//   const categoryToApiKey = {
//     school: 'schools',
//     university: 'university',
//     library: 'library',
//     hospital: 'hospitals',
//     doctor: 'doctor',
//     pharmacy: 'pharmacies',
//     restaurant: 'restaurants',
//     cafe: 'cafe',
//     bakery: 'bakery',
//     bar: 'bar',
//     grocery_or_supermarket: 'grocery_or_supermarket',
//     supermarket: 'supermarket',
//     bank: 'banks',
//     atm: 'atm',
//     post_office: 'post_office',
//     gas_station: 'gas_station',
//     park: 'park',
//     gym: 'gym',
//     stadium: 'stadium',
//     museum: 'museum',
//     art_gallery: 'art_gallery',
//     movie_theater: 'movie_theater',
//     airport: 'airport',
//     electric_vehicle_charging_station: 'electric_vehicle_charging_station',
//     transport: 'transports'
//   };

//   const transportIcons = {
//     bikepoint: '🚲', bus: '🚌', dlr: '🚈',
//     'national-rail': '🚆', overground: '🚇', tube: '🚇',
//     tram: '🚊', ferry: '⛴️', cable_car: '🚡', default: '📍'
//   };

//   // Close compare suggestions when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (compareRef.current && !compareRef.current.contains(e.target)) {
//         setShowCompareSuggestions(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   // Fetch main street rating + amenities using street_id
//   useEffect(() => {
//     const fetchStreet = async () => {
//       if (!streetIdFromUrl) {
//         navigate('/');
//         return;
//       }
//       setLoading(true);
//       setError(null);

//       try {
//         const token = localStorage.getItem('token');
//         const headers = token ? { Authorization: `Token ${token}` } : {};

//         // rating-summary expects street_id param (your backend)
//         const ratingRes = await fetch(
//           `${BASE_URL}api/streets/rating-summary/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
//           { headers }
//         );
//         if (!ratingRes.ok) throw new Error('Failed to fetch rating summary');
//         const ratingJson = await ratingRes.json();

//         // places-by-name supports street_id (preferred)
//         const placesRes = await fetch(
//           `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
//           { headers }
//         );
//         if (!placesRes.ok) throw new Error('Failed to fetch amenities');
//         const placesJson = await placesRes.json();

//         // Combine and keep rating id too
//         setStreetData({
//           id: ratingJson.id ?? streetIdFromUrl,
//           ...ratingJson,
//           amenities: placesJson,
//         });

//         if (ratingJson.top_3_attributes?.length > 0) {
//           setActiveCategory(ratingJson.top_3_attributes[0].name);
//         }
//       } catch (err) {
//         console.error(err);
//         setError(err.message || 'Failed to load street data');
//       } finally {
//         setLoading(false);
//       }
//     };

//     // only fetch when user is present (your pattern) — if you want public access, remove user guard
//     if (user && streetIdFromUrl) fetchStreet();
//     else setLoading(false);
//   }, [user, streetIdFromUrl, navigate]);

//   // Helper: fetch amenities by street id (uses street_id param)
//   const fetchAmenitiesById = async (id) => {
//     try {
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};
//       const res = await fetch(
//         `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(id)}`,
//         { headers }
//       );
//       if (!res.ok) throw new Error('Failed to fetch amenities');
//       return await res.json();
//     } catch (err) {
//       console.error('fetchAmenitiesById error:', err);
//       return { transports: {}, categories: {} };
//     }
//   };

//   // Helper: search streets for compare suggestions
//   const searchStreets = async (q) => {
//     try {
//       if (!q || !q.trim()) return [];
//       setCompareLoading(true);
//       const res = await fetch(`${BASE_URL}api/streets/search-streets/?q=${encodeURIComponent(q.trim())}`);
//       if (!res.ok) return [];
//       const data = await res.json(); // expects [{id,name,postcode}, ...]
//       return Array.isArray(data) ? data : [];
//     } catch (err) {
//       console.error('searchStreets error:', err);
//       return [];
//     } finally {
//       setCompareLoading(false);
//     }
//   };

//   // Debounce compare input to fetch suggestions
//   useEffect(() => {
//     if (!compareInput) {
//       setCompareSuggestions([]);
//       setShowCompareSuggestions(false);
//       setCompareSelectedId(null);
//       return;
//     }
//     const t = setTimeout(async () => {
//       const results = await searchStreets(compareInput);
//       setCompareSuggestions(results);
//       setShowCompareSuggestions(results.length > 0);
//     }, 300);
//     return () => clearTimeout(t);
//   }, [compareInput]);

//   // When user clicks a suggestion — set input, set selected id and immediately compare
//   const handleCompareSuggestionClick = async (suggestion) => {
//     setCompareInput(suggestion.name);
//     setCompareSelectedId(suggestion.id);
//     setShowCompareSuggestions(false);

//     // trigger compare by id (preferred)
//     await performCompareByIds(streetData?.id, suggestion.id);
//   };

//   // Perform compare with preferred id1/id2. If ids not available, fallback to q1/q2 name based compare
//   const performCompareByIds = async (id1, id2) => {
//     if (!id1 || !id2) {
//       setError('Both street IDs are required for comparison.');
//       return;
//     }
//     setLoading(true);
//     setError(null);

//     try {
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};

//       const res = await fetch(`${BASE_URL}api/streets/compare/?id1=${encodeURIComponent(id1)}&id2=${encodeURIComponent(id2)}`, { headers });
//       if (!res.ok) {
//         // fallback: if backend returns 404 or bad request, try name-based compare as a last resort
//         if (res.status === 404) throw new Error('One of the streets was not found for comparison.');
//         throw new Error('Failed to fetch comparison data');
//       }
//       const comp = await res.json();

//       // fetch amenities for both sides using returned ids (backend returns area1.id/area2.id)
//       const area1Id = comp?.area1?.id ?? id1;
//       const area2Id = comp?.area2?.id ?? id2;

//       const [amen1, amen2] = await Promise.all([fetchAmenitiesById(area1Id), fetchAmenitiesById(area2Id)]);

//       setComparisonData(comp);
//       setComparisonAmenities({ area1: amen1, area2: amen2 });
//       setShowComparison(true);

//       // scroll to results
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     } catch (err) {
//       console.error('performCompareByIds error:', err);
//       setError(err.message || 'Comparison failed');
//       setShowComparison(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // User pressed Enter in compare input — prefer selectedId, else attempt to find first match and compare by id,
//   // else fallback to name-based compare using q1/q2 endpoint.
//   const handleCompareSubmit = async (e) => {
//     e?.preventDefault?.();
//     if (!compareInput?.trim()) {
//       setError('Please enter a street name or pick a suggestion to compare.');
//       return;
//     }
//     setError(null);

//     if (compareSelectedId) {
//       return performCompareByIds(streetData?.id, compareSelectedId);
//     }

//     // Try to find a suggestion programmatically
//     const results = await searchStreets(compareInput);
//     if (results.length > 0) {
//       return performCompareByIds(streetData?.id, results[0].id);
//     }

//     // Last resort: name-based compare (q1/q2) — backend still supports this for backward compat
//     try {
//       setLoading(true);
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};
//       const res = await fetch(`${BASE_URL}api/streets/compare/?q1=${encodeURIComponent(streetData.street)}&q2=${encodeURIComponent(compareInput.trim())}`, { headers });
//       if (!res.ok) {
//         if (res.status === 404) throw new Error('Comparison street not found');
//         throw new Error('Comparison failed');
//       }
//       const comp = await res.json();
//       // fetch amenities using area names returned by compare (fallback)
//       const [amen1, amen2] = await Promise.all([fetchAmenitiesById(comp.area1.id || streetData.id), fetchAmenitiesById(comp.area2.id)]);
//       setComparisonData(comp);
//       setComparisonAmenities({ area1: amen1, area2: amen2 });
//       setShowComparison(true);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     } catch (err) {
//       console.error('fallback name compare error:', err);
//       setError(err.message || 'Comparison failed');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Utilities used by UI (counts, ratings, places lists)
//   const countAmenities = (category) => {
//     if (!streetData?.amenities) return 0;
//     if (category === 'transport') {
//       const transport = streetData.amenities.transports || {};
//       return Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
//     }
//     const apiKey = categoryToApiKey[category];
//     if (!apiKey) return 0;
//     return streetData.amenities[apiKey]?.length || 0;
//   };

//   const getCategoryRating = (categoryId, data = streetData) => {
//     if (!data?.attributes || !data.attributes[0]) return 0;
//     return data.attributes[0][categoryId] || 0;
//   };

//   const getNearbyPlaces = (category) => {
//     if (!streetData?.amenities) return [];
//     if (category === 'transport') {
//       const transport = streetData.amenities.transports || {};
//       return Object.values(transport).flat().slice(0, 5);
//     }
//     const apiKey = categoryToApiKey[category];
//     if (!apiKey) return [];
//     return streetData.amenities[apiKey]?.slice(0, 5) || [];
//   };

//   const getAllPlacesForCategory = (category, streetNameParam) => {
//     // If streetNameParam === streetData.street => return from streetData
//     if (!streetNameParam) return [];
//     if (streetNameParam === streetData?.street) {
//       if (category === 'transport') {
//         const transport = streetData.amenities?.transports || {};
//         return Object.values(transport).flat();
//       }
//       const apiKey = categoryToApiKey[category];
//       if (!apiKey) return [];
//       return streetData.amenities?.[apiKey] || [];
//     }

//     // If comparisonAmenities present, pick the correct one
//     if (comparisonAmenities) {
//       const amenities = streetNameParam === comparisonData?.area1.street ? comparisonAmenities.area1 : comparisonAmenities.area2;
//       if (category === 'transport') {
//         const transport = amenities?.transports || {};
//         return Object.values(transport).flat();
//       }
//       const apiKey = categoryToApiKey[category];
//       if (!apiKey) return [];
//       return amenities?.[apiKey] || [];
//     }

//     return [];
//   };

//   // Modals and UI helpers
//   const openCategoryModal = (category, streetName = '') => {
//     // Store current scroll position before opening modal
//     scrollPositionRef.current = window.scrollY;
//     setModalCategory(category);
//     setModalStreetName(streetName || streetData?.street || '');
//     setIsCategoryModalOpen(true);
//   };

//   const closeCategoryModal = () => {
//     setIsCategoryModalOpen(false);
//     setModalCategory(null);
//     // Restore scroll position after a short delay to allow modal to close
//     setTimeout(() => {
//       window.scrollTo(0, scrollPositionRef.current);
//     }, 10);
//   };

//   useEffect(() => {
//     if (isCategoryModalOpen) {
//       document.body.style.overflow = 'hidden';
//     } else {
//       document.body.style.overflow = 'unset';
//     }
//     return () => {
//       document.body.style.overflow = 'unset';
//     };
//   }, [isCategoryModalOpen]);

//   // Remove the useEffect that scrolls to top when showComparison changes
//   // We only want to scroll when comparison is first shown, not when modal closes
//   useEffect(() => {
//     if (showComparison) {
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   }, [showComparison]);

//   function getScoreClass(score) {
//     if (score < 8) return 'low';
//     if (score < 9) return 'medium';
//     return 'high';
//   }

//   // UI components: PlaceItem, StreetDetailCard, modal renderer
//   const PlaceItem = ({ place, category }) => (
//     <div className="place-item">
//       <div className="place-name">
//         {category === 'transport' && place.stop_type && (
//           <span className="transport-icon">{transportIcons[place.stop_type] || transportIcons.default}</span>
//         )}
//         {place.name}
//       </div>
//       {place.final_rating && <div className="place-rating">Rating: {place.final_rating}</div>}
//       {place.latitude && place.longitude && (
//         <a href={`https://maps.google.com/?q=${place.latitude},${place.longitude}`} target="_blank" rel="noopener noreferrer" className="map-link">View on Map</a>
//       )}
//     </div>
//   );

//   const StreetDetailCard = ({ street, amenities, overallScore, top3, streetType = 'primary' }) => {
//     const streetNameShort = (typeof street === 'string') ? street.split(',')[0] : '';
//     const postcode = amenities?.street?.postcode || 'London';

//     const totalAmenities = Object.keys(amenities || {})
//       .filter(key => key !== 'street')
//       .reduce((total, key) => {
//         if (key === 'transports') {
//           const transport = amenities.transports || {};
//           return total + Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
//         }
//         return total + (amenities[key]?.length || 0);
//       }, 0);

//     // Determine CSS class based on streetType
//     const streetColorClass = streetType === 'primary' ? 'primary-street' : 'comparison-street';

//     return (
//       <div className="street-detail-card">
//         <div className="location-info">
//           <h2 className={streetColorClass}>{streetNameShort}</h2> {/* Add color class here */}
//           <p>{postcode}</p>
//         </div>

//         <div className="scores-container">
//           <div className="score-item main-score">
//             <div className={`score-value ${streetColorClass}`}>{overallScore}/100</div> {/* Add color class here */}
//             <div className="score-label">Lifestyle Score</div>
//           </div>
//         </div>

//         <div className="top-3-inline">
//           <h3 className="subsection-title">Top 3 Amenity Categories</h3>
//           <ul className="top3-list">
//             {(top3 || []).map((attr, i) => {
//               const key = attr.name.toLowerCase();
//               const cat = amenityCategories.find(c => c.id === key);
//               const icon = cat ? cat.icon : '📍';
//               const label = cat ? cat.name : attr.name;
//               const score = +attr.score.toFixed(1);
//               const pct = (score / 10) * 100;
//               const cls = getScoreClass(score);

//               return (
//                 <li key={i} className="top3-item" style={{ '--i': i }}>
//                   <span className="top3-icon">{icon}</span>
//                   <span className="top3-label">{label}</span>
//                   <div className="top3-bar">
//                     <div className={`top3-fill ${cls}`} style={{ width: `${pct}%` }} />
//                   </div>
//                   <span className="top3-score">{score}/10</span>
//                 </li>
//               );
//             })}
//           </ul>
//         </div>

//         <div className="stats-container">
//           <div className="stat-item">
//             <div className="stat-value">{totalAmenities}</div>
//             <div className="stat-label">Total Amenities</div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderModal = () => {
//     if (!isCategoryModalOpen || !modalCategory) return null;

//     return ReactDOM.createPortal(
//       <div className="modal-overlay" onClick={closeCategoryModal}>
//         <div className="places-modal compare" onClick={(e) => e.stopPropagation()}>
//           <div className="modal-header">
//             <h3>{amenityCategories.find(cat => cat.id === modalCategory)?.name || modalCategory}</h3>
//             <div className="modal-subtitle">
//               <span className={`modal-street-name primary-street`}>{streetData?.street?.split(',')[0]}</span>
//               {showComparison && comparisonData && (
//                 <>
//                   <span className="modal-vs"> vs </span>
//                   <span className={`modal-street-name comparison-street`}>{comparisonData.area2.street.split(',')[0]}</span>
//                 </>
//               )}
//             </div>
//             <button className="close-detail" onClick={closeCategoryModal} aria-label="Close">×</button>
//           </div>

//           <div className="modal-stats">
//             <div className="stat-group">
//               <div className="stat-label">Performance Score</div>
//               <div className="stat-value">{getCategoryRating(modalCategory).toFixed(1)}/10</div>
//             </div>
//           </div>

//           <div className="modal-content compare">
//             <div className="modal-column">
//               <h4 className="primary-street">{streetData?.street?.split(',')[0]}</h4>
//               <div className="places-scrollable">
//                 {getAllPlacesForCategory(modalCategory, streetData?.street).map((place, index) => (
//                   <PlaceItem key={index} place={place} category={modalCategory} />
//                 ))}
//               </div>
//             </div>

//             {showComparison && comparisonData && (
//               <div className="modal-column">
//                 <h4 className="comparison-street">{comparisonData.area2.street.split(',')[0]}</h4>
//                 <div className="places-scrollable">
//                   {getAllPlacesForCategory(modalCategory, comparisonData.area2.street).map((place, index) => (
//                     <PlaceItem key={index} place={place} category={modalCategory} />
//                   ))}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>,
//       document.body
//     );
//   };

//   // Loading & error handling
//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="loading-spinner" />
//         <p>Loading street data...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return <ErrorComponent error={error} onRetry={() => { setError(null); setLoading(true); }} />;
//   }

//   if (!streetData) {
//     return <ErrorComponent error="No Data Available" onRetry={() => { setError(null); setLoading(true); }} />;
//   }

//   // Main render
//   return (
//     <>
//       {!isCategoryModalOpen && (
//         <div className="analysis-container">
//           <header className="analysis-header">
//             <button onClick={() => {
//               if (showComparison) {
//                 setShowComparison(false);
//                 navigate(`/analysis?street_id=${encodeURIComponent(streetData.id)}`, { replace: true });
//               } else {
//                 navigate(-1);
//               }
//             }} className="back-button">← Back</button>
//           </header>

//           <section className={`detailed-analysis-compare ${showComparison ? 'two-cards' : ''}`}>
//             <StreetDetailCard
//               street={streetData.street}
//               amenities={streetData.amenities}
//               overallScore={streetData.overall_score}
//               top3={streetData.top_3_attributes}
//               streetType="primary" // This makes it blue
//             />

//             {showComparison && comparisonData && (
//               <StreetDetailCard
//                 street={comparisonData.area2.street}
//                 amenities={comparisonAmenities?.area2}
//                 overallScore={comparisonData.area2.overall_score}
//                 top3={comparisonData.area2.top_3_attributes}
//                 streetType="comparison" // This makes it green
//               />
//             )}
//           </section>

//           <section className="compare-area">
//             <h2 className="section-title">Compare with Another Area</h2>
//             <div className="compare-card">
//               <div className="input-group" ref={compareRef} style={{ position: 'relative' }}>
//                 <input
//                   type="text"
//                   placeholder="Enter street name"
//                   className="compare-input"
//                   value={compareInput}
//                   onChange={(e) => {
//                     setCompareInput(e.target.value);
//                     setCompareSelectedId(null);
//                     setShowCompareSuggestions(true);
//                     setError(null);
//                   }}
//                   onKeyDown={(e) => {
//                     if (e.key === 'Enter') handleCompareSubmit(e);
//                     if (e.key === 'Escape') {
//                       setShowCompareSuggestions(false);
//                     }
//                   }}
//                 />
//                 <button className="compare-button" onClick={handleCompareSubmit}>Compare Areas</button>

//                 {/* Suggestions dropdown */}
//                 {showCompareSuggestions && compareSuggestions.length > 0 && (
//                   <div className="suggestions-dropdown compare-suggestions">
//                     {compareSuggestions.map(s => (
//                       <div key={s.id} className="suggestion-item" onClick={() => handleCompareSuggestionClick(s)}>
//                         <div className="suggestion-name">{s.name}</div>
//                         <div className="suggestion-postcode">{s.postcode}</div>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               <p className="compare-description">Compare {streetData.street.split(',')[0]} with any other area to see side-by-side amenity analysis</p>
//             </div>
//           </section>

//           {showComparison && comparisonData && (
//             <>
//               <section className="comparison-results">
//                 <h2 className="section-title">Comparison Results</h2>

//                 <div className="attribute-comparison">
//                   <h3>Attribute Scores</h3>
//                   <div className="attribute-grid">
//                     {Object.entries(comparisonData.area1.attributes).map(([attr, score]) => (
//                       <div key={attr} className="attribute-item">
//                         <div className="attribute-name">{amenityCategories.find(c => c.id === attr)?.name || attr}</div>
//                         <div className="attribute-scores">
//                           <span className="score1 primary-street">{score}</span> {/* Add class */}
//                           <span className="score-divider">:</span>
//                           <span className="score2 comparison-street">{comparisonData.area2.attributes[attr]}</span> {/* Add class */}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <button className="close-comparison" onClick={() => setShowComparison(false)}>Close Comparison</button>
//               </section>

//               <section className="amenity-comparison-container">
//                 <h2 className="section-title comparison-title">Amenity Comparison</h2>
//                 <div className="categories-grid comparison">
//                   {amenityCategories.map(category => {
//                     const street1Count = countAmenities(category.id);
//                     const street1Score = getCategoryRating(category.id);
//                     const street2Count = comparisonData.area2.category_counts[category.id] || 0;
//                     const street2Score = comparisonData.area2.attributes[category.id] || 0;

//                     if (street1Count === 0 && street2Count === 0) return null;

//                     return (
//                       <div key={category.id} className="category-card comparison" onClick={() => openCategoryModal(category.id)}>
//                         <div className="category-header">
//                           <div className="category-icon">{category.icon}</div>
//                           <h3 className="category-name">{category.name}</h3>
//                         </div>

//                         <div className="street-comparison">
//                           <div className="street-row">
//                             <div className="street-name primary-street">{comparisonData.area1.street.split(',')[0]}</div> {/* Add class */}
//                             <div className="score-display">
//                               <div className="street-score primary-street">{street1Score.toFixed(1)}/10</div> {/* Add class */}
//                               <div className="street-count">({street1Count} locations)</div>
//                             </div>
//                           </div>

//                           <div className="street-row">
//                             <div className="street-name comparison-street">{comparisonData.area2.street.split(',')[0]}</div> {/* Add class */}
//                             <div className="score-display">
//                               <div className="street-score comparison-street">{street2Score.toFixed(1)}/10</div> {/* Add class */}
//                               <div className="street-count">({street2Count} locations)</div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </section>
//             </>
//           )}

//           {!showComparison && (
//             <section className="amenity-categories">
//               <h2 className="section-title">All Amenity Categories</h2>
//               <div className="categories-grid">
//                 {amenityCategories.map(category => {
//                   const count = countAmenities(category.id);
//                   if (count === 0) return null;
//                   const score = getCategoryRating(category.id);

//                   return (
//                     <div key={category.id} className="category-card" onClick={() => openCategoryModal(category.id)}>
//                       <div className="category-header">
//                         <div className="category-icon">{category.icon}</div>
//                         <h3 className="category-name">{category.name}</h3>
//                       </div>
//                       <div className="street-row">
//                         <div className="score-display">
//                           <div className="street-score primary-street">{score.toFixed(1)}/10</div> {/* Add class */}
//                           <div className="street-count">({count} {count === 1 ? 'location' : 'locations'})</div>
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </section>
//           )}

//           <section className="recommendations">
//             <h2 className="section-title">Area Insights & Recommendations</h2>
//             <h3 className="subsection-title">Best Suited For</h3>

//             <div className="recommendation-cards">
//               <div className="recommendation-card">
//                 <div className="card-icon">🚆</div>
//                 <h4>Excellent for Commuters</h4>
//                 <p>AI-generated insights coming soon</p>
//               </div>

//               <div className="recommendation-card">
//                 <div className="card-icon">🍽️</div>
//                 <h4>Food & Entertainment Hub</h4>
//                 <p>AI-generated insights coming soon</p>
//               </div>

//               <div className="recommendation-card">
//                 <div className="card-icon">🛍️</div>
//                 <h4>Shopping Destination</h4>
//                 <p>AI-generated insights coming soon</p>
//               </div>
//             </div>
//           </section>
//         </div>
//       )}
//       {renderModal()}
//     </>
//   );
// };

// export default StreetAnalysis;




// import React, { useState, useEffect, useRef } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
// import './AnalysisPage.css';
// import { BASE_URL } from '../constants';
// import ReactDOM from 'react-dom';
// import ErrorComponent from '../components/ErrorComponent';

// const StreetAnalysis = () => {
//   useEffect(() => { window.scrollTo(0, 0); }, []);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user } = useAuth();

//   // Primary data
//   const [streetData, setStreetData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // UI / comparison state
//   const [activeCategory, setActiveCategory] = useState(null);
//   const [compareInput, setCompareInput] = useState('');
//   const [compareSuggestions, setCompareSuggestions] = useState([]);
//   const [showCompareSuggestions, setShowCompareSuggestions] = useState(false);
//   const [compareLoading, setCompareLoading] = useState(false);
//   const [compareSelectedId, setCompareSelectedId] = useState(null); // id selected from suggestions
//   const [comparisonData, setComparisonData] = useState(null);
//   const [comparisonAmenities, setComparisonAmenities] = useState(null);
//   const [showComparison, setShowComparison] = useState(false);

//   // modal state
//   const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
//   const [modalCategory, setModalCategory] = useState(null);
//   const [modalStreetName, setModalStreetName] = useState('');

//   const compareRef = useRef(null); // to close suggestions on outside click
//   const scrollPositionRef = useRef(0); // to remember scroll position when modal opens
//   const modalRef = useRef(null); // reference to the modal for click outside detection

//   // accept both 'street_id' and 'id' query params for compatibility
//   const queryParams = new URLSearchParams(location.search);
//   const streetIdFromUrl = queryParams.get('street_id') || queryParams.get('id') || null;

//   const BAR_COLORS = {
//     Education: '#34D169',
//     Transport: '#3B82F6',
//     'Parks & Recreation': '#F59E0B',
//   };

//   const amenityCategories = [
//     { id: 'school', name: 'School', icon: '🏫' },
//     { id: 'university', name: 'University', icon: '🎓' },
//     { id: 'library', name: 'Library', icon: '📚' },
//     { id: 'hospital', name: 'Hospital', icon: '🏥' },
//     { id: 'doctor', name: 'Doctor', icon: '👨‍⚕️' },
//     { id: 'pharmacy', name: 'Pharmacy', icon: '💊' },
//     { id: 'restaurant', name: 'Restaurant', icon: '🍽️' },
//     { id: 'cafe', name: 'Café', icon: '☕' },
//     { id: 'bakery', name: 'Bakery', icon: '🥐' },
//     { id: 'bar', name: 'Bar', icon: '🍻' },
//     { id: 'grocery_or_supermarket', name: 'Grocery Store', icon: '🛒' },
//     { id: 'supermarket', name: 'Supermarket', icon: '🛍️' },
//     { id: 'bank', name: 'Bank', icon: '🏦' },
//     { id: 'atm', name: 'ATM', icon: '💳' },
//     { id: 'post_office', name: 'Post Office', icon: '📮' },
//     { id: 'gas_station', name: 'Petrol Station', icon: '⛽' },
//     { id: 'airport', name: 'Airport', icon: '✈️' },
//     { id: 'electric_vehicle_charging_station', name: 'EV Charging', icon: '🔌' },
//     { id: 'transport', name: 'Transport', icon: '🚆' },
//     { id: 'park', name: 'Park', icon: '🌳' },
//     { id: 'gym', name: 'Gym', icon: '💪' },
//     { id: 'stadium', name: 'Stadium', icon: '🏟️' },
//     { id: 'museum', name: 'Museum', icon: '🏛️' },
//     { id: 'art_gallery', name: 'Art Gallery', icon: '🎨' },
//     { id: 'movie_theater', name: 'Cinema', icon: '🎬' },
//   ];

//   const categoryToApiKey = {
//     school: 'schools',
//     university: 'university',
//     library: 'library',
//     hospital: 'hospitals',
//     doctor: 'doctor',
//     pharmacy: 'pharmacies',
//     restaurant: 'restaurants',
//     cafe: 'cafe',
//     bakery: 'bakery',
//     bar: 'bar',
//     grocery_or_supermarket: 'grocery_or_supermarket',
//     supermarket: 'supermarket',
//     bank: 'banks',
//     atm: 'atm',
//     post_office: 'post_office',
//     gas_station: 'gas_station',
//     park: 'park',
//     gym: 'gym',
//     stadium: 'stadium',
//     museum: 'museum',
//     art_gallery: 'art_gallery',
//     movie_theater: 'movie_theater',
//     airport: 'airport',
//     electric_vehicle_charging_station: 'electric_vehicle_charging_station',
//     transport: 'transports'
//   };

//   const transportIcons = {
//     bikepoint: '🚲', bus: '🚌', dlr: '🚈',
//     'national-rail': '🚆', overground: '🚇', tube: '🚇',
//     tram: '🚊', ferry: '⛴️', cable_car: '🚡', default: '📍'
//   };

//   // Close compare suggestions when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (compareRef.current && !compareRef.current.contains(e.target)) {
//         setShowCompareSuggestions(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   // Handle click outside modal
//   useEffect(() => {
//     const handleClickOutsideModal = (e) => {
//       if (isCategoryModalOpen && modalRef.current && !modalRef.current.contains(e.target)) {
//         closeCategoryModal();
//       }
//     };
    
//     const handleEscapeKey = (e) => {
//       if (isCategoryModalOpen && e.key === 'Escape') {
//         closeCategoryModal();
//       }
//     };
    
//     if (isCategoryModalOpen) {
//       document.addEventListener('mousedown', handleClickOutsideModal);
//       document.addEventListener('keydown', handleEscapeKey);
//     }
    
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutsideModal);
//       document.removeEventListener('keydown', handleEscapeKey);
//     };
//   }, [isCategoryModalOpen]);

//   // Fetch main street rating + amenities using street_id
//   useEffect(() => {
//     const fetchStreet = async () => {
//       if (!streetIdFromUrl) {
//         navigate('/');
//         return;
//       }
//       setLoading(true);
//       setError(null);

//       try {
//         const token = localStorage.getItem('token');
//         const headers = token ? { Authorization: `Token ${token}` } : {};

//         // rating-summary expects street_id param (your backend)
//         const ratingRes = await fetch(
//           `${BASE_URL}api/streets/rating-summary/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
//           { headers }
//         );
//         if (!ratingRes.ok) throw new Error('Failed to fetch rating summary');
//         const ratingJson = await ratingRes.json();

//         // places-by-name supports street_id (preferred)
//         const placesRes = await fetch(
//           `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
//           { headers }
//         );
//         if (!placesRes.ok) throw new Error('Failed to fetch amenities');
//         const placesJson = await placesRes.json();

//         // Combine and keep rating id too
//         setStreetData({
//           id: ratingJson.id ?? streetIdFromUrl,
//           ...ratingJson,
//           amenities: placesJson,
//         });

//         if (ratingJson.top_3_attributes?.length > 0) {
//           setActiveCategory(ratingJson.top_3_attributes[0].name);
//         }
//       } catch (err) {
//         console.error(err);
//         setError(err.message || 'Failed to load street data');
//       } finally {
//         setLoading(false);
//       }
//     };

//     // only fetch when user is present (your pattern) — if you want public access, remove user guard
//     if (user && streetIdFromUrl) fetchStreet();
//     else setLoading(false);
//   }, [user, streetIdFromUrl, navigate]);

//   // Helper: fetch amenities by street id (uses street_id param)
//   const fetchAmenitiesById = async (id) => {
//     try {
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};
//       const res = await fetch(
//         `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(id)}`,
//         { headers }
//       );
//       if (!res.ok) throw new Error('Failed to fetch amenities');
//       return await res.json();
//     } catch (err) {
//       console.error('fetchAmenitiesById error:', err);
//       return { transports: {}, categories: {} };
//     }
//   };

//   // Helper: search streets for compare suggestions
//   const searchStreets = async (q) => {
//     try {
//       if (!q || !q.trim()) return [];
//       setCompareLoading(true);
//       const res = await fetch(`${BASE_URL}api/streets/search-streets/?q=${encodeURIComponent(q.trim())}`);
//       if (!res.ok) return [];
//       const data = await res.json(); // expects [{id,name,postcode}, ...]
//       return Array.isArray(data) ? data : [];
//     } catch (err) {
//       console.error('searchStreets error:', err);
//       return [];
//     } finally {
//       setCompareLoading(false);
//     }
//   };

//   // Debounce compare input to fetch suggestions
//   useEffect(() => {
//     if (!compareInput) {
//       setCompareSuggestions([]);
//       setShowCompareSuggestions(false);
//       setCompareSelectedId(null);
//       return;
//     }
//     const t = setTimeout(async () => {
//       const results = await searchStreets(compareInput);
//       setCompareSuggestions(results);
//       setShowCompareSuggestions(results.length > 0);
//     }, 300);
//     return () => clearTimeout(t);
//   }, [compareInput]);

//   // When user clicks a suggestion — set input, set selected id and immediately compare
//   const handleCompareSuggestionClick = async (suggestion) => {
//     setCompareInput(suggestion.name);
//     setCompareSelectedId(suggestion.id);
//     setShowCompareSuggestions(false);

//     // trigger compare by id (preferred)
//     await performCompareByIds(streetData?.id, suggestion.id);
//   };

//   // Perform compare with preferred id1/id2. If ids not available, fallback to q1/q2 name based compare
//   const performCompareByIds = async (id1, id2) => {
//     if (!id1 || !id2) {
//       setError('Both street IDs are required for comparison.');
//       return;
//     }
//     setLoading(true);
//     setError(null);

//     try {
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};

//       const res = await fetch(`${BASE_URL}api/streets/compare/?id1=${encodeURIComponent(id1)}&id2=${encodeURIComponent(id2)}`, { headers });
//       if (!res.ok) {
//         // fallback: if backend returns 404 or bad request, try name-based compare as a last resort
//         if (res.status === 404) throw new Error('One of the streets was not found for comparison.');
//         throw new Error('Failed to fetch comparison data');
//       }
//       const comp = await res.json();

//       // fetch amenities for both sides using returned ids (backend returns area1.id/area2.id)
//       const area1Id = comp?.area1?.id ?? id1;
//       const area2Id = comp?.area2?.id ?? id2;

//       const [amen1, amen2] = await Promise.all([fetchAmenitiesById(area1Id), fetchAmenitiesById(area2Id)]);

//       setComparisonData(comp);
//       setComparisonAmenities({ area1: amen1, area2: amen2 });
//       setShowComparison(true);

//       // scroll to results
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     } catch (err) {
//       console.error('performCompareByIds error:', err);
//       setError(err.message || 'Comparison failed');
//       setShowComparison(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // User pressed Enter in compare input — prefer selectedId, else attempt to find first match and compare by id,
//   // else fallback to name-based compare using q1/q2 endpoint.
//   const handleCompareSubmit = async (e) => {
//     e?.preventDefault?.();
//     if (!compareInput?.trim()) {
//       setError('Please enter a street name or pick a suggestion to compare.');
//       return;
//     }
//     setError(null);

//     if (compareSelectedId) {
//       return performCompareByIds(streetData?.id, compareSelectedId);
//     }

//     // Try to find a suggestion programmatically
//     const results = await searchStreets(compareInput);
//     if (results.length > 0) {
//       return performCompareByIds(streetData?.id, results[0].id);
//     }

//     // Last resort: name-based compare (q1/q2) — backend still supports this for backward compat
//     try {
//       setLoading(true);
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};
//       const res = await fetch(`${BASE_URL}api/streets/compare/?q1=${encodeURIComponent(streetData.street)}&q2=${encodeURIComponent(compareInput.trim())}`, { headers });
//       if (!res.ok) {
//         if (res.status === 404) throw new Error('Comparison street not found');
//         throw new Error('Comparison failed');
//       }
//       const comp = await res.json();
//       // fetch amenities using area names returned by compare (fallback)
//       const [amen1, amen2] = await Promise.all([fetchAmenitiesById(comp.area1.id || streetData.id), fetchAmenitiesById(comp.area2.id)]);
//       setComparisonData(comp);
//       setComparisonAmenities({ area1: amen1, area2: amen2 });
//       setShowComparison(true);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     } catch (err) {
//       console.error('fallback name compare error:', err);
//       setError(err.message || 'Comparison failed');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Utilities used by UI (counts, ratings, places lists)
//   const countAmenities = (category) => {
//     if (!streetData?.amenities) return 0;
//     if (category === 'transport') {
//       const transport = streetData.amenities.transports || {};
//       return Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
//     }
//     const apiKey = categoryToApiKey[category];
//     if (!apiKey) return 0;
//     return streetData.amenities[apiKey]?.length || 0;
//   };

//   const getCategoryRating = (categoryId, data = streetData) => {
//     if (!data?.attributes || !data.attributes[0]) return 0;
//     return data.attributes[0][categoryId] || 0;
//   };

//   const getNearbyPlaces = (category) => {
//     if (!streetData?.amenities) return [];
//     if (category === 'transport') {
//       const transport = streetData.amenities.transports || {};
//       return Object.values(transport).flat().slice(0, 5);
//     }
//     const apiKey = categoryToApiKey[category];
//     if (!apiKey) return [];
//     return streetData.amenities[apiKey]?.slice(0, 5) || [];
//   };

//   const getAllPlacesForCategory = (category, streetNameParam) => {
//     // If streetNameParam === streetData.street => return from streetData
//     if (!streetNameParam) return [];
//     if (streetNameParam === streetData?.street) {
//       if (category === 'transport') {
//         const transport = streetData.amenities?.transports || {};
//         return Object.values(transport).flat();
//       }
//       const apiKey = categoryToApiKey[category];
//       if (!apiKey) return [];
//       return streetData.amenities?.[apiKey] || [];
//     }

//     // If comparisonAmenities present, pick the correct one
//     if (comparisonAmenities) {
//       const amenities = streetNameParam === comparisonData?.area1.street ? comparisonAmenities.area1 : comparisonAmenities.area2;
//       if (category === 'transport') {
//         const transport = amenities?.transports || {};
//         return Object.values(transport).flat();
//       }
//       const apiKey = categoryToApiKey[category];
//       if (!apiKey) return [];
//       return amenities?.[apiKey] || [];
//     }

//     return [];
//   };

//   // Modals and UI helpers
//   const openCategoryModal = (category, streetName = '') => {
//     // Store current scroll position before opening modal
//     scrollPositionRef.current = window.scrollY;
//     setModalCategory(category);
//     setModalStreetName(streetName || streetData?.street || '');
//     setIsCategoryModalOpen(true);
    
//     // Prevent body scrolling when modal is open
//     document.body.style.overflow = 'hidden';
//   };

//   const closeCategoryModal = () => {
//     setIsCategoryModalOpen(false);
//     setModalCategory(null);
//     // Restore body scrolling
//     document.body.style.overflow = 'unset';
    
//     // Restore scroll position after a short delay to allow modal to close
//     setTimeout(() => {
//       window.scrollTo(0, scrollPositionRef.current);
//     }, 10);
//   };

//   // Remove the problematic useEffect for modal body class
//   useEffect(() => {
//     return () => {
//       // Cleanup: ensure body scrolling is restored when component unmounts
//       document.body.style.overflow = 'unset';
//     };
//   }, []);

//   useEffect(() => {
//     if (showComparison) {
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   }, [showComparison]);

//   function getScoreClass(score) {
//     if (score < 8) return 'low';
//     if (score < 9) return 'medium';
//     return 'high';
//   }

//   // UI components: PlaceItem, StreetDetailCard, modal renderer
//   const PlaceItem = ({ place, category }) => (
//     <div className="place-item">
//       <div className="place-name">
//         {category === 'transport' && place.stop_type && (
//           <span className="transport-icon">{transportIcons[place.stop_type] || transportIcons.default}</span>
//         )}
//         {place.name}
//       </div>
//       {place.final_rating && <div className="place-rating">Rating: {place.final_rating}</div>}
//       {place.latitude && place.longitude && (
//         <a href={`https://maps.google.com/?q=${place.latitude},${place.longitude}`} target="_blank" rel="noopener noreferrer" className="map-link">View on Map</a>
//       )}
//     </div>
//   );

//   const StreetDetailCard = ({ street, amenities, overallScore, top3, streetType = 'primary' }) => {
//     const streetNameShort = (typeof street === 'string') ? street.split(',')[0] : '';
//     const postcode = amenities?.street?.postcode || 'London';

//     const totalAmenities = Object.keys(amenities || {})
//       .filter(key => key !== 'street')
//       .reduce((total, key) => {
//         if (key === 'transports') {
//           const transport = amenities.transports || {};
//           return total + Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
//         }
//         return total + (amenities[key]?.length || 0);
//       }, 0);

//     // Determine CSS class based on streetType
//     const streetColorClass = streetType === 'primary' ? 'primary-street' : 'comparison-street';

//     return (
//       <div className="street-detail-card">
//         <div className="location-info">
//           <h2 className={streetColorClass}>{streetNameShort}</h2> {/* Add color class here */}
//           <p>{postcode}</p>
//         </div>

//         <div className="scores-container">
//           <div className="score-item main-score">
//             <div className={`score-value ${streetColorClass}`}>{overallScore}/100</div> {/* Add color class here */}
//             <div className="score-label">Lifestyle Score</div>
//           </div>
//         </div>

//         <div className="top-3-inline">
//           <h3 className="subsection-title">Top 3 Amenity Categories</h3>
//           <ul className="top3-list">
//             {(top3 || []).map((attr, i) => {
//               const key = attr.name.toLowerCase();
//               const cat = amenityCategories.find(c => c.id === key);
//               const icon = cat ? cat.icon : '📍';
//               const label = cat ? cat.name : attr.name;
//               const score = +attr.score.toFixed(1);
//               const pct = (score / 10) * 100;
//               const cls = getScoreClass(score);

//               return (
//                 <li key={i} className="top3-item" style={{ '--i': i }}>
//                   <span className="top3-icon">{icon}</span>
//                   <span className="top3-label">{label}</span>
//                   <div className="top3-bar">
//                     <div className={`top3-fill ${cls}`} style={{ width: `${pct}%` }} />
//                   </div>
//                   <span className="top3-score">{score}/10</span>
//                 </li>
//               );
//             })}
//           </ul>
//         </div>

//         <div className="stats-container">
//           <div className="stat-item">
//             <div className="stat-value">{totalAmenities}</div>
//             <div className="stat-label">Total Amenities</div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderModal = () => {
//     if (!isCategoryModalOpen || !modalCategory) return null;

//     return ReactDOM.createPortal(
//       <div className="modal-overlay">
//         <div 
//           className="places-modal compare" 
//           ref={modalRef}
//           onClick={(e) => e.stopPropagation()}
//         >
//           <div className="modal-header">
//             <h3>{amenityCategories.find(cat => cat.id === modalCategory)?.name || modalCategory}</h3>
//             <div className="modal-subtitle">
//               {/* <span className={`modal-street-name primary-street`}>{streetData?.street?.split(',')[0]}</span> */}
//               {showComparison && comparisonData && (
//                 <>
//                   {/* <span className="modal-vs"> vs </span>
//                   <span className={`modal-street-name comparison-street`}>{comparisonData.area2.street.split(',')[0]}</span> */}
//                 </>
//               )}
//             </div>
//             <button 
//               className="close-detail" 
//               onClick={closeCategoryModal} 
//               aria-label="Close"
//             >
//               ×
//             </button>
//           </div>

//           <div className="modal-stats">
//             <div className="stat-group">
//               <div className="stat-label">Performance Score</div>
//               <div className="stat-value">{getCategoryRating(modalCategory).toFixed(1)}/10</div>
//             </div>
//             <p className="scoring-note">
//             Each amenity is scored based on a combination of proximity and quality.
//           </p>
//           </div>

//           <div className="modal-content compare">
//             <div className="modal-column">
//               <h4 className="primary-street">{streetData?.street?.split(',')[0]}</h4>
//               <div className="places-scrollable">
//                 {getAllPlacesForCategory(modalCategory, streetData?.street).length > 0 ? (
//                   getAllPlacesForCategory(modalCategory, streetData?.street).map((place, index) => (
//                     <PlaceItem key={index} place={place} category={modalCategory} />
//                   ))
//                 ) : (
//                   <div className="no-places-message">No places found in this category</div>
//                 )}
//               </div>
//             </div>

//             {showComparison && comparisonData && (
//               <div className="modal-column">
//                 <h4 className="comparison-street">{comparisonData.area2.street.split(',')[0]}</h4>
//                 <div className="places-scrollable">
//                   {getAllPlacesForCategory(modalCategory, comparisonData.area2.street).length > 0 ? (
//                     getAllPlacesForCategory(modalCategory, comparisonData.area2.street).map((place, index) => (
//                       <PlaceItem key={index} place={place} category={modalCategory} />
//                     ))
//                   ) : (
//                     <div className="no-places-message">No places found in this category</div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>,
//       document.body
//     );
//   };

//   // Loading & error handling
//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="loading-spinner" />
//         <p>Loading street data...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return <ErrorComponent error={error} onRetry={() => { setError(null); setLoading(true); }} />;
//   }

//   if (!streetData) {
//     return <ErrorComponent error="No Data Available" onRetry={() => { setError(null); setLoading(true); }} />;
//   }

//   // Main render
//   return (
//     <>
//       {!isCategoryModalOpen && (
//         <div className="analysis-container">
//           <header className="analysis-header">
//             <button onClick={() => {
//               if (showComparison) {
//                 setShowComparison(false);
//                 navigate(`/analysis?street_id=${encodeURIComponent(streetData.id)}`, { replace: true });
//               } else {
//                 navigate(-1);
//               }
//             }} className="back-button">← Back</button>
//           </header>

//           <section className={`detailed-analysis-compare ${showComparison ? 'two-cards' : ''}`}>
//             <StreetDetailCard
//               street={streetData.street}
//               amenities={streetData.amenities}
//               overallScore={streetData.overall_score}
//               top3={streetData.top_3_attributes}
//               streetType="primary" // This makes it blue
//             />

//             {showComparison && comparisonData && (
//               <StreetDetailCard
//                 street={comparisonData.area2.street}
//                 amenities={comparisonAmenities?.area2}
//                 overallScore={comparisonData.area2.overall_score}
//                 top3={comparisonData.area2.top_3_attributes}
//                 streetType="comparison" // This makes it green
//               />
//             )}
//           </section>

//           <section className="compare-area">
//             <h2 className="section-title">Compare with Another Area</h2>
//             <div className="compare-card">
//               <div className="input-group" ref={compareRef} style={{ position: 'relative' }}>
//                 <input
//                   type="text"
//                   placeholder="Enter street name"
//                   className="compare-input"
//                   value={compareInput}
//                   onChange={(e) => {
//                     setCompareInput(e.target.value);
//                     setCompareSelectedId(null);
//                     setShowCompareSuggestions(true);
//                     setError(null);
//                   }}
//                   onKeyDown={(e) => {
//                     if (e.key === 'Enter') handleCompareSubmit(e);
//                     if (e.key === 'Escape') {
//                       setShowCompareSuggestions(false);
//                     }
//                   }}
//                 />
//                 <button className="compare-button" onClick={handleCompareSubmit}>Compare Areas</button>

//                 {/* Suggestions dropdown */}
//                 {showCompareSuggestions && compareSuggestions.length > 0 && (
//                   <div className="suggestions-dropdown compare-suggestions">
//                     {compareSuggestions.map(s => (
//                       <div key={s.id} className="suggestion-item" onClick={() => handleCompareSuggestionClick(s)}>
//                         <div className="suggestion-name">{s.name}</div>
//                         <div className="suggestion-postcode">{s.postcode}</div>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               <p className="compare-description">Compare {streetData.street.split(',')[0]} with any other area to see side-by-side amenity analysis</p>
//             </div>
//           </section>

//           {showComparison && comparisonData && (
//             <>
//               <section className="comparison-results">
//                 <h2 className="section-title">Comparison Results</h2>

//                 <div className="attribute-comparison">
//                   <h3>Attribute Scores</h3>
//                   <div className="attribute-grid">
//                     {Object.entries(comparisonData.area1.attributes).map(([attr, score]) => (
//                       <div key={attr} className="attribute-item">
//                         <div className="attribute-name">{amenityCategories.find(c => c.id === attr)?.name || attr}</div>
//                         <div className="attribute-scores">
//                           <span className="score1 primary-street">{score}</span> {/* Add class */}
//                           <span className="score-divider">:</span>
//                           <span className="score2 comparison-street">{comparisonData.area2.attributes[attr]}</span> {/* Add class */}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <button className="close-comparison" onClick={() => setShowComparison(false)}>Close Comparison</button>
//               </section>

//               <section className="amenity-comparison-container">
//                 <h2 className="section-title comparison-title">Amenity Comparison</h2>
//                 <p className="comparison-description">
//     Scores are based on proximity and quality of amenities.
//   </p>
//                 <div className="categories-grid comparison">
//                   {amenityCategories.map(category => {
//                     const street1Count = countAmenities(category.id);
//                     const street1Score = getCategoryRating(category.id);
//                     const street2Count = comparisonData.area2.category_counts[category.id] || 0;
//                     const street2Score = comparisonData.area2.attributes[category.id] || 0;

//                     if (street1Count === 0 && street2Count === 0) return null;

//                     return (
//                       <div key={category.id} className="category-card comparison" onClick={() => openCategoryModal(category.id)}>
//                         <div className="category-header">
//                           <div className="category-icon">{category.icon}</div>
//                           <h3 className="category-name">{category.name}</h3>
//                         </div>

//                         <div className="street-comparison">
//                           <div className="street-row">
//                             <div className="street-name primary-street">{comparisonData.area1.street.split(',')[0]}</div> {/* Add class */}
//                             <div className="score-display">
//                               <div className="street-score primary-street">{street1Score.toFixed(1)}/10</div> {/* Add class */}
//                               <div className="street-count">({street1Count} locations)</div>
//                             </div>
//                           </div>

//                           <div className="street-row">
//                             <div className="street-name comparison-street">{comparisonData.area2.street.split(',')[0]}</div> {/* Add class */}
//                             <div className="score-display">
//                               <div className="street-score comparison-street">{street2Score.toFixed(1)}/10</div> {/* Add class */}
//                               <div className="street-count">({street2Count} locations)</div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </section>
//             </>
//           )}

//           {!showComparison && (
//             <section className="amenity-categories">
//               <h2 className="section-title">All Amenity Categories</h2>
//               <div className="categories-grid">
//                 {amenityCategories.map(category => {
//                   const count = countAmenities(category.id);
//                   if (count === 0) return null;
//                   const score = getCategoryRating(category.id);

//                   return (
//                     <div key={category.id} className="category-card" onClick={() => openCategoryModal(category.id)}>
//                       <div className="category-header">
//                         <div className="category-icon">{category.icon}</div>
//                         <h3 className="category-name">{category.name}</h3>
//                       </div>
//                       <div className="street-row">
//                         <div className="score-display">
//                           <div className="street-score primary-street">{score.toFixed(1)}/10</div> {/* Add class */}
//                           <div className="street-count">({count} {count === 1 ? 'location' : 'locations'})</div>
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </section>
//           )}

//           <section className="recommendations">
//             <h2 className="section-title">Area Insights & Recommendations</h2>
//             <h3 className="subsection-title">Best Suited For</h3>

//             <div className="recommendation-cards">
//               <div className="recommendation-card">
//                 <div className="card-icon">🚆</div>
//                 <h4>Excellent for Commuters</h4>
//                 <p>AI-generated insights coming soon</p>
//               </div>

//               <div className="recommendation-card">
//                 <div className="card-icon">🍽️</div>
//                 <h4>Food & Entertainment Hub</h4>
//                 <p>AI-generated insights coming soon</p>
//               </div>

//               <div className="recommendation-card">
//                 <div className="card-icon">🛍️</div>
//                 <h4>Shopping Destination</h4>
//                 <p>AI-generated insights coming soon</p>
//               </div>
//             </div>
//           </section>
//         </div>
//       )}
//       {renderModal()}
//     </>
//   );
// };

// export default StreetAnalysis;

//---------------------------------------------------------------

// import React, { useState, useEffect, useRef } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
// import './AnalysisPage.css';
// import { BASE_URL } from '../constants';
// import ReactDOM from 'react-dom';
// import ErrorComponent from '../components/ErrorComponent';

// const StreetAnalysis = () => {
//   useEffect(() => { window.scrollTo(0, 0); }, []);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user } = useAuth();

//   // Primary data
//   const [streetData, setStreetData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // UI / comparison state
//   const [activeCategory, setActiveCategory] = useState(null);
//   const [compareInput, setCompareInput] = useState('');
//   const [compareSuggestions, setCompareSuggestions] = useState([]);
//   const [showCompareSuggestions, setShowCompareSuggestions] = useState(false);
//   const [compareLoading, setCompareLoading] = useState(false);
//   const [compareSelectedId, setCompareSelectedId] = useState(null); // id selected from suggestions
//   const [comparisonData, setComparisonData] = useState(null);
//   const [comparisonAmenities, setComparisonAmenities] = useState(null);
//   const [showComparison, setShowComparison] = useState(false);

//   // modal state
//   const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
//   const [modalCategory, setModalCategory] = useState(null);
//   const [modalStreetName, setModalStreetName] = useState('');


//   // AI summaries state
// const [aiSummaries, setAiSummaries] = useState({
//   area1: null,
//   area2: null,
//   comparison: null,
// });
// const [aiLoading, setAiLoading] = useState(false);
// const [aiError, setAiError] = useState(null);


//   const compareRef = useRef(null); // to close suggestions on outside click
//   const scrollPositionRef = useRef(0); // to remember scroll position when modal opens
//   const modalRef = useRef(null); // reference to the modal for click outside detection

//   // accept both 'street_id' and 'id' query params for compatibility
//   const queryParams = new URLSearchParams(location.search);
//   const streetIdFromUrl = queryParams.get('street_id') || queryParams.get('id') || null;

//   const BAR_COLORS = {
//     Education: '#34D169',
//     Transport: '#3B82F6',
//     'Parks & Recreation': '#F59E0B',
//   };

//   const amenityCategories = [
//     { id: 'school', name: 'School', icon: '🏫' },
//     { id: 'university', name: 'University', icon: '🎓' },
//     { id: 'library', name: 'Library', icon: '📚' },
//     { id: 'hospital', name: 'Hospital', icon: '🏥' },
//     { id: 'doctor', name: 'Doctor', icon: '👨‍⚕️' },
//     { id: 'pharmacy', name: 'Pharmacy', icon: '💊' },
//     { id: 'restaurant', name: 'Restaurant', icon: '🍽️' },
//     { id: 'cafe', name: 'Café', icon: '☕' },
//     { id: 'bakery', name: 'Bakery', icon: '🥐' },
//     { id: 'bar', name: 'Bar', icon: '🍻' },
//     { id: 'grocery_or_supermarket', name: 'Grocery Store', icon: '🛒' },
//     { id: 'supermarket', name: 'Supermarket', icon: '🛍️' },
//     { id: 'bank', name: 'Bank', icon: '🏦' },
//     { id: 'atm', name: 'ATM', icon: '💳' },
//     { id: 'post_office', name: 'Post Office', icon: '📮' },
//     { id: 'gas_station', name: 'Petrol Station', icon: '⛽' },
//     { id: 'airport', name: 'Airport', icon: '✈️' },
//     { id: 'electric_vehicle_charging_station', name: 'EV Charging', icon: '🔌' },
//     { id: 'transport', name: 'Transport', icon: '🚆' },
//     { id: 'park', name: 'Park', icon: '🌳' },
//     { id: 'gym', name: 'Gym', icon: '💪' },
//     { id: 'stadium', name: 'Stadium', icon: '🏟️' },
//     { id: 'museum', name: 'Museum', icon: '🏛️' },
//     { id: 'art_gallery', name: 'Art Gallery', icon: '🎨' },
//     { id: 'movie_theater', name: 'Cinema', icon: '🎬' },
//   ];

//   const categoryToApiKey = {
//     school: 'schools',
//     university: 'university',
//     library: 'library',
//     hospital: 'hospitals',
//     doctor: 'doctor',
//     pharmacy: 'pharmacies',
//     restaurant: 'restaurants',
//     cafe: 'cafe',
//     bakery: 'bakery',
//     bar: 'bar',
//     grocery_or_supermarket: 'grocery_or_supermarket',
//     supermarket: 'supermarket',
//     bank: 'banks',
//     atm: 'atm',
//     post_office: 'post_office',
//     gas_station: 'gas_station',
//     park: 'park',
//     gym: 'gym',
//     stadium: 'stadium',
//     museum: 'museum',
//     art_gallery: 'art_gallery',
//     movie_theater: 'movie_theater',
//     airport: 'airport',
//     electric_vehicle_charging_station: 'electric_vehicle_charging_station',
//     transport: 'transports'
//   };

//   const transportIcons = {
//     bikepoint: '🚲', bus: '🚌', dlr: '🚈',
//     'national-rail': '🚆', overground: '🚇', tube: '🚇',
//     tram: '🚊', ferry: '⛴️', cable_car: '🚡', default: '📍'
//   };

//   // -------------------------
//   // New helpers for directions
//   // -------------------------
//   const buildDirectionsUrl = ({ startLat, startLon, endLat, endLon }) => {
//     // If any of the start or end coords are missing, fallback to a simple place query
//     const hasStart = startLat !== undefined && startLon !== undefined && startLat !== null && startLon !== null;
//     const hasEnd = endLat !== undefined && endLon !== undefined && endLat !== null && endLon !== null;

//     if (!hasEnd) return '#';

//     if (!hasStart) {
//       // Open end place in Maps if we don't have origin coords
//       return `https://maps.google.com/?q=${encodeURIComponent(endLat + ',' + endLon)}`;
//     }

//     // Normal directions URL
//     const origin = `${startLat},${startLon}`;
//     const destination = `${endLat},${endLon}`;
//     return `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}`;
//   };

//   const extractLatLonFromStreetObj = (streetObj) => {
//     if (!streetObj) return { lat: null, lon: null };
//     // Accept multiple possible field names returned by backend
//     const lat = streetObj.latitude ?? streetObj.lat ?? streetObj.location_lat ?? null;
//     const lon = streetObj.longitude ?? streetObj.lon ?? streetObj.lng ?? streetObj.location_lon ?? null;
//     return { lat, lon };
//   };

//   const getStreetCoordsForName = (streetName) => {
//     // Try primary street
//     if (streetName === streetData?.street) {
//       return extractLatLonFromStreetObj(streetData?.amenities?.street || {});
//     }

//     if (comparisonAmenities && comparisonData) {
//       // area1
//       if (streetName === comparisonData.area1.street) {
//         return extractLatLonFromStreetObj(comparisonAmenities.area1?.street || {});
//       }
//       // area2
//       if (streetName === comparisonData.area2.street) {
//         return extractLatLonFromStreetObj(comparisonAmenities.area2?.street || {});
//       }
//     }

//     return { lat: null, lon: null };
//   };

//   // Close compare suggestions when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (compareRef.current && !compareRef.current.contains(e.target)) {
//         setShowCompareSuggestions(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   // Handle click outside modal
//   useEffect(() => {
//     const handleClickOutsideModal = (e) => {
//       if (isCategoryModalOpen && modalRef.current && !modalRef.current.contains(e.target)) {
//         closeCategoryModal();
//       }
//     };
    
//     const handleEscapeKey = (e) => {
//       if (isCategoryModalOpen && e.key === 'Escape') {
//         closeCategoryModal();
//       }
//     };
    
//     if (isCategoryModalOpen) {
//       document.addEventListener('mousedown', handleClickOutsideModal);
//       document.addEventListener('keydown', handleEscapeKey);
//     }
    
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutsideModal);
//       document.removeEventListener('keydown', handleEscapeKey);
//     };
//   }, [isCategoryModalOpen]);

//   // Fetch main street rating + amenities using street_id
//   useEffect(() => {
//     const fetchStreet = async () => {
//       if (!streetIdFromUrl) {
//         navigate('/');
//         return;
//       }
//       setLoading(true);
//       setError(null);

//       try {
//         const token = localStorage.getItem('token');
//         const headers = token ? { Authorization: `Token ${token}` } : {};

//         // rating-summary expects street_id param (your backend)
//         const ratingRes = await fetch(
//           `${BASE_URL}api/streets/rating-summary/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
//           { headers }
//         );
//         if (!ratingRes.ok) throw new Error('Failed to fetch rating summary');
//         const ratingJson = await ratingRes.json();

//         // places-by-name supports street_id (preferred)
//         const placesRes = await fetch(
//           `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
//           { headers }
//         );
//         if (!placesRes.ok) throw new Error('Failed to fetch amenities');
//         const placesJson = await placesRes.json();

//         // Combine and keep rating id too
//         setStreetData({
//           id: ratingJson.id ?? streetIdFromUrl,
//           ...ratingJson,
//           amenities: placesJson,
//         });

//         if (ratingJson.top_3_attributes?.length > 0) {
//           setActiveCategory(ratingJson.top_3_attributes[0].name);
//         }
//       } catch (err) {
//         console.error(err);
//         setError(err.message || 'Failed to load street data');
//       } finally {
//         setLoading(false);
//       }
//     };

//     // only fetch when user is present (your pattern) — if you want public access, remove user guard
//     if (user && streetIdFromUrl) fetchStreet();
//     else setLoading(false);
//   }, [user, streetIdFromUrl, navigate]);

//   // Helper: fetch amenities by street id (uses street_id param)
//   const fetchAmenitiesById = async (id) => {
//     try {
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};
//       const res = await fetch(
//         `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(id)}`,
//         { headers }
//       );
//       if (!res.ok) throw new Error('Failed to fetch amenities');
//       return await res.json();
//     } catch (err) {
//       console.error('fetchAmenitiesById error:', err);
//       return { transports: {}, categories: {} };
//     }
//   };

//   const fetchAISummaries = async () => {
//   if (!streetData) return;
//   setAiLoading(true);
//   setAiError(null);

//   try {
//     const payload = {
//       area1: {
//         name: streetData.street,
//         overall_score: streetData.overall_score,
//         top3: (streetData.top_3_attributes || []).slice(0, 3)
//       }
//     };

//     if (showComparison && comparisonData) {
//       payload.area2 = {
//         name: comparisonData.area2.street,
//         overall_score: comparisonData.area2.overall_score,
//         top3: (comparisonData.area2.top_3_attributes || []).slice(0, 3)
//       };
//     }

//     const res = await fetch('/api/ai/summary/', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify(payload),
//     });

//     if (!res.ok) {
//       const txt = await res.text();
//       throw new Error(txt || 'AI summary request failed');
//     }

//     const json = await res.json();

//     // If OpenAI returned raw text (fallback), wrap it, else set structured result
//     if (json.raw) {
//       setAiSummaries({
//         area1: { summary: json.raw, valuation: '', lifestyle: [] },
//         area2: null,
//         comparison: null,
//       });
//     } else {
//       setAiSummaries({
//         area1: json.area1 || null,
//         area2: json.area2 || null,
//         comparison: json.comparison || null,
//       });
//     }
//   } catch (err) {
//     console.error('AI summary error', err);
//     setAiError(err.message || 'Failed to generate AI summary');
//   } finally {
//     setAiLoading(false);
//   }
// };


//   // Helper: search streets for compare suggestions
//   const searchStreets = async (q) => {
//     try {
//       if (!q || !q.trim()) return [];
//       setCompareLoading(true);
//       const res = await fetch(`${BASE_URL}api/streets/search-streets/?q=${encodeURIComponent(q.trim())}`);
//       if (!res.ok) return [];
//       const data = await res.json(); // expects [{id,name,postcode}, ...]
//       return Array.isArray(data) ? data : [];
//     } catch (err) {
//       console.error('searchStreets error:', err);
//       return [];
//     } finally {
//       setCompareLoading(false);
//     }
//   };

//   // Debounce compare input to fetch suggestions
//   useEffect(() => {
//     if (!compareInput) {
//       setCompareSuggestions([]);
//       setShowCompareSuggestions(false);
//       setCompareSelectedId(null);
//       return;
//     }
//     const t = setTimeout(async () => {
//       const results = await searchStreets(compareInput);
//       setCompareSuggestions(results);
//       setShowCompareSuggestions(results.length > 0);
//     }, 300);
//     return () => clearTimeout(t);
//   }, [compareInput]);

//   // When user clicks a suggestion — set input, set selected id and immediately compare
//   const handleCompareSuggestionClick = async (suggestion) => {
//     setCompareInput(suggestion.name);
//     setCompareSelectedId(suggestion.id);
//     setShowCompareSuggestions(false);

//     // trigger compare by id (preferred)
//     await performCompareByIds(streetData?.id, suggestion.id);
//   };

//   // Perform compare with preferred id1/id2. If ids not available, fallback to q1/q2 name based compare
//   const performCompareByIds = async (id1, id2) => {
//     if (!id1 || !id2) {
//       setError('Both street IDs are required for comparison.');
//       return;
//     }
//     setLoading(true);
//     setError(null);

//     try {
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};

//       const res = await fetch(`${BASE_URL}api/streets/compare/?id1=${encodeURIComponent(id1)}&id2=${encodeURIComponent(id2)}`, { headers });
//       if (!res.ok) {
//         // fallback: if backend returns 404 or bad request, try name-based compare as a last resort
//         if (res.status === 404) throw new Error('One of the streets was not found for comparison.');
//         throw new Error('Failed to fetch comparison data');
//       }
//       const comp = await res.json();

//       // fetch amenities for both sides using returned ids (backend returns area1.id/area2.id)
//       const area1Id = comp?.area1?.id ?? id1;
//       const area2Id = comp?.area2?.id ?? id2;

//       const [amen1, amen2] = await Promise.all([fetchAmenitiesById(area1Id), fetchAmenitiesById(area2Id)]);

//       setComparisonData(comp);
//       setComparisonAmenities({ area1: amen1, area2: amen2 });
//       setShowComparison(true);

//       // scroll to results
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     } catch (err) {
//       console.error('performCompareByIds error:', err);
//       setError(err.message || 'Comparison failed');
//       setShowComparison(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // User pressed Enter in compare input — prefer selectedId, else attempt to find first match and compare by id,
//   // else fallback to name-based compare using q1/q2 endpoint.
//   const handleCompareSubmit = async (e) => {
//     e?.preventDefault?.();
//     if (!compareInput?.trim()) {
//       setError('Please enter a street name or pick a suggestion to compare.');
//       return;
//     }
//     setError(null);

//     if (compareSelectedId) {
//       return performCompareByIds(streetData?.id, compareSelectedId);
//     }

//     // Try to find a suggestion programmatically
//     const results = await searchStreets(compareInput);
//     if (results.length > 0) {
//       return performCompareByIds(streetData?.id, results[0].id);
//     }

//     // Last resort: name-based compare (q1/q2) — backend still supports this for backward compat
//     try {
//       setLoading(true);
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};
//       const res = await fetch(`${BASE_URL}api/streets/compare/?q1=${encodeURIComponent(streetData.street)}&q2=${encodeURIComponent(compareInput.trim())}`, { headers });
//       if (!res.ok) {
//         if (res.status === 404) throw new Error('Comparison street not found');
//         throw new Error('Comparison failed');
//       }
//       const comp = await res.json();
//       // fetch amenities using area names returned by compare (fallback)
//       const [amen1, amen2] = await Promise.all([fetchAmenitiesById(comp.area1.id || streetData.id), fetchAmenitiesById(comp.area2.id)]);
//       setComparisonData(comp);
//       setComparisonAmenities({ area1: amen1, area2: amen2 });
//       setShowComparison(true);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     } catch (err) {
//       console.error('fallback name compare error:', err);
//       setError(err.message || 'Comparison failed');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Utilities used by UI (counts, ratings, places lists)
//   const countAmenities = (category) => {
//     if (!streetData?.amenities) return 0;
//     if (category === 'transport') {
//       const transport = streetData.amenities.transports || {};
//       return Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
//     }
//     const apiKey = categoryToApiKey[category];
//     if (!apiKey) return 0;
//     return streetData.amenities[apiKey]?.length || 0;
//   };

//   const getCategoryRating = (categoryId, data = streetData) => {
//     if (!data?.attributes || !data.attributes[0]) return 0;
//     return data.attributes[0][categoryId] || 0;
//   };

//   const getNearbyPlaces = (category) => {
//     if (!streetData?.amenities) return [];
//     if (category === 'transport') {
//       const transport = streetData.amenities.transports || {};
//       return Object.values(transport).flat().slice(0, 5);
//     }
//     const apiKey = categoryToApiKey[category];
//     if (!apiKey) return [];
//     return streetData.amenities[apiKey]?.slice(0, 5) || [];
//   };

//   const getAllPlacesForCategory = (category, streetNameParam) => {
//     // If streetNameParam === streetData.street => return from streetData
//     if (!streetNameParam) return [];
//     if (streetNameParam === streetData?.street) {
//       if (category === 'transport') {
//         const transport = streetData.amenities?.transports || {};
//         return Object.values(transport).flat();
//       }
//       const apiKey = categoryToApiKey[category];
//       if (!apiKey) return [];
//       return streetData.amenities?.[apiKey] || [];
//     }

//     // If comparisonAmenities present, pick the correct one
//     if (comparisonAmenities) {
//       const amenities = streetNameParam === comparisonData?.area1.street ? comparisonAmenities.area1 : comparisonAmenities.area2;
//       if (category === 'transport') {
//         const transport = amenities?.transports || {};
//         return Object.values(transport).flat();
//       }
//       const apiKey = categoryToApiKey[category];
//       if (!apiKey) return [];
//       return amenities?.[apiKey] || [];
//     }

//     return [];
//   };

//   // Modals and UI helpers
//   const openCategoryModal = (category, streetName = '') => {
//     // Store current scroll position before opening modal
//     scrollPositionRef.current = window.scrollY;
//     setModalCategory(category);
//     setModalStreetName(streetName || streetData?.street || '');
//     setIsCategoryModalOpen(true);
    
//     // Prevent body scrolling when modal is open
//     document.body.style.overflow = 'hidden';
//   };

//   const closeCategoryModal = () => {
//     setIsCategoryModalOpen(false);
//     setModalCategory(null);
//     // Restore body scrolling
//     document.body.style.overflow = 'unset';
    
//     // Restore scroll position after a short delay to allow modal to close
//     setTimeout(() => {
//       window.scrollTo(0, scrollPositionRef.current);
//     }, 10);
//   };

//   // Remove the problematic useEffect for modal body class
//   useEffect(() => {
//     return () => {
//       // Cleanup: ensure body scrolling is restored when component unmounts
//       document.body.style.overflow = 'unset';
//     };
//   }, []);

//   useEffect(() => {
//     if (showComparison) {
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   }, [showComparison]);

//   useEffect(() => {
//   if (!streetData) return;
//   const t = setTimeout(() => {
//     fetchAISummaries();
//   }, 150);
//   return () => clearTimeout(t);
//   // regenerate when street id or compare mode (area2 id) changes
// }, [streetData?.id, showComparison, comparisonData?.area2?.id]);


//   function getScoreClass(score) {
//     if (score < 8) return 'low';
//     if (score < 9) return 'medium';
//     return 'high';
//   }

//   // UI components: PlaceItem, StreetDetailCard, modal renderer
//   const PlaceItem = ({ place, category, startCoords }) => {
//     // startCoords should be an object with { lat, lon }
//     const endLat = place.latitude ?? place.lat ?? place.location_lat ?? null;
//     const endLon = place.longitude ?? place.lon ?? place.location_lon ?? null;

//     const startLat = startCoords?.lat ?? null;
//     const startLon = startCoords?.lon ?? null;

//     const directionsUrl = buildDirectionsUrl({ startLat, startLon, endLat, endLon });

//     return (
//       <div className="place-item">
//         <div className="place-name">
//           {category === 'transport' && place.stop_type && (
//             <span className="transport-icon">{transportIcons[place.stop_type] || transportIcons.default}</span>
//           )}
//           {place.name}
//         </div>
//         {place.final_rating && <div className="place-rating">Rating: {place.final_rating}</div>}
//         <div className="place-links">
//           {endLat && endLon && (
//             <a href={directionsUrl} target="_blank" rel="noopener noreferrer" className="map-link">View on Map</a>
//           )}

//           {/* Keep existing "View on Map" link as a fallback */}
//           {/* {endLat && endLon && (
//             <a href={`https://maps.google.com/?q=${endLat},${endLon}`} target="_blank" rel="noopener noreferrer" className="map-link">View on Map</a>
//           )} */}
//         </div>
//       </div>
//     );
//   };

//   const StreetDetailCard = ({ street, amenities, overallScore, top3, streetType = 'primary' }) => {
//     const streetNameShort = (typeof street === 'string') ? street.split(',')[0] : '';
//     const postcode = amenities?.street?.postcode || 'London';

//     const totalAmenities = Object.keys(amenities || {})
//       .filter(key => key !== 'street')
//       .reduce((total, key) => {
//         if (key === 'transports') {
//           const transport = amenities.transports || {};
//           return total + Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
//         }
//         return total + (amenities[key]?.length || 0);
//       }, 0);

//     // Determine CSS class based on streetType
//     const streetColorClass = streetType === 'primary' ? 'primary-street' : 'comparison-street';

//     return (
//       <div className="street-detail-card">
//         <div className="location-info">
//           <h2 className={streetColorClass}>{streetNameShort}</h2> {/* Add color class here */}
//           <p>{postcode}</p>
//         </div>

//         <div className="scores-container">
//           <div className="score-item main-score">
//             <div className={`score-value ${streetColorClass}`}>{overallScore}/100</div> {/* Add color class here */}
//             <div className="score-label">Lifestyle Score</div>
//           </div>
//         </div>

//         <div className="top-3-inline">
//           <h3 className="subsection-title">Top 3 Amenity Categories</h3>
//           <ul className="top3-list">
//             {(top3 || []).map((attr, i) => {
//               const key = attr.name.toLowerCase();
//               const cat = amenityCategories.find(c => c.id === key);
//               const icon = cat ? cat.icon : '📍';
//               const label = cat ? cat.name : attr.name;
//               const score = +attr.score.toFixed(1);
//               const pct = (score / 10) * 100;
//               const cls = getScoreClass(score);

//               return (
//                 <li key={i} className="top3-item" style={{ '--i': i }}>
//                   <span className="top3-icon">{icon}</span>
//                   <span className="top3-label">{label}</span>
//                   <div className="top3-bar">
//                     <div className={`top3-fill ${cls}`} style={{ width: `${pct}%` }} />
//                   </div>
//                   <span className="top3-score">{score}/10</span>
//                 </li>
//               );
//             })}
//           </ul>
//         </div>

//         <div className="stats-container">
//           <div className="stat-item">
//             <div className="stat-value">{totalAmenities}</div>
//             <div className="stat-label">Total Amenities</div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderModal = () => {
//     if (!isCategoryModalOpen || !modalCategory) return null;

//     // Determine start coords for primary and comparison columns
//     const primaryStreetCoords = extractLatLonFromStreetObj(streetData?.amenities?.street || {});
//     const comparisonStreetCoords = comparisonAmenities ? extractLatLonFromStreetObj(comparisonAmenities.area2?.street || {}) : { lat: null, lon: null };

//     return ReactDOM.createPortal(
//       <div className="modal-overlay">
//         <div 
//           className="places-modal compare" 
//           ref={modalRef}
//           onClick={(e) => e.stopPropagation()}
//         >
//           <div className="modal-header">
//             <h3>{amenityCategories.find(cat => cat.id === modalCategory)?.name || modalCategory}</h3>
//             <div className="modal-subtitle">
//               {/* <span className={`modal-street-name primary-street`}>{streetData?.street?.split(',')[0]}</span> */}
//               {showComparison && comparisonData && (
//                 <>
//                   {/* <span className="modal-vs"> vs </span>
//                   <span className={`modal-street-name comparison-street`}>{comparisonData.area2.street.split(',')[0]}</span> */}
//                 </>
//               )}
//             </div>
//             <button 
//               className="close-detail" 
//               onClick={closeCategoryModal} 
//               aria-label="Close"
//             >
//               ×
//             </button>
//           </div>

//           <div className="modal-stats">
//             <div className="stat-group">
//               <div className="stat-label">Performance Score</div>
//               <div className="stat-value">{getCategoryRating(modalCategory).toFixed(1)}/10</div>
//             </div>
//             <p className="scoring-note">
//             Each amenity is scored based on a combination of proximity and quality.
//           </p>
//           </div>

//           <div className="modal-content compare">
//             <div className="modal-column">
//               <h4 className="primary-street">{streetData?.street?.split(',')[0]}</h4>
//               <div className="places-scrollable">
//                 {getAllPlacesForCategory(modalCategory, streetData?.street).length > 0 ? (
//                   getAllPlacesForCategory(modalCategory, streetData?.street).map((place, index) => (
//                     <PlaceItem key={index} place={place} category={modalCategory} startCoords={primaryStreetCoords} />
//                   ))
//                 ) : (
//                   <div className="no-places-message">No places found in this category</div>
//                 )}
//               </div>
//             </div>

//             {showComparison && comparisonData && (
//               <div className="modal-column">
//                 <h4 className="comparison-street">{comparisonData.area2.street.split(',')[0]}</h4>
//                 <div className="places-scrollable">
//                   {getAllPlacesForCategory(modalCategory, comparisonData.area2.street).length > 0 ? (
//                     getAllPlacesForCategory(modalCategory, comparisonData.area2.street).map((place, index) => (
//                       <PlaceItem key={index} place={place} category={modalCategory} startCoords={comparisonStreetCoords} />
//                     ))
//                   ) : (
//                     <div className="no-places-message">No places found in this category</div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>,
//       document.body
//     );
//   };

//   // Loading & error handling
//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="loading-spinner" />
//         <p>Loading street data...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return <ErrorComponent error={error} onRetry={() => { setError(null); setLoading(true); }} />;
//   }

//   if (!streetData) {
//     return <ErrorComponent error="No Data Available" onRetry={() => { setError(null); setLoading(true); }} />;
//   }

//   // Main render
//   return (
//     <>
//       {!isCategoryModalOpen && (
//         <div className="analysis-container">
//           <header className="analysis-header">
//             <button onClick={() => {
//               if (showComparison) {
//                 setShowComparison(false);
//                 navigate(`/analysis?street_id=${encodeURIComponent(streetData.id)}`, { replace: true });
//               } else {
//                 navigate(-1);
//               }
//             }} className="back-button">← Back</button>
//           </header>

//           <section className={`detailed-analysis-compare ${showComparison ? 'two-cards' : ''}`}>
//             <StreetDetailCard
//               street={streetData.street}
//               amenities={streetData.amenities}
//               overallScore={streetData.overall_score}
//               top3={streetData.top_3_attributes}
//               streetType="primary" // This makes it blue
//             />

//             {showComparison && comparisonData && (
//               <StreetDetailCard
//                 street={comparisonData.area2.street}
//                 amenities={comparisonAmenities?.area2}
//                 overallScore={comparisonData.area2.overall_score}
//                 top3={comparisonData.area2.top_3_attributes}
//                 streetType="comparison" // This makes it green
//               />
//             )}
//           </section>

//           <section className="compare-area">
//             <h2 className="section-title">Compare with Another Area</h2>
//             <div className="compare-card">
//               <div className="input-group" ref={compareRef} style={{ position: 'relative' }}>
//                 <input
//                   type="text"
//                   placeholder="Enter street name"
//                   className="compare-input"
//                   value={compareInput}
//                   onChange={(e) => {
//                     setCompareInput(e.target.value);
//                     setCompareSelectedId(null);
//                     setShowCompareSuggestions(true);
//                     setError(null);
//                   }}
//                   onKeyDown={(e) => {
//                     if (e.key === 'Enter') handleCompareSubmit(e);
//                     if (e.key === 'Escape') {
//                       setShowCompareSuggestions(false);
//                     }
//                   }}
//                 />
//                 <button className="compare-button" onClick={handleCompareSubmit}>Compare Areas</button>

//                 {/* Suggestions dropdown */}
//                 {showCompareSuggestions && compareSuggestions.length > 0 && (
//                   <div className="suggestions-dropdown compare-suggestions">
//                     {compareSuggestions.map(s => (
//                       <div key={s.id} className="suggestion-item" onClick={() => handleCompareSuggestionClick(s)}>
//                         <div className="suggestion-name">{s.name}</div>
//                         <div className="suggestion-postcode">{s.postcode}</div>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               <p className="compare-description">Compare {streetData.street.split(',')[0]} with any other area to see side-by-side amenity analysis</p>
//             </div>
//           </section>

//           {showComparison && comparisonData && (
//             <>
//               <section className="comparison-results">
//                 <h2 className="section-title">Comparison Results</h2>

//                 <div className="attribute-comparison">
//                   <h3>Attribute Scores</h3>
//                   <div className="attribute-grid">
//                     {Object.entries(comparisonData.area1.attributes).map(([attr, score]) => (
//                       <div key={attr} className="attribute-item">
//                         <div className="attribute-name">{amenityCategories.find(c => c.id === attr)?.name || attr}</div>
//                         <div className="attribute-scores">
//                           <span className="score1 primary-street">{score}</span> {/* Add class */}
//                           <span className="score-divider">:</span>
//                           <span className="score2 comparison-street">{comparisonData.area2.attributes[attr]}</span> {/* Add class */}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <button className="close-comparison" onClick={() => setShowComparison(false)}>Close Comparison</button>
//               </section>

//               <section className="amenity-comparison-container">
//                 <h2 className="section-title comparison-title">Amenity Comparison</h2>
//                 <p className="comparison-description">
//     Scores are based on proximity and quality of amenities.
//   </p>
//                 <div className="categories-grid comparison">
//                   {amenityCategories.map(category => {
//                     const street1Count = countAmenities(category.id);
//                     const street1Score = getCategoryRating(category.id);
//                     const street2Count = comparisonData.area2.category_counts[category.id] || 0;
//                     const street2Score = comparisonData.area2.attributes[category.id] || 0;

//                     if (street1Count === 0 && street2Count === 0) return null;

//                     return (
//                       <div key={category.id} className="category-card comparison" onClick={() => openCategoryModal(category.id)}>
//                         <div className="category-header">
//                           <div className="category-icon">{category.icon}</div>
//                           <h3 className="category-name">{category.name}</h3>
//                         </div>

//                         <div className="street-comparison">
//                           <div className="street-row">
//                             <div className="street-name primary-street">{comparisonData.area1.street.split(',')[0]}</div> {/* Add class */}
//                             <div className="score-display">
//                               <div className="street-score primary-street">{street1Score.toFixed(1)}/10</div> {/* Add class */}
//                               <div className="street-count">({street1Count} locations)</div>
//                             </div>
//                           </div>

//                           <div className="street-row">
//                             <div className="street-name comparison-street">{comparisonData.area2.street.split(',')[0]}</div> {/* Add class */}
//                             <div className="score-display">
//                               <div className="street-score comparison-street">{street2Score.toFixed(1)}/10</div> {/* Add class */}
//                               <div className="street-count">({street2Count} locations)</div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </section>
//             </>
//           )}

//           {!showComparison && (
//             <section className="amenity-categories">
//               <h2 className="section-title">All Amenity Categories</h2>
//               <div className="categories-grid">
//                 {amenityCategories.map(category => {
//                   const count = countAmenities(category.id);
//                   if (count === 0) return null;
//                   const score = getCategoryRating(category.id);

//                   return (
//                     <div key={category.id} className="category-card" onClick={() => openCategoryModal(category.id)}>
//                       <div className="category-header">
//                         <div className="category-icon">{category.icon}</div>
//                         <h3 className="category-name">{category.name}</h3>
//                       </div>
//                       <div className="street-row">
//                         <div className="score-display">
//                           <div className="street-score primary-street">{score.toFixed(1)}/10</div> {/* Add class */}
//                           <div className="street-count">({count} {count === 1 ? 'location' : 'locations'})</div>
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </section>
//           )}

//           {/* <section className="recommendations">
//             <h2 className="section-title">Area Insights & Recommendations</h2>
//             <h3 className="subsection-title">Best Suited For</h3>

//             <div className="recommendation-cards">
//               <div className="recommendation-card">
//                 <div className="card-icon">🚆</div>
//                 <h4>Excellent for Commuters</h4>
//                 <p>AI-generated insights coming soon</p>
//               </div>

//               <div className="recommendation-card">
//                 <div className="card-icon">🍽️</div>
//                 <h4>Food & Entertainment Hub</h4>
//                 <p>AI-generated insights coming soon</p>
//               </div>

//               <div className="recommendation-card">
//                 <div className="card-icon">🛍️</div>
//                 <h4>Shopping Destination</h4>
//                 <p>AI-generated insights coming soon</p>
//               </div>
//             </div>
//           </section> */}

//           <section className="recommendations">
//   <h2 className="section-title">Area Insights & Recommendations</h2>

//   <div style={{ marginBottom: 16 }}>
//     <div style={{ display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'space-between' }}>
//       <div style={{ fontWeight: 600 }}>AI Insights</div>
//       <div>
//         <button className="view-locations" onClick={fetchAISummaries} disabled={aiLoading}>
//           {aiLoading ? 'Generating…' : 'Regenerate AI Summaries'}
//         </button>
//       </div>
//     </div>
//     {aiError && <div style={{ color: 'red', marginTop: 8 }}>Error: {aiError}</div>}
//   </div>

//   {/* Single-street summary */}
//   {!showComparison && (
//     <div className="ai-summary-card" style={{ marginBottom: 20 }}>
//       <h3 className="subsection-title">High-level Summary</h3>
//       {aiSummaries.area1 ? (
//         <>
//           <p className="ai-summary-text">{aiSummaries.area1.summary}</p>
//           {aiSummaries.area1.valuation && <p><strong>Valuation:</strong> {aiSummaries.area1.valuation}</p>}
//           <ul>
//             {(aiSummaries.area1.lifestyle || []).map((b, i) => <li key={i}>{b}</li>)}
//           </ul>
//         </>
//       ) : (
//         <p>{aiLoading ? 'Generating summary…' : 'Summary will appear here.'}</p>
//       )}
//     </div>
//   )}

//   {/* Comparison summaries */}
//   {showComparison && comparisonData && (
//     <div className="ai-comparison-wrapper" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
//       <div className="ai-summary-card">
//         <h4>{comparisonData.area1.street.split(',')[0]} — Summary</h4>
//         {aiSummaries.area1 ? (
//           <>
//             <p>{aiSummaries.area1.summary}</p>
//             <p><strong>Valuation:</strong> {aiSummaries.area1.valuation}</p>
//             <ul>{(aiSummaries.area1.lifestyle || []).map((b, i) => <li key={i}>{b}</li>)}</ul>
//           </>
//         ) : <p>{aiLoading ? 'Generating…' : '—'}</p>}
//       </div>

//       <div className="ai-summary-card">
//         <h4>{comparisonData.area2.street.split(',')[0]} — Summary</h4>
//         {aiSummaries.area2 ? (
//           <>
//             <p>{aiSummaries.area2.summary}</p>
//             <p><strong>Valuation:</strong> {aiSummaries.area2.valuation}</p>
//             <ul>{(aiSummaries.area2.lifestyle || []).map((b, i) => <li key={i}>{b}</li>)}</ul>
//           </>
//         ) : <p>{aiLoading ? 'Generating…' : '—'}</p>}
//       </div>

//       <div className="ai-summary-card">
//         <h4>Light Comparative Summary</h4>
//         {aiSummaries.comparison ? (
//           <>
//             <p>{aiSummaries.comparison.summary}</p>
//             <p><strong>Valuation comparison:</strong> {aiSummaries.comparison.valuation}</p>
//             <ul>{(aiSummaries.comparison.differences || []).map((d, i) => <li key={i}>{d}</li>)}</ul>
//           </>
//         ) : <p>{aiLoading ? 'Generating comparison…' : '—'}</p>}
//       </div>
//     </div>
//   )}

//   {/* Keep your old recommendation cards if you want */}
//   <div className="recommendation-cards" style={{ marginTop: 20 }}>
//     <div className="recommendation-card"><div className="card-icon">🚆</div><h4>Excellent for Commuters</h4><p>AI-generated insights coming soon</p></div>
//     <div className="recommendation-card"><div className="card-icon">🍽️</div><h4>Food & Entertainment Hub</h4><p>AI-generated insights coming soon</p></div>
//     <div className="recommendation-card"><div className="card-icon">🛍️</div><h4>Shopping Destination</h4><p>AI-generated insights coming soon</p></div>
//   </div>
// </section>

//         </div>
//       )}
//       {renderModal()}
//     </>
//   );
// };

// export default StreetAnalysis;



// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
// import './AnalysisPage.css';
// import { BASE_URL } from '../constants';
// import ReactDOM from 'react-dom';
// import ErrorComponent from '../components/ErrorComponent';

// const StreetAnalysis = () => {
//   useEffect(() => { window.scrollTo(0, 0); }, []);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user } = useAuth();

//   // Primary data
//   const [streetData, setStreetData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // UI / comparison state
//   // prefixed unused state variables with _ to silence lint while keeping setters available
//   const [_activeCategory, setActiveCategory] = useState(null);
//   const [compareInput, setCompareInput] = useState('');
//   const [compareSuggestions, setCompareSuggestions] = useState([]);
//   const [showCompareSuggestions, setShowCompareSuggestions] = useState(false);
//   const [_compareLoading, setCompareLoading] = useState(false);
//   const [compareSelectedId, setCompareSelectedId] = useState(null); // id selected from suggestions
//   const [comparisonData, setComparisonData] = useState(null);
//   const [comparisonAmenities, setComparisonAmenities] = useState(null);
//   const [showComparison, setShowComparison] = useState(false);

//   // modal state
//   const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
//   const [modalCategory, setModalCategory] = useState(null);
//   const [_modalStreetName, setModalStreetName] = useState('');

//   // AI summaries state
//   const [aiSummaries, setAiSummaries] = useState({
//     area1: null,
//     area2: null,
//     comparison: null,
//   });
//   const [aiLoading, setAiLoading] = useState(false);
//   const [aiError, setAiError] = useState(null);

//   const compareRef = useRef(null); // to close suggestions on outside click
//   const scrollPositionRef = useRef(0); // to remember scroll position when modal opens
//   const modalRef = useRef(null); // reference to the modal for click outside detection

//   // accept both 'street_id' and 'id' query params for compatibility
//   const queryParams = new URLSearchParams(location.search);
//   const streetIdFromUrl = queryParams.get('street_id') || queryParams.get('id') || null;

//   // left in but prefixed to silence unused-var lint (you can remove if not needed)
//   const _BAR_COLORS = {
//     Education: '#34D169',
//     Transport: '#3B82F6',
//     'Parks & Recreation': '#F59E0B',
//   };

//   const amenityCategories = [
//     { id: 'school', name: 'School', icon: '🏫' },
//     { id: 'university', name: 'University', icon: '🎓' },
//     { id: 'library', name: 'Library', icon: '📚' },
//     { id: 'hospital', name: 'Hospital', icon: '🏥' },
//     { id: 'doctor', name: 'Doctor', icon: '👨‍⚕️' },
//     { id: 'pharmacy', name: 'Pharmacy', icon: '💊' },
//     { id: 'restaurant', name: 'Restaurant', icon: '🍽️' },
//     { id: 'cafe', name: 'Café', icon: '☕' },
//     { id: 'bakery', name: 'Bakery', icon: '🥐' },
//     { id: 'bar', name: 'Bar', icon: '🍻' },
//     { id: 'grocery_or_supermarket', name: 'Grocery Store', icon: '🛒' },
//     { id: 'supermarket', name: 'Supermarket', icon: '🛍️' },
//     { id: 'bank', name: 'Bank', icon: '🏦' },
//     { id: 'atm', name: 'ATM', icon: '💳' },
//     { id: 'post_office', name: 'Post Office', icon: '📮' },
//     { id: 'gas_station', name: 'Petrol Station', icon: '⛽' },
//     { id: 'airport', name: 'Airport', icon: '✈️' },
//     { id: 'electric_vehicle_charging_station', name: 'EV Charging', icon: '🔌' },
//     { id: 'transport', name: 'Transport', icon: '🚆' },
//     { id: 'park', name: 'Park', icon: '🌳' },
//     { id: 'gym', name: 'Gym', icon: '💪' },
//     { id: 'stadium', name: 'Stadium', icon: '🏟️' },
//     { id: 'museum', name: 'Museum', icon: '🏛️' },
//     { id: 'art_gallery', name: 'Art Gallery', icon: '🎨' },
//     { id: 'movie_theater', name: 'Cinema', icon: '🎬' },
//   ];

//   const categoryToApiKey = {
//     school: 'schools',
//     university: 'university',
//     library: 'library',
//     hospital: 'hospitals',
//     doctor: 'doctor',
//     pharmacy: 'pharmacies',
//     restaurant: 'restaurants',
//     cafe: 'cafe',
//     bakery: 'bakery',
//     bar: 'bar',
//     grocery_or_supermarket: 'grocery_or_supermarket',
//     supermarket: 'supermarket',
//     bank: 'banks',
//     atm: 'atm',
//     post_office: 'post_office',
//     gas_station: 'gas_station',
//     park: 'park',
//     gym: 'gym',
//     stadium: 'stadium',
//     museum: 'museum',
//     art_gallery: 'art_gallery',
//     movie_theater: 'movie_theater',
//     airport: 'airport',
//     electric_vehicle_charging_station: 'electric_vehicle_charging_station',
//     transport: 'transports'
//   };

//   const transportIcons = {
//     bikepoint: '🚲', bus: '🚌', dlr: '🚈',
//     'national-rail': '🚆', overground: '🚇', tube: '🚇',
//     tram: '🚊', ferry: '⛴️', cable_car: '🚡', default: '📍'
//   };

//   // -------------------------
//   // New helpers for directions
//   // -------------------------
//   const buildDirectionsUrl = ({ startLat, startLon, endLat, endLon }) => {
//     // If any of the start or end coords are missing, fallback to a simple place query
//     const hasStart = startLat !== undefined && startLon !== undefined && startLat !== null && startLon !== null;
//     const hasEnd = endLat !== undefined && endLon !== undefined && endLat !== null && endLon !== null;

//     if (!hasEnd) return '#';

//     if (!hasStart) {
//       // Open end place in Maps if we don't have origin coords
//       return `https://maps.google.com/?q=${encodeURIComponent(endLat + ',' + endLon)}`;
//     }

//     // Normal directions URL
//     const origin = `${startLat},${startLon}`;
//     const destination = `${endLat},${endLon}`;
//     return `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}`;
//   };

//   const extractLatLonFromStreetObj = (streetObj) => {
//     if (!streetObj) return { lat: null, lon: null };
//     // Accept multiple possible field names returned by backend
//     const lat = streetObj.latitude ?? streetObj.lat ?? streetObj.location_lat ?? null;
//     const lon = streetObj.longitude ?? streetObj.lon ?? streetObj.lng ?? streetObj.location_lon ?? null;
//     return { lat, lon };
//   };

//   // kept but prefixed to avoid lint warning (not used right now)
//   const _getStreetCoordsForName = (streetName) => {
//     if (streetName === streetData?.street) {
//       return extractLatLonFromStreetObj(streetData?.amenities?.street || {});
//     }

//     if (comparisonAmenities && comparisonData) {
//       if (streetName === comparisonData.area1.street) {
//         return extractLatLonFromStreetObj(comparisonAmenities.area1?.street || {});
//       }
//       if (streetName === comparisonData.area2.street) {
//         return extractLatLonFromStreetObj(comparisonAmenities.area2?.street || {});
//       }
//     }

//     return { lat: null, lon: null };
//   };

//   // Close compare suggestions when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (compareRef.current && !compareRef.current.contains(e.target)) {
//         setShowCompareSuggestions(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   // Handle click outside modal
//   useEffect(() => {
//     const handleClickOutsideModal = (e) => {
//       if (isCategoryModalOpen && modalRef.current && !modalRef.current.contains(e.target)) {
//         closeCategoryModal();
//       }
//     };

//     const handleEscapeKey = (e) => {
//       if (isCategoryModalOpen && e.key === 'Escape') {
//         closeCategoryModal();
//       }
//     };

//     if (isCategoryModalOpen) {
//       document.addEventListener('mousedown', handleClickOutsideModal);
//       document.addEventListener('keydown', handleEscapeKey);
//     }

//     return () => {
//       document.removeEventListener('mousedown', handleClickOutsideModal);
//       document.removeEventListener('keydown', handleEscapeKey);
//     };
//   }, [isCategoryModalOpen]);

//   // Fetch main street rating + amenities using street_id
//   useEffect(() => {
//     const fetchStreet = async () => {
//       if (!streetIdFromUrl) {
//         navigate('/');
//         return;
//       }
//       setLoading(true);
//       setError(null);

//       try {
//         const token = localStorage.getItem('token');
//         const headers = token ? { Authorization: `Token ${token}` } : {};

//         // rating-summary expects street_id param (your backend)
//         const ratingRes = await fetch(
//           `${BASE_URL}api/streets/rating-summary/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
//           { headers }
//         );
//         if (!ratingRes.ok) throw new Error('Failed to fetch rating summary');
//         const ratingJson = await ratingRes.json();

//         // places-by-name supports street_id (preferred)
//         const placesRes = await fetch(
//           `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
//           { headers }
//         );
//         if (!placesRes.ok) throw new Error('Failed to fetch amenities');
//         const placesJson = await placesRes.json();

//         // Combine and keep rating id too
//         setStreetData({
//           id: ratingJson.id ?? streetIdFromUrl,
//           ...ratingJson,
//           amenities: placesJson,
//         });

//         if (ratingJson.top_3_attributes?.length > 0) {
//           setActiveCategory(ratingJson.top_3_attributes[0].name);
//         }
//       } catch (err) {
//         console.error(err);
//         setError(err.message || 'Failed to load street data');
//       } finally {
//         setLoading(false);
//       }
//     };

//     // only fetch when user is present (your pattern) — if you want public access, remove user guard
//     if (user && streetIdFromUrl) fetchStreet();
//     else setLoading(false);
//   }, [user, streetIdFromUrl, navigate]);

//   // Helper: fetch amenities by street id (uses street_id param)
//   const fetchAmenitiesById = async (id) => {
//     try {
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};
//       const res = await fetch(
//         `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(id)}`,
//         { headers }
//       );
//       if (!res.ok) throw new Error('Failed to fetch amenities');
//       return await res.json();
//     } catch (err) {
//       console.error('fetchAmenitiesById error:', err);
//       return { transports: {}, categories: {} };
//     }
//   };

//   // Stable AI fetcher - useCallback to satisfy hook deps
//   const fetchAISummaries = useCallback(async () => {
//     if (!streetData) return;
//     setAiLoading(true);
//     setAiError(null);

//     try {
//       const payload = {
//         area1: {
//           name: streetData.street,
//           overall_score: streetData.overall_score,
//           top3: (streetData.top_3_attributes || []).slice(0, 3)
//         }
//       };

//       if (showComparison && comparisonData) {
//         payload.area2 = {
//           name: comparisonData.area2.street,
//           overall_score: comparisonData.area2.overall_score,
//           top3: (comparisonData.area2.top_3_attributes || []).slice(0, 3)
//         };
//       }

//       console.log('AI summary payload:', payload); 

//       const res = await fetch('/api/ai/summary/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(payload),
//       });

//       if (!res.ok) {
//         const txt = await res.text();
//         throw new Error(txt || 'AI summary request failed');
//       }

//       const json = await res.json();

//       // If OpenAI returned raw text (fallback), wrap it, else set structured result
//       if (json.raw) {
//         setAiSummaries({
//           area1: { summary: json.raw, valuation: '', lifestyle: [] },
//           area2: null,
//           comparison: null,
//         });
//       } else {
//         setAiSummaries({
//           area1: json.area1 || null,
//           area2: json.area2 || null,
//           comparison: json.comparison || null,
//         });
//       }
//     } catch (err) {
//       console.error('AI summary error', err);
//       setAiError(err.message || 'Failed to generate AI summary');
//     } finally {
//       setAiLoading(false);
//     }
//   }, [streetData, showComparison, comparisonData]);

//   // Helper: search streets for compare suggestions
//   const searchStreets = async (q) => {
//     try {
//       if (!q || !q.trim()) return [];
//       setCompareLoading(true);
//       const res = await fetch(`${BASE_URL}api/streets/search-streets/?q=${encodeURIComponent(q.trim())}`);
//       if (!res.ok) return [];
//       const data = await res.json(); // expects [{id,name,postcode}, ...]
//       return Array.isArray(data) ? data : [];
//     } catch (err) {
//       console.error('searchStreets error:', err);
//       return [];
//     } finally {
//       setCompareLoading(false);
//     }
//   };

//   // Debounce compare input to fetch suggestions
//   useEffect(() => {
//     if (!compareInput) {
//       setCompareSuggestions([]);
//       setShowCompareSuggestions(false);
//       setCompareSelectedId(null);
//       return;
//     }
//     const t = setTimeout(async () => {
//       const results = await searchStreets(compareInput);
//       setCompareSuggestions(results);
//       setShowCompareSuggestions(results.length > 0);
//     }, 300);
//     return () => clearTimeout(t);
//   }, [compareInput]);

//   // When user clicks a suggestion — set input, set selected id and immediately compare
//   const handleCompareSuggestionClick = async (suggestion) => {
//     setCompareInput(suggestion.name);
//     setCompareSelectedId(suggestion.id);
//     setShowCompareSuggestions(false);

//     // trigger compare by id (preferred)
//     await performCompareByIds(streetData?.id, suggestion.id);
//   };

//   // Perform compare with preferred id1/id2. If ids not available, fallback to q1/q2 name based compare
//   const performCompareByIds = async (id1, id2) => {
//     if (!id1 || !id2) {
//       setError('Both street IDs are required for comparison.');
//       return;
//     }
//     setLoading(true);
//     setError(null);

//     try {
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};

//       const res = await fetch(`${BASE_URL}api/streets/compare/?id1=${encodeURIComponent(id1)}&id2=${encodeURIComponent(id2)}`, { headers });
//       if (!res.ok) {
//         // fallback: if backend returns 404 or bad request, try name-based compare as a last resort
//         if (res.status === 404) throw new Error('One of the streets was not found for comparison.');
//         throw new Error('Failed to fetch comparison data');
//       }
//       const comp = await res.json();

//       // fetch amenities for both sides using returned ids (backend returns area1.id/area2.id)
//       const area1Id = comp?.area1?.id ?? id1;
//       const area2Id = comp?.area2?.id ?? id2;

//       const [amen1, amen2] = await Promise.all([fetchAmenitiesById(area1Id), fetchAmenitiesById(area2Id)]);

//       setComparisonData(comp);
//       setComparisonAmenities({ area1: amen1, area2: amen2 });
//       setShowComparison(true);

//       // scroll to results
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     } catch (err) {
//       console.error('performCompareByIds error:', err);
//       setError(err.message || 'Comparison failed');
//       setShowComparison(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // User pressed Enter in compare input — prefer selectedId, else attempt to find first match and compare by id,
//   // else fallback to name-based compare using q1/q2 endpoint.
//   const handleCompareSubmit = async (e) => {
//     e?.preventDefault?.();
//     if (!compareInput?.trim()) {
//       setError('Please enter a street name or pick a suggestion to compare.');
//       return;
//     }
//     setError(null);

//     if (compareSelectedId) {
//       return performCompareByIds(streetData?.id, compareSelectedId);
//     }

//     // Try to find a suggestion programmatically
//     const results = await searchStreets(compareInput);
//     if (results.length > 0) {
//       return performCompareByIds(streetData?.id, results[0].id);
//     }

//     // Last resort: name-based compare (q1/q2) — backend still supports this for backward compat
//     try {
//       setLoading(true);
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};
//       const res = await fetch(`${BASE_URL}api/streets/compare/?q1=${encodeURIComponent(streetData.street)}&q2=${encodeURIComponent(compareInput.trim())}`, { headers });
//       if (!res.ok) {
//         if (res.status === 404) throw new Error('Comparison street not found');
//         throw new Error('Comparison failed');
//       }
//       const comp = await res.json();
//       // fetch amenities using area names returned by compare (fallback)
//       const [amen1, amen2] = await Promise.all([fetchAmenitiesById(comp.area1.id || streetData.id), fetchAmenitiesById(comp.area2.id)]);
//       setComparisonData(comp);
//       setComparisonAmenities({ area1: amen1, area2: amen2 });
//       setShowComparison(true);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     } catch (err) {
//       console.error('fallback name compare error:', err);
//       setError(err.message || 'Comparison failed');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Utilities used by UI (counts, ratings, places lists)
//   const countAmenities = (category) => {
//     if (!streetData?.amenities) return 0;
//     if (category === 'transport') {
//       const transport = streetData.amenities.transports || {};
//       return Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
//     }
//     const apiKey = categoryToApiKey[category];
//     if (!apiKey) return 0;
//     return streetData.amenities[apiKey]?.length || 0;
//   };

//   const getCategoryRating = (categoryId, data = streetData) => {
//     if (!data?.attributes || !data.attributes[0]) return 0;
//     return data.attributes[0][categoryId] || 0;
//   };

//   // kept but prefixed to avoid lint warning (not used right now)
//   const _getNearbyPlaces = (category) => {
//     if (!streetData?.amenities) return [];
//     if (category === 'transport') {
//       const transport = streetData.amenities.transports || {};
//       return Object.values(transport).flat().slice(0, 5);
//     }
//     const apiKey = categoryToApiKey[category];
//     if (!apiKey) return [];
//     return streetData.amenities[apiKey]?.slice(0, 5) || [];
//   };

//   const getAllPlacesForCategory = (category, streetNameParam) => {
//     // If streetNameParam === streetData.street => return from streetData
//     if (!streetNameParam) return [];
//     if (streetNameParam === streetData?.street) {
//       if (category === 'transport') {
//         const transport = streetData.amenities?.transports || {};
//         return Object.values(transport).flat();
//       }
//       const apiKey = categoryToApiKey[category];
//       if (!apiKey) return [];
//       return streetData.amenities?.[apiKey] || [];
//     }

//     // If comparisonAmenities present, pick the correct one
//     if (comparisonAmenities) {
//       const amenities = streetNameParam === comparisonData?.area1.street ? comparisonAmenities.area1 : comparisonAmenities.area2;
//       if (category === 'transport') {
//         const transport = amenities?.transports || {};
//         return Object.values(transport).flat();
//       }
//       const apiKey = categoryToApiKey[category];
//       if (!apiKey) return [];
//       return amenities?.[apiKey] || [];
//     }

//     return [];
//   };

//   // Modals and UI helpers
//   const openCategoryModal = (category, streetName = '') => {
//     // Store current scroll position before opening modal
//     scrollPositionRef.current = window.scrollY;
//     setModalCategory(category);
//     setModalStreetName(streetName || streetData?.street || '');
//     setIsCategoryModalOpen(true);

//     // Prevent body scrolling when modal is open
//     document.body.style.overflow = 'hidden';
//   };

//   const closeCategoryModal = () => {
//     setIsCategoryModalOpen(false);
//     setModalCategory(null);
//     // Restore body scrolling
//     document.body.style.overflow = 'unset';

//     // Restore scroll position after a short delay to allow modal to close
//     setTimeout(() => {
//       window.scrollTo(0, scrollPositionRef.current);
//     }, 10);
//   };

//   // Remove the problematic useEffect for modal body class
//   useEffect(() => {
//     return () => {
//       // Cleanup: ensure body scrolling is restored when component unmounts
//       document.body.style.overflow = 'unset';
//     };
//   }, []);

//   useEffect(() => {
//     if (showComparison) {
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   }, [showComparison]);

//   // regenerate AI summaries when street or comparison changes
//   useEffect(() => {
//     if (!streetData) return;
//     const t = setTimeout(() => {
//       fetchAISummaries();
//     }, 150);
//     return () => clearTimeout(t);
//   }, [fetchAISummaries]);

//   function getScoreClass(score) {
//     if (score < 8) return 'low';
//     if (score < 9) return 'medium';
//     return 'high';
//   }

//   // UI components: PlaceItem, StreetDetailCard, modal renderer
//   const PlaceItem = ({ place, category, startCoords }) => {
//     // startCoords should be an object with { lat, lon }
//     const endLat = place.latitude ?? place.lat ?? place.location_lat ?? null;
//     const endLon = place.longitude ?? place.lon ?? place.location_lon ?? null;

//     const startLat = startCoords?.lat ?? null;
//     const startLon = startCoords?.lon ?? null;

//     const directionsUrl = buildDirectionsUrl({ startLat, startLon, endLat, endLon });

//     return (
//       <div className="place-item">
//         <div className="place-name">
//           {category === 'transport' && place.stop_type && (
//             <span className="transport-icon">{transportIcons[place.stop_type] || transportIcons.default}</span>
//           )}
//           {place.name}
//         </div>
//         {place.final_rating && <div className="place-rating">Rating: {place.final_rating}</div>}
//         <div className="place-links">
//           {endLat && endLon && (
//             <a href={directionsUrl} target="_blank" rel="noopener noreferrer" className="map-link">View on Map</a>
//           )}
//         </div>
//       </div>
//     );
//   };

//   const StreetDetailCard = ({ street, amenities, overallScore, top3, streetType = 'primary' }) => {
//     const streetNameShort = (typeof street === 'string') ? street.split(',')[0] : '';
//     const postcode = amenities?.street?.postcode || 'London';

//     const totalAmenities = Object.keys(amenities || {})
//       .filter(key => key !== 'street')
//       .reduce((total, key) => {
//         if (key === 'transports') {
//           const transport = amenities.transports || {};
//           return total + Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
//         }
//         return total + (amenities[key]?.length || 0);
//       }, 0);

//     // Determine CSS class based on streetType
//     const streetColorClass = streetType === 'primary' ? 'primary-street' : 'comparison-street';

//     return (
//       <div className="street-detail-card">
//         <div className="location-info">
//           <h2 className={streetColorClass}>{streetNameShort}</h2> {/* Add color class here */}
//           <p>{postcode}</p>
//         </div>

//         <div className="scores-container">
//           <div className="score-item main-score">
//             <div className={`score-value ${streetColorClass}`}>{overallScore}/100</div> {/* Add color class here */}
//             <div className="score-label">Lifestyle Score</div>
//           </div>
//         </div>

//         <div className="top-3-inline">
//           <h3 className="subsection-title">Top 3 Amenity Categories</h3>
//           <ul className="top3-list">
//             {(top3 || []).map((attr, i) => {
//               const key = attr.name.toLowerCase();
//               const cat = amenityCategories.find(c => c.id === key);
//               const icon = cat ? cat.icon : '📍';
//               const label = cat ? cat.name : attr.name;
//               const score = +attr.score.toFixed(1);
//               const pct = (score / 10) * 100;
//               const cls = getScoreClass(score);

//               return (
//                 <li key={i} className="top3-item" style={{ '--i': i }}>
//                   <span className="top3-icon">{icon}</span>
//                   <span className="top3-label">{label}</span>
//                   <div className="top3-bar">
//                     <div className={`top3-fill ${cls}`} style={{ width: `${pct}%` }} />
//                   </div>
//                   <span className="top3-score">{score}/10</span>
//                 </li>
//               );
//             })}
//           </ul>
//         </div>

//         <div className="stats-container">
//           <div className="stat-item">
//             <div className="stat-value">{totalAmenities}</div>
//             <div className="stat-label">Total Amenities</div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderModal = () => {
//     if (!isCategoryModalOpen || !modalCategory) return null;

//     // Determine start coords for primary and comparison columns
//     const primaryStreetCoords = extractLatLonFromStreetObj(streetData?.amenities?.street || {});
//     const comparisonStreetCoords = comparisonAmenities ? extractLatLonFromStreetObj(comparisonAmenities.area2?.street || {}) : { lat: null, lon: null };

//     return ReactDOM.createPortal(
//       <div className="modal-overlay">
//         <div
//           className="places-modal compare"
//           ref={modalRef}
//           onClick={(e) => e.stopPropagation()}
//         >
//           <div className="modal-header">
//             <h3>{amenityCategories.find(cat => cat.id === modalCategory)?.name || modalCategory}</h3>
//             <div className="modal-subtitle">
//               {showComparison && comparisonData && (
//                 <></>
//               )}
//             </div>
//             <button
//               className="close-detail"
//               onClick={closeCategoryModal}
//               aria-label="Close"
//             >
//               ×
//             </button>
//           </div>

//           <div className="modal-stats">
//             <div className="stat-group">
//               <div className="stat-label">Performance Score</div>
//               <div className="stat-value">{getCategoryRating(modalCategory).toFixed(1)}/10</div>
//             </div>
//             <p className="scoring-note">
//               Each amenity is scored based on a combination of proximity and quality.
//             </p>
//           </div>

//           <div className="modal-content compare">
//             <div className="modal-column">
//               <h4 className="primary-street">{streetData?.street?.split(',')[0]}</h4>
//               <div className="places-scrollable">
//                 {getAllPlacesForCategory(modalCategory, streetData?.street).length > 0 ? (
//                   getAllPlacesForCategory(modalCategory, streetData?.street).map((place, index) => (
//                     <PlaceItem key={index} place={place} category={modalCategory} startCoords={primaryStreetCoords} />
//                   ))
//                 ) : (
//                   <div className="no-places-message">No places found in this category</div>
//                 )}
//               </div>
//             </div>

//             {showComparison && comparisonData && (
//               <div className="modal-column">
//                 <h4 className="comparison-street">{comparisonData.area2.street.split(',')[0]}</h4>
//                 <div className="places-scrollable">
//                   {getAllPlacesForCategory(modalCategory, comparisonData.area2.street).length > 0 ? (
//                     getAllPlacesForCategory(modalCategory, comparisonData.area2.street).map((place, index) => (
//                       <PlaceItem key={index} place={place} category={modalCategory} startCoords={comparisonStreetCoords} />
//                     ))
//                   ) : (
//                     <div className="no-places-message">No places found in this category</div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>,
//       document.body
//     );
//   };

//   // Loading & error handling
//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="loading-spinner" />
//         <p>Loading street data...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return <ErrorComponent error={error} onRetry={() => { setError(null); setLoading(true); }} />;
//   }

//   if (!streetData) {
//     return <ErrorComponent error="No Data Available" onRetry={() => { setError(null); setLoading(true); }} />;
//   }

//   // Main render
//   return (
//     <>
//       {!isCategoryModalOpen && (
//         <div className="analysis-container">
//           <header className="analysis-header">
//             <button onClick={() => {
//               if (showComparison) {
//                 setShowComparison(false);
//                 navigate(`/analysis?street_id=${encodeURIComponent(streetData.id)}`, { replace: true });
//               } else {
//                 navigate(-1);
//               }
//             }} className="back-button">← Back</button>
//           </header>

//           <section className={`detailed-analysis-compare ${showComparison ? 'two-cards' : ''}`}>
//             <StreetDetailCard
//               street={streetData.street}
//               amenities={streetData.amenities}
//               overallScore={streetData.overall_score}
//               top3={streetData.top_3_attributes}
//               streetType="primary" // This makes it blue
//             />

//             {showComparison && comparisonData && (
//               <StreetDetailCard
//                 street={comparisonData.area2.street}
//                 amenities={comparisonAmenities?.area2}
//                 overallScore={comparisonData.area2.overall_score}
//                 top3={comparisonData.area2.top_3_attributes}
//                 streetType="comparison" // This makes it green
//               />
//             )}
//           </section>

//           <section className="compare-area">
//             <h2 className="section-title">Compare with Another Area</h2>
//             <div className="compare-card">
//               <div className="input-group" ref={compareRef} style={{ position: 'relative' }}>
//                 <input
//                   type="text"
//                   placeholder="Enter street name"
//                   className="compare-input"
//                   value={compareInput}
//                   onChange={(e) => {
//                     setCompareInput(e.target.value);
//                     setCompareSelectedId(null);
//                     setShowCompareSuggestions(true);
//                     setError(null);
//                   }}
//                   onKeyDown={(e) => {
//                     if (e.key === 'Enter') handleCompareSubmit(e);
//                     if (e.key === 'Escape') {
//                       setShowCompareSuggestions(false);
//                     }
//                   }}
//                 />
//                 <button className="compare-button" onClick={handleCompareSubmit}>Compare Areas</button>

//                 {/* Suggestions dropdown */}
//                 {showCompareSuggestions && compareSuggestions.length > 0 && (
//                   <div className="suggestions-dropdown compare-suggestions">
//                     {compareSuggestions.map(s => (
//                       <div key={s.id} className="suggestion-item" onClick={() => handleCompareSuggestionClick(s)}>
//                         <div className="suggestion-name">{s.name}</div>
//                         <div className="suggestion-postcode">{s.postcode}</div>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               <p className="compare-description">Compare {streetData.street.split(',')[0]} with any other area to see side-by-side amenity analysis</p>
//             </div>
//           </section>

//           {showComparison && comparisonData && (
//             <>
//               <section className="comparison-results">
//                 <h2 className="section-title">Comparison Results</h2>

//                 <div className="attribute-comparison">
//                   <h3>Attribute Scores</h3>
//                   <div className="attribute-grid">
//                     {Object.entries(comparisonData.area1.attributes).map(([attr, score]) => (
//                       <div key={attr} className="attribute-item">
//                         <div className="attribute-name">{amenityCategories.find(c => c.id === attr)?.name || attr}</div>
//                         <div className="attribute-scores">
//                           <span className="score1 primary-street">{score}</span> {/* Add class */}
//                           <span className="score-divider">:</span>
//                           <span className="score2 comparison-street">{comparisonData.area2.attributes[attr]}</span> {/* Add class */}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <button className="close-comparison" onClick={() => setShowComparison(false)}>Close Comparison</button>
//               </section>

//               <section className="amenity-comparison-container">
//                 <h2 className="section-title comparison-title">Amenity Comparison</h2>
//                 <p className="comparison-description">
//                   Scores are based on proximity and quality of amenities.
//                 </p>
//                 <div className="categories-grid comparison">
//                   {amenityCategories.map(category => {
//                     const street1Count = countAmenities(category.id);
//                     const street1Score = getCategoryRating(category.id);
//                     const street2Count = comparisonData.area2.category_counts[category.id] || 0;
//                     const street2Score = comparisonData.area2.attributes[category.id] || 0;

//                     if (street1Count === 0 && street2Count === 0) return null;

//                     return (
//                       <div key={category.id} className="category-card comparison" onClick={() => openCategoryModal(category.id)}>
//                         <div className="category-header">
//                           <div className="category-icon">{category.icon}</div>
//                           <h3 className="category-name">{category.name}</h3>
//                         </div>

//                         <div className="street-comparison">
//                           <div className="street-row">
//                             <div className="street-name primary-street">{comparisonData.area1.street.split(',')[0]}</div> {/* Add class */}
//                             <div className="score-display">
//                               <div className="street-score primary-street">{street1Score.toFixed(1)}/10</div> {/* Add class */}
//                               <div className="street-count">({street1Count} locations)</div>
//                             </div>
//                           </div>

//                           <div className="street-row">
//                             <div className="street-name comparison-street">{comparisonData.area2.street.split(',')[0]}</div> {/* Add class */}
//                             <div className="score-display">
//                               <div className="street-score comparison-street">{street2Score.toFixed(1)}/10</div> {/* Add class */}
//                               <div className="street-count">({street2Count} locations)</div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </section>
//             </>
//           )}

//           {!showComparison && (
//             <section className="amenity-categories">
//               <h2 className="section-title">All Amenity Categories</h2>
//               <div className="categories-grid">
//                 {amenityCategories.map(category => {
//                   const count = countAmenities(category.id);
//                   if (count === 0) return null;
//                   const score = getCategoryRating(category.id);

//                   return (
//                     <div key={category.id} className="category-card" onClick={() => openCategoryModal(category.id)}>
//                       <div className="category-header">
//                         <div className="category-icon">{category.icon}</div>
//                         <h3 className="category-name">{category.name}</h3>
//                       </div>
//                       <div className="street-row">
//                         <div className="score-display">
//                           <div className="street-score primary-street">{score.toFixed(1)}/10</div> {/* Add class */}
//                           <div className="street-count">({count} {count === 1 ? 'location' : 'locations'})</div>
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </section>
//           )}

//           <section className="recommendations">
//             <h2 className="section-title">Area Insights & Recommendations</h2>

//             <div style={{ marginBottom: 16 }}>
//               <div style={{ display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'space-between' }}>
//                 <div style={{ fontWeight: 600 }}>AI Insights</div>
//                 <div>
//                   <button className="view-locations" onClick={fetchAISummaries} disabled={aiLoading}>
//                     {aiLoading ? 'Generating…' : 'Regenerate AI Summaries'}
//                   </button>
//                 </div>
//               </div>
//               {aiError && <div style={{ color: 'red', marginTop: 8 }}>Error: {aiError}</div>}
//             </div>

//             {/* Single-street summary */}
//             {!showComparison && (
//               <div className="ai-summary-card" style={{ marginBottom: 20 }}>
//                 <h3 className="subsection-title">High-level Summary</h3>
//                 {aiSummaries.area1 ? (
//                   <>
//                     <p className="ai-summary-text">{aiSummaries.area1.summary}</p>
//                     {aiSummaries.area1.valuation && <p><strong>Valuation:</strong> {aiSummaries.area1.valuation}</p>}
//                     <ul>
//                       {(aiSummaries.area1.lifestyle || []).map((b, i) => <li key={i}>{b}</li>)}
//                     </ul>
//                   </>
//                 ) : (
//                   <p>{aiLoading ? 'Generating summary…' : 'Summary will appear here.'}</p>
//                 )}
//               </div>
//             )}

//             {/* Comparison summaries */}
//             {showComparison && comparisonData && (
//               <div className="ai-comparison-wrapper" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
//                 <div className="ai-summary-card">
//                   <h4>{comparisonData.area1.street.split(',')[0]} — Summary</h4>
//                   {aiSummaries.area1 ? (
//                     <>
//                       <p>{aiSummaries.area1.summary}</p>
//                       <p><strong>Valuation:</strong> {aiSummaries.area1.valuation}</p>
//                       <ul>{(aiSummaries.area1.lifestyle || []).map((b, i) => <li key={i}>{b}</li>)}</ul>
//                     </>
//                   ) : <p>{aiLoading ? 'Generating…' : '—'}</p>}
//                 </div>

//                 <div className="ai-summary-card">
//                   <h4>{comparisonData.area2.street.split(',')[0]} — Summary</h4>
//                   {aiSummaries.area2 ? (
//                     <>
//                       <p>{aiSummaries.area2.summary}</p>
//                       <p><strong>Valuation:</strong> {aiSummaries.area2.valuation}</p>
//                       <ul>{(aiSummaries.area2.lifestyle || []).map((b, i) => <li key={i}>{b}</li>)}</ul>
//                     </>
//                   ) : <p>{aiLoading ? 'Generating…' : '—'}</p>}
//                 </div>

//                 <div className="ai-summary-card">
//                   <h4>Light Comparative Summary</h4>
//                   {aiSummaries.comparison ? (
//                     <>
//                       <p>{aiSummaries.comparison.summary}</p>
//                       <p><strong>Valuation comparison:</strong> {aiSummaries.comparison.valuation}</p>
//                       <ul>{(aiSummaries.comparison.differences || []).map((d, i) => <li key={i}>{d}</li>)}</ul>
//                     </>
//                   ) : <p>{aiLoading ? 'Generating comparison…' : '—'}</p>}
//                 </div>
//               </div>
//             )}

//             {/* Keep your old recommendation cards if you want */}
//             <div className="recommendation-cards" style={{ marginTop: 20 }}>
//               <div className="recommendation-card"><div className="card-icon">🚆</div><h4>Excellent for Commuters</h4><p>AI-generated insights coming soon</p></div>
//               <div className="recommendation-card"><div className="card-icon">🍽️</div><h4>Food & Entertainment Hub</h4><p>AI-generated insights coming soon</p></div>
//               <div className="recommendation-card"><div className="card-icon">🛍️</div><h4>Shopping Destination</h4><p>AI-generated insights coming soon</p></div>
//             </div>
//           </section>

//         </div>
//       )}
//       {renderModal()}
//     </>
//   );
// };

// export default StreetAnalysis;



// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
// import './AnalysisPage.css';
// import { BASE_URL } from '../constants';
// import ReactDOM from 'react-dom';
// import ErrorComponent from '../components/ErrorComponent';

// const StreetAnalysis = () => {
//   useEffect(() => { window.scrollTo(0, 0); }, []);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user } = useAuth();

//   // Primary data
//   const [streetData, setStreetData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // UI / comparison state
//   // prefixed unused state variables with _ to silence lint while keeping setters available
//   const [_activeCategory, setActiveCategory] = useState(null);
//   const [compareInput, setCompareInput] = useState('');
//   const [compareSuggestions, setCompareSuggestions] = useState([]);
//   const [showCompareSuggestions, setShowCompareSuggestions] = useState(false);
//   const [_compareLoading, setCompareLoading] = useState(false);
//   const [compareSelectedId, setCompareSelectedId] = useState(null); // id selected from suggestions
//   const [comparisonData, setComparisonData] = useState(null);
//   const [comparisonAmenities, setComparisonAmenities] = useState(null);
//   const [showComparison, setShowComparison] = useState(false);

//   // modal state
//   const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
//   const [modalCategory, setModalCategory] = useState(null);
//   const [_modalStreetName, setModalStreetName] = useState('');

//   // AI summaries state
//   const [aiSummaries, setAiSummaries] = useState({
//     area1: null,
//     area2: null,
//     comparison: null,
//   });
//   const [aiLoading, setAiLoading] = useState(false);
//   const [aiError, setAiError] = useState(null);

//   const compareRef = useRef(null); // to close suggestions on outside click
//   const scrollPositionRef = useRef(0); // to remember scroll position when modal opens
//   const modalRef = useRef(null); // reference to the modal for click outside detection

//   // accept both 'street_id' and 'id' query params for compatibility
//   const queryParams = new URLSearchParams(location.search);
//   const streetIdFromUrl = queryParams.get('street_id') || queryParams.get('id') || null;

//   // left in but prefixed to silence unused-var lint (you can remove if not needed)
//   const _BAR_COLORS = {
//     Education: '#34D169',
//     Transport: '#3B82F6',
//     'Parks & Recreation': '#F59E0B',
//   };

//   const amenityCategories = [
//     { id: 'school', name: 'School', icon: '🏫' },
//     { id: 'university', name: 'University', icon: '🎓' },
//     { id: 'library', name: 'Library', icon: '📚' },
//     { id: 'hospital', name: 'Hospital', icon: '🏥' },
//     { id: 'doctor', name: 'Doctor', icon: '👨‍⚕️' },
//     { id: 'pharmacy', name: 'Pharmacy', icon: '💊' },
//     { id: 'restaurant', name: 'Restaurant', icon: '🍽️' },
//     { id: 'cafe', name: 'Café', icon: '☕' },
//     { id: 'bakery', name: 'Bakery', icon: '🥐' },
//     { id: 'bar', name: 'Bar', icon: '🍻' },
//     { id: 'grocery_or_supermarket', name: 'Grocery Store', icon: '🛒' },
//     { id: 'supermarket', name: 'Supermarket', icon: '🛍️' },
//     { id: 'bank', name: 'Bank', icon: '🏦' },
//     { id: 'atm', name: 'ATM', icon: '💳' },
//     { id: 'post_office', name: 'Post Office', icon: '📮' },
//     { id: 'gas_station', name: 'Petrol Station', icon: '⛽' },
//     { id: 'airport', name: 'Airport', icon: '✈️' },
//     { id: 'electric_vehicle_charging_station', name: 'EV Charging', icon: '🔌' },
//     { id: 'transport', name: 'Transport', icon: '🚆' },
//     { id: 'park', name: 'Park', icon: '🌳' },
//     { id: 'gym', name: 'Gym', icon: '💪' },
//     { id: 'stadium', name: 'Stadium', icon: '🏟️' },
//     { id: 'museum', name: 'Museum', icon: '🏛️' },
//     { id: 'art_gallery', name: 'Art Gallery', icon: '🎨' },
//     { id: 'movie_theater', name: 'Cinema', icon: '🎬' },
//   ];

//   const categoryToApiKey = {
//     school: 'schools',
//     university: 'university',
//     library: 'library',
//     hospital: 'hospitals',
//     doctor: 'doctor',
//     pharmacy: 'pharmacies',
//     restaurant: 'restaurants',
//     cafe: 'cafe',
//     bakery: 'bakery',
//     bar: 'bar',
//     grocery_or_supermarket: 'grocery_or_supermarket',
//     supermarket: 'supermarket',
//     bank: 'banks',
//     atm: 'atm',
//     post_office: 'post_office',
//     gas_station: 'gas_station',
//     park: 'park',
//     gym: 'gym',
//     stadium: 'stadium',
//     museum: 'museum',
//     art_gallery: 'art_gallery',
//     movie_theater: 'movie_theater',
//     airport: 'airport',
//     electric_vehicle_charging_station: 'electric_vehicle_charging_station',
//     transport: 'transports'
//   };

//   const transportIcons = {
//     bikepoint: '🚲', bus: '🚌', dlr: '🚈',
//     'national-rail': '🚆', overground: '🚇', tube: '🚇',
//     tram: '🚊', ferry: '⛴️', cable_car: '🚡', default: '📍'
//   };

//   // -------------------------
//   // New helpers for directions
//   // -------------------------
//   const buildDirectionsUrl = ({ startLat, startLon, endLat, endLon }) => {
//     // If any of the start or end coords are missing, fallback to a simple place query
//     const hasStart = startLat !== undefined && startLon !== undefined && startLat !== null && startLon !== null;
//     const hasEnd = endLat !== undefined && endLon !== undefined && endLat !== null && endLon !== null;

//     if (!hasEnd) return '#';

//     if (!hasStart) {
//       // Open end place in Maps if we don't have origin coords
//       return `https://maps.google.com/?q=${encodeURIComponent(endLat + ',' + endLon)}`;
//     }

//     // Normal directions URL
//     const origin = `${startLat},${startLon}`;
//     const destination = `${endLat},${endLon}`;
//     return `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}`;
//   };

//   const extractLatLonFromStreetObj = (streetObj) => {
//     if (!streetObj) return { lat: null, lon: null };
//     // Accept multiple possible field names returned by backend
//     const lat = streetObj.latitude ?? streetObj.lat ?? streetObj.location_lat ?? null;
//     const lon = streetObj.longitude ?? streetObj.lon ?? streetObj.lng ?? streetObj.location_lon ?? null;
//     return { lat, lon };
//   };

//   // kept but prefixed to avoid lint warning (not used right now)
//   const _getStreetCoordsForName = (streetName) => {
//     if (streetName === streetData?.street) {
//       return extractLatLonFromStreetObj(streetData?.amenities?.street || {});
//     }

//     if (comparisonAmenities && comparisonData) {
//       if (streetName === comparisonData.area1.street) {
//         return extractLatLonFromStreetObj(comparisonAmenities.area1?.street || {});
//       }
//       if (streetName === comparisonData.area2.street) {
//         return extractLatLonFromStreetObj(comparisonAmenities.area2?.street || {});
//       }
//     }

//     return { lat: null, lon: null };
//   };

//   // Close compare suggestions when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (compareRef.current && !compareRef.current.contains(e.target)) {
//         setShowCompareSuggestions(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   // Handle click outside modal
//   useEffect(() => {
//     const handleClickOutsideModal = (e) => {
//       if (isCategoryModalOpen && modalRef.current && !modalRef.current.contains(e.target)) {
//         closeCategoryModal();
//       }
//     };

//     const handleEscapeKey = (e) => {
//       if (isCategoryModalOpen && e.key === 'Escape') {
//         closeCategoryModal();
//       }
//     };

//     if (isCategoryModalOpen) {
//       document.addEventListener('mousedown', handleClickOutsideModal);
//       document.addEventListener('keydown', handleEscapeKey);
//     }

//     return () => {
//       document.removeEventListener('mousedown', handleClickOutsideModal);
//       document.removeEventListener('keydown', handleEscapeKey);
//     };
//   }, [isCategoryModalOpen]);

//   // Fetch main street rating + amenities using street_id
//   useEffect(() => {
//     const fetchStreet = async () => {
//       if (!streetIdFromUrl) {
//         navigate('/');
//         return;
//       }
//       setLoading(true);
//       setError(null);

//       try {
//         const token = localStorage.getItem('token');
//         const headers = token ? { Authorization: `Token ${token}` } : {};

//         // rating-summary expects street_id param (your backend)
//         const ratingRes = await fetch(
//           `${BASE_URL}api/streets/rating-summary/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
//           { headers }
//         );
//         if (!ratingRes.ok) throw new Error('Failed to fetch rating summary');
//         const ratingJson = await ratingRes.json();

//         // places-by-name supports street_id (preferred)
//         const placesRes = await fetch(
//           `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
//           { headers }
//         );
//         if (!placesRes.ok) throw new Error('Failed to fetch amenities');
//         const placesJson = await placesRes.json();

//         // Combine and keep rating id too
//         setStreetData({
//           id: ratingJson.id ?? streetIdFromUrl,
//           ...ratingJson,
//           amenities: placesJson,
//         });

//         if (ratingJson.top_3_attributes?.length > 0) {
//           setActiveCategory(ratingJson.top_3_attributes[0].name);
//         }
//       } catch (err) {
//         console.error(err);
//         setError(err.message || 'Failed to load street data');
//       } finally {
//         setLoading(false);
//       }
//     };

//     // only fetch when user is present (your pattern) — if you want public access, remove user guard
//     if (user && streetIdFromUrl) fetchStreet();
//     else setLoading(false);
//   }, [user, streetIdFromUrl, navigate]);

//   // Helper: fetch amenities by street id (uses street_id param)
//   const fetchAmenitiesById = async (id) => {
//     try {
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};
//       const res = await fetch(
//         `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(id)}`,
//         { headers }
//       );
//       if (!res.ok) throw new Error('Failed to fetch amenities');
//       return await res.json();
//     } catch (err) {
//       console.error('fetchAmenitiesById error:', err);
//       return { transports: {}, categories: {} };
//     }
//   };

// const fetchAISummaries = useCallback(async () => {
//   if (!streetData) return;
//   setAiLoading(true);
//   setAiError(null);

//   try {
//     const payload = {
//       area1: {
//         name: streetData.street,
//         overall_score: streetData.overall_score,
//         amenities: streetData.top_3_attributes || []
//       }
//     };

//     if (showComparison && comparisonData) {
//       payload.area2 = {
//         name: comparisonData.area2.street,
//         overall_score: comparisonData.area2.overall_score,
//         amenities: comparisonData.area2.top_3_attributes || []
//       };
//     }

//     const res = await fetch(`${BASE_URL}api/ai/summary/`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payload)
//     });

//     if (!res.ok) throw new Error("Failed to fetch AI summary");

//     const data = await res.json();

//     // -------------------------
//     // RAW fallback (bad JSON from Claude)
//     // -------------------------
//     if (data.raw) {
//       setAiSummaries({
//         area1: { summary: data.raw },
//         area2: null,
//         comparison: null
//       });
//       return;
//     }

//     // -------------------------
//     // COMPARISON MODE
//     // -------------------------
//     if (data.area1 && data.area2 && data.comparison) {
//       setAiSummaries({
//         area1: data.area1,
//         area2: data.area2,
//         comparison: data.comparison
//       });
//       return;
//     }

//     // -------------------------
//     // SINGLE STREET MODE
//     // -------------------------
//     if (
//       data.one_liner ||
//       data.summary ||
//       data.highlights ||
//       data.history
//     ) {
//       setAiSummaries({
//         area1: data,
//         area2: null,
//         comparison: null
//       });
//       return;
//     }

//     // -------------------------
//     // FINAL FALLBACK
//     // -------------------------
//     setAiSummaries({
//       area1: { summary: JSON.stringify(data) },
//       area2: null,
//       comparison: null
//     });

//   } catch (err) {
//     console.error("AI Summary Error:", err);
//     setAiError(err.message);
//   } finally {
//     setAiLoading(false);
//   }
// }, [streetData, showComparison, comparisonData]);


//   // Helper: search streets for compare suggestions
//   const searchStreets = async (q) => {
//     try {
//       if (!q || !q.trim()) return [];
//       setCompareLoading(true);
//       const res = await fetch(`${BASE_URL}api/streets/search-streets/?q=${encodeURIComponent(q.trim())}`);
//       if (!res.ok) return [];
//       const data = await res.json(); // expects [{id,name,postcode}, ...]
//       return Array.isArray(data) ? data : [];
//     } catch (err) {
//       console.error('searchStreets error:', err);
//       return [];
//     } finally {
//       setCompareLoading(false);
//     }
//   };

//   // Debounce compare input to fetch suggestions
//   useEffect(() => {
//     if (!compareInput) {
//       setCompareSuggestions([]);
//       setShowCompareSuggestions(false);
//       setCompareSelectedId(null);
//       return;
//     }
//     const t = setTimeout(async () => {
//       const results = await searchStreets(compareInput);
//       setCompareSuggestions(results);
//       setShowCompareSuggestions(results.length > 0);
//     }, 300);
//     return () => clearTimeout(t);
//   }, [compareInput]);

//   // When user clicks a suggestion — set input, set selected id and immediately compare
//   const handleCompareSuggestionClick = async (suggestion) => {
//     setCompareInput(suggestion.name);
//     setCompareSelectedId(suggestion.id);
//     setShowCompareSuggestions(false);

//     // trigger compare by id (preferred)
//     await performCompareByIds(streetData?.id, suggestion.id);
//   };

//   // Perform compare with preferred id1/id2. If ids not available, fallback to q1/q2 name based compare
//   const performCompareByIds = async (id1, id2) => {
//     if (!id1 || !id2) {
//       setError('Both street IDs are required for comparison.');
//       return;
//     }
//     setLoading(true);
//     setError(null);

//     try {
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};

//       const res = await fetch(`${BASE_URL}api/streets/compare/?id1=${encodeURIComponent(id1)}&id2=${encodeURIComponent(id2)}`, { headers });
//       if (!res.ok) {
//         // fallback: if backend returns 404 or bad request, try name-based compare as a last resort
//         if (res.status === 404) throw new Error('One of the streets was not found for comparison.');
//         throw new Error('Failed to fetch comparison data');
//       }
//       const comp = await res.json();

//       // fetch amenities for both sides using returned ids (backend returns area1.id/area2.id)
//       const area1Id = comp?.area1?.id ?? id1;
//       const area2Id = comp?.area2?.id ?? id2;

//       const [amen1, amen2] = await Promise.all([fetchAmenitiesById(area1Id), fetchAmenitiesById(area2Id)]);

//       setComparisonData(comp);
//       setComparisonAmenities({ area1: amen1, area2: amen2 });
//       setShowComparison(true);

//       // scroll to results
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     } catch (err) {
//       console.error('performCompareByIds error:', err);
//       setError(err.message || 'Comparison failed');
//       setShowComparison(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // User pressed Enter in compare input — prefer selectedId, else attempt to find first match and compare by id,
//   // else fallback to name-based compare using q1/q2 endpoint.
//   const handleCompareSubmit = async (e) => {
//     e?.preventDefault?.();
//     if (!compareInput?.trim()) {
//       setError('Please enter a street name or pick a suggestion to compare.');
//       return;
//     }
//     setError(null);

//     if (compareSelectedId) {
//       return performCompareByIds(streetData?.id, compareSelectedId);
//     }

//     // Try to find a suggestion programmatically
//     const results = await searchStreets(compareInput);
//     if (results.length > 0) {
//       return performCompareByIds(streetData?.id, results[0].id);
//     }

//     // Last resort: name-based compare (q1/q2) — backend still supports this for backward compat
//     try {
//       setLoading(true);
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};
//       const res = await fetch(`${BASE_URL}api/streets/compare/?q1=${encodeURIComponent(streetData.street)}&q2=${encodeURIComponent(compareInput.trim())}`, { headers });
//       if (!res.ok) {
//         if (res.status === 404) throw new Error('Comparison street not found');
//         throw new Error('Comparison failed');
//       }
//       const comp = await res.json();
//       // fetch amenities using area names returned by compare (fallback)
//       const [amen1, amen2] = await Promise.all([fetchAmenitiesById(comp.area1.id || streetData.id), fetchAmenitiesById(comp.area2.id)]);
//       setComparisonData(comp);
//       setComparisonAmenities({ area1: amen1, area2: amen2 });
//       setShowComparison(true);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     } catch (err) {
//       console.error('fallback name compare error:', err);
//       setError(err.message || 'Comparison failed');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Utilities used by UI (counts, ratings, places lists)
//   const countAmenities = (category) => {
//     if (!streetData?.amenities) return 0;
//     if (category === 'transport') {
//       const transport = streetData.amenities.transports || {};
//       return Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
//     }
//     const apiKey = categoryToApiKey[category];
//     if (!apiKey) return 0;
//     return streetData.amenities[apiKey]?.length || 0;
//   };

//   const getCategoryRating = (categoryId, data = streetData) => {
//     if (!data?.attributes || !data.attributes[0]) return 0;
//     return data.attributes[0][categoryId] || 0;
//   };

//   // kept but prefixed to avoid lint warning (not used right now)
//   const _getNearbyPlaces = (category) => {
//     if (!streetData?.amenities) return [];
//     if (category === 'transport') {
//       const transport = streetData.amenities.transports || {};
//       return Object.values(transport).flat().slice(0, 5);
//     }
//     const apiKey = categoryToApiKey[category];
//     if (!apiKey) return [];
//     return streetData.amenities[apiKey]?.slice(0, 5) || [];
//   };

//   const getAllPlacesForCategory = (category, streetNameParam) => {
//     // If streetNameParam === streetData.street => return from streetData
//     if (!streetNameParam) return [];
//     if (streetNameParam === streetData?.street) {
//       if (category === 'transport') {
//         const transport = streetData.amenities?.transports || {};
//         return Object.values(transport).flat();
//       }
//       const apiKey = categoryToApiKey[category];
//       if (!apiKey) return [];
//       return streetData.amenities?.[apiKey] || [];
//     }

//     // If comparisonAmenities present, pick the correct one
//     if (comparisonAmenities) {
//       const amenities = streetNameParam === comparisonData?.area1.street ? comparisonAmenities.area1 : comparisonAmenities.area2;
//       if (category === 'transport') {
//         const transport = amenities?.transports || {};
//         return Object.values(transport).flat();
//       }
//       const apiKey = categoryToApiKey[category];
//       if (!apiKey) return [];
//       return amenities?.[apiKey] || [];
//     }

//     return [];
//   };

//   // Modals and UI helpers
//   const openCategoryModal = (category, streetName = '') => {
//     // Store current scroll position before opening modal
//     scrollPositionRef.current = window.scrollY;
//     setModalCategory(category);
//     setModalStreetName(streetName || streetData?.street || '');
//     setIsCategoryModalOpen(true);

//     // Prevent body scrolling when modal is open
//     document.body.style.overflow = 'hidden';
//   };

//   const closeCategoryModal = () => {
//     setIsCategoryModalOpen(false);
//     setModalCategory(null);
//     // Restore body scrolling
//     document.body.style.overflow = 'unset';

//     // Restore scroll position after a short delay to allow modal to close
//     setTimeout(() => {
//       window.scrollTo(0, scrollPositionRef.current);
//     }, 10);
//   };

//   // Remove the problematic useEffect for modal body class
//   useEffect(() => {
//     return () => {
//       // Cleanup: ensure body scrolling is restored when component unmounts
//       document.body.style.overflow = 'unset';
//     };
//   }, []);

//   useEffect(() => {
//     if (showComparison) {
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   }, [showComparison]);

//   // regenerate AI summaries when street or comparison changes
//   useEffect(() => {
//     if (!streetData) return;
//     const t = setTimeout(() => {
//       fetchAISummaries();
//     }, 150);
//     return () => clearTimeout(t);
//   }, [fetchAISummaries]);

//   function getScoreClass(score) {
//     if (score < 8) return 'low';
//     if (score < 9) return 'medium';
//     return 'high';
//   }

//   // UI components: PlaceItem, StreetDetailCard, modal renderer
//   const PlaceItem = ({ place, category, startCoords }) => {
//     // startCoords should be an object with { lat, lon }
//     const endLat = place.latitude ?? place.lat ?? place.location_lat ?? null;
//     const endLon = place.longitude ?? place.lon ?? place.location_lon ?? null;

//     const startLat = startCoords?.lat ?? null;
//     const startLon = startCoords?.lon ?? null;

//     const directionsUrl = buildDirectionsUrl({ startLat, startLon, endLat, endLon });

//     return (
//       <div className="place-item">
//         <div className="place-name">
//           {category === 'transport' && place.stop_type && (
//             <span className="transport-icon">{transportIcons[place.stop_type] || transportIcons.default}</span>
//           )}
//           {place.name}
//         </div>
//         {place.final_rating && <div className="place-rating">Rating: {place.final_rating}</div>}
//         <div className="place-links">
//           {endLat && endLon && (
//             <a href={directionsUrl} target="_blank" rel="noopener noreferrer" className="map-link">View on Map</a>
//           )}
//         </div>
//       </div>
//     );
//   };

//   const StreetDetailCard = ({ street, amenities, overallScore, top3, streetType = 'primary' }) => {
//     const streetNameShort = (typeof street === 'string') ? street.split(',')[0] : '';
//     const postcode = amenities?.street?.postcode || 'London';

//     const totalAmenities = Object.keys(amenities || {})
//       .filter(key => key !== 'street')
//       .reduce((total, key) => {
//         if (key === 'transports') {
//           const transport = amenities.transports || {};
//           return total + Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
//         }
//         return total + (amenities[key]?.length || 0);
//       }, 0);

//     // Determine CSS class based on streetType
//     const streetColorClass = streetType === 'primary' ? 'primary-street' : 'comparison-street';

//     return (
//       <div className="street-detail-card">
//         <div className="location-info">
//           <h2 className={streetColorClass}>{streetNameShort}</h2> {/* Add color class here */}
//           <p>{postcode}</p>
//         </div>

//         <div className="scores-container">
//           <div className="score-item main-score">
//             <div className={`score-value ${streetColorClass}`}>{overallScore}/100</div> {/* Add color class here */}
//             <div className="score-label">Lifestyle Score</div>
//           </div>
//         </div>

//         <div className="top-3-inline">
//           <h3 className="subsection-title">Top 3 Amenity Categories</h3>
//           <ul className="top3-list">
//             {(top3 || []).map((attr, i) => {
//               const key = attr.name.toLowerCase();
//               const cat = amenityCategories.find(c => c.id === key);
//               const icon = cat ? cat.icon : '📍';
//               const label = cat ? cat.name : attr.name;
//               const score = +attr.score.toFixed(1);
//               const pct = (score / 10) * 100;
//               const cls = getScoreClass(score);

//               return (
//                 <li key={i} className="top3-item" style={{ '--i': i }}>
//                   <span className="top3-icon">{icon}</span>
//                   <span className="top3-label">{label}</span>
//                   <div className="top3-bar">
//                     <div className={`top3-fill ${cls}`} style={{ width: `${pct}%` }} />
//                   </div>
//                   <span className="top3-score">{score}/10</span>
//                 </li>
//               );
//             })}
//           </ul>
//         </div>

//         <div className="stats-container">
//           <div className="stat-item">
//             <div className="stat-value">{totalAmenities}</div>
//             <div className="stat-label">Total Amenities</div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderModal = () => {
//     if (!isCategoryModalOpen || !modalCategory) return null;

//     // Determine start coords for primary and comparison columns
//     const primaryStreetCoords = extractLatLonFromStreetObj(streetData?.amenities?.street || {});
//     const comparisonStreetCoords = comparisonAmenities ? extractLatLonFromStreetObj(comparisonAmenities.area2?.street || {}) : { lat: null, lon: null };

//     return ReactDOM.createPortal(
//       <div className="modal-overlay">
//         <div
//           className="places-modal compare"
//           ref={modalRef}
//           onClick={(e) => e.stopPropagation()}
//         >
//           <div className="modal-header">
//             <h3>{amenityCategories.find(cat => cat.id === modalCategory)?.name || modalCategory}</h3>
//             <div className="modal-subtitle">
//               {showComparison && comparisonData && (
//                 <></>
//               )}
//             </div>
//             <button
//               className="close-detail"
//               onClick={closeCategoryModal}
//               aria-label="Close"
//             >
//               ×
//             </button>
//           </div>

//           <div className="modal-stats">
//             <div className="stat-group">
//               <div className="stat-label">Performance Score</div>
//               <div className="stat-value">{getCategoryRating(modalCategory).toFixed(1)}/10</div>
//             </div>
//             <p className="scoring-note">
//               Each amenity is scored based on a combination of proximity and quality.
//             </p>
//           </div>

//           <div className="modal-content compare">
//             <div className="modal-column">
//               <h4 className="primary-street">{streetData?.street?.split(',')[0]}</h4>
//               <div className="places-scrollable">
//                 {getAllPlacesForCategory(modalCategory, streetData?.street).length > 0 ? (
//                   getAllPlacesForCategory(modalCategory, streetData?.street).map((place, index) => (
//                     <PlaceItem key={index} place={place} category={modalCategory} startCoords={primaryStreetCoords} />
//                   ))
//                 ) : (
//                   <div className="no-places-message">No places found in this category</div>
//                 )}
//               </div>
//             </div>

//             {showComparison && comparisonData && (
//               <div className="modal-column">
//                 <h4 className="comparison-street">{comparisonData.area2.street.split(',')[0]}</h4>
//                 <div className="places-scrollable">
//                   {getAllPlacesForCategory(modalCategory, comparisonData.area2.street).length > 0 ? (
//                     getAllPlacesForCategory(modalCategory, comparisonData.area2.street).map((place, index) => (
//                       <PlaceItem key={index} place={place} category={modalCategory} startCoords={comparisonStreetCoords} />
//                     ))
//                   ) : (
//                     <div className="no-places-message">No places found in this category</div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>,
//       document.body
//     );
//   };

//   // Loading & error handling
//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="loading-spinner" />
//         <p>Loading street data...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return <ErrorComponent error={error} onRetry={() => { setError(null); setLoading(true); }} />;
//   }

//   if (!streetData) {
//     return <ErrorComponent error="No Data Available" onRetry={() => { setError(null); setLoading(true); }} />;
//   }

//   // Main render
//   return (
//     <>
//       {!isCategoryModalOpen && (
//         <div className="analysis-container">
//           <header className="analysis-header">
//             <button onClick={() => {
//               if (showComparison) {
//                 setShowComparison(false);
//                 navigate(`/analysis?street_id=${encodeURIComponent(streetData.id)}`, { replace: true });
//               } else {
//                 navigate(-1);
//               }
//             }} className="back-button">← Back</button>
//           </header>

//           <section className={`detailed-analysis-compare ${showComparison ? 'two-cards' : ''}`}>
//             <StreetDetailCard
//               street={streetData.street}
//               amenities={streetData.amenities}
//               overallScore={streetData.overall_score}
//               top3={streetData.top_3_attributes}
//               streetType="primary" // This makes it blue
//             />

//             {showComparison && comparisonData && (
//               <StreetDetailCard
//                 street={comparisonData.area2.street}
//                 amenities={comparisonAmenities?.area2}
//                 overallScore={comparisonData.area2.overall_score}
//                 top3={comparisonData.area2.top_3_attributes}
//                 streetType="comparison" // This makes it green
//               />
//             )}
//           </section>

//           <section className="compare-area">
//             <h2 className="section-title">Compare with Another Area</h2>
//             <div className="compare-card">
//               <div className="input-group" ref={compareRef} style={{ position: 'relative' }}>
//                 <input
//                   type="text"
//                   placeholder="Enter street name"
//                   className="compare-input"
//                   value={compareInput}
//                   onChange={(e) => {
//                     setCompareInput(e.target.value);
//                     setCompareSelectedId(null);
//                     setShowCompareSuggestions(true);
//                     setError(null);
//                   }}
//                   onKeyDown={(e) => {
//                     if (e.key === 'Enter') handleCompareSubmit(e);
//                     if (e.key === 'Escape') {
//                       setShowCompareSuggestions(false);
//                     }
//                   }}
//                 />
//                 <button className="compare-button" onClick={handleCompareSubmit}>Compare Areas</button>

//                 {/* Suggestions dropdown */}
//                 {showCompareSuggestions && compareSuggestions.length > 0 && (
//                   <div className="suggestions-dropdown compare-suggestions">
//                     {compareSuggestions.map(s => (
//                       <div key={s.id} className="suggestion-item" onClick={() => handleCompareSuggestionClick(s)}>
//                         <div className="suggestion-name">{s.name}</div>
//                         <div className="suggestion-postcode">{s.postcode}</div>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               <p className="compare-description">Compare {streetData.street.split(',')[0]} with any other area to see side-by-side amenity analysis</p>
//             </div>
//           </section>

//           {showComparison && comparisonData && (
//             <>
//               <section className="comparison-results">
//                 <h2 className="section-title">Comparison Results</h2>

//                 <div className="attribute-comparison">
//                   <h3>Attribute Scores</h3>
//                   <div className="attribute-grid">
//                     {Object.entries(comparisonData.area1.attributes).map(([attr, score]) => (
//                       <div key={attr} className="attribute-item">
//                         <div className="attribute-name">{amenityCategories.find(c => c.id === attr)?.name || attr}</div>
//                         <div className="attribute-scores">
//                           <span className="score1 primary-street">{score}</span> {/* Add class */}
//                           <span className="score-divider">:</span>
//                           <span className="score2 comparison-street">{comparisonData.area2.attributes[attr]}</span> {/* Add class */}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <button className="close-comparison" onClick={() => setShowComparison(false)}>Close Comparison</button>
//               </section>

//               <section className="amenity-comparison-container">
//                 <h2 className="section-title comparison-title">Amenity Comparison</h2>
//                 <p className="comparison-description">
//                   Scores are based on proximity and quality of amenities.
//                 </p>
//                 <div className="categories-grid comparison">
//                   {amenityCategories.map(category => {
//                     const street1Count = countAmenities(category.id);
//                     const street1Score = getCategoryRating(category.id);
//                     const street2Count = comparisonData.area2.category_counts[category.id] || 0;
//                     const street2Score = comparisonData.area2.attributes[category.id] || 0;

//                     if (street1Count === 0 && street2Count === 0) return null;

//                     return (
//                       <div key={category.id} className="category-card comparison" onClick={() => openCategoryModal(category.id)}>
//                         <div className="category-header">
//                           <div className="category-icon">{category.icon}</div>
//                           <h3 className="category-name">{category.name}</h3>
//                         </div>

//                         <div className="street-comparison">
//                           <div className="street-row">
//                             <div className="street-name primary-street">{comparisonData.area1.street.split(',')[0]}</div> {/* Add class */}
//                             <div className="score-display">
//                               <div className="street-score primary-street">{street1Score.toFixed(1)}/10</div> {/* Add class */}
//                               <div className="street-count">({street1Count} locations)</div>
//                             </div>
//                           </div>

//                           <div className="street-row">
//                             <div className="street-name comparison-street">{comparisonData.area2.street.split(',')[0]}</div> {/* Add class */}
//                             <div className="score-display">
//                               <div className="street-score comparison-street">{street2Score.toFixed(1)}/10</div> {/* Add class */}
//                               <div className="street-count">({street2Count} locations)</div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </section>
//             </>
//           )}

//           {!showComparison && (
//             <section className="amenity-categories">
//               <h2 className="section-title">All Amenity Categories</h2>
//               <div className="categories-grid">
//                 {amenityCategories.map(category => {
//                   const count = countAmenities(category.id);
//                   if (count === 0) return null;
//                   const score = getCategoryRating(category.id);

//                   return (
//                     <div key={category.id} className="category-card" onClick={() => openCategoryModal(category.id)}>
//                       <div className="category-header">
//                         <div className="category-icon">{category.icon}</div>
//                         <h3 className="category-name">{category.name}</h3>
//                       </div>
//                       <div className="street-row">
//                         <div className="score-display">
//                           <div className="street-score primary-street">{score.toFixed(1)}/10</div> {/* Add class */}
//                           <div className="street-count">({count} {count === 1 ? 'location' : 'locations'})</div>
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </section>
//           )}

//           <section className="ai-insights-section">

//   <div className="ai-header-row">
//     <h2 className="section-title">AI Insights</h2>

//     <button
//       className="ai-refresh-btn"
//       onClick={fetchAISummaries}
//       disabled={aiLoading}
//     >
//       {aiLoading ? 'Generating…' : 'Regenerate'}
//     </button>
//   </div>

//   {aiError && <div className="ai-error">{aiError}</div>}

//   {/* SINGLE STREET MODE */}
//   {!showComparison && aiSummaries.area1 && (
//     <div className="ai-card">

//       <h3 className="ai-subtitle">🧭 One-liner</h3>
//       <p className="ai-text">{aiSummaries.area1.one_liner}</p>

//       <div className="ai-divider" />

//       <h3 className="ai-subtitle">📌 High-level Summary</h3>
//       <p className="ai-text">{aiSummaries.area1.summary}</p>

//       <div className="ai-divider" />

//       <h3 className="ai-subtitle">⭐ Key Highlights</h3>
//       <ul className="ai-bullet-list">
//         {aiSummaries.area1.highlights?.map((h, i) => (
//           <li key={i}>{h}</li>
//         ))}
//       </ul>

//       <div className="ai-divider" />

//       <h3 className="ai-subtitle">🏛 Historical Background</h3>
//       <p className="ai-text">{aiSummaries.area1.history}</p>
//     </div>
//   )}

//   {/* COMPARISON MODE */}
//   {showComparison && aiSummaries.area1 && aiSummaries.area2 && (
//     <div className="ai-compare-grid">

//       {/* Street 1 */}
//       <div className="ai-card">
//         <h3 className="ai-card-title">{comparisonData.area1.street.split(',')[0]}</h3>

//         <h4 className="ai-subsubtitle">🧭 One-liner</h4>
//         <p className="ai-text">{aiSummaries.area1.one_liner}</p>

//         <h4 className="ai-subsubtitle">📌 Summary</h4>
//         <p className="ai-text">{aiSummaries.area1.summary}</p>

//         <h4 className="ai-subsubtitle">⭐ Highlights</h4>
//         <ul className="ai-bullet-list">
//           {aiSummaries.area1.highlights?.map((h, i) => <li key={i}>{h}</li>)}
//         </ul>

//         <h4 className="ai-subsubtitle">🏛 History</h4>
//         <p className="ai-text">{aiSummaries.area1.history}</p>
//       </div>

//       {/* Street 2 */}
//       <div className="ai-card">
//         <h3 className="ai-card-title">{comparisonData.area2.street.split(',')[0]}</h3>

//         <h4 className="ai-subsubtitle">🧭 One-liner</h4>
//         <p className="ai-text">{aiSummaries.area2.one_liner}</p>

//         <h4 className="ai-subsubtitle">📌 Summary</h4>
//         <p className="ai-text">{aiSummaries.area2.summary}</p>

//         <h4 className="ai-subsubtitle">⭐ Highlights</h4>
//         <ul className="ai-bullet-list">
//           {aiSummaries.area2.highlights?.map((h, i) => <li key={i}>{h}</li>)}
//         </ul>

//         <h4 className="ai-subsubtitle">🏛 History</h4>
//         <p className="ai-text">{aiSummaries.area2.history}</p>
//       </div>

//       {/* Comparison block */}
//       <div className="ai-card">
//         <h3 className="ai-card-title">Comparison Summary</h3>

//         <h4 className="ai-subsubtitle">📌 Overview</h4>
//         <p className="ai-text">{aiSummaries.comparison.summary}</p>

//         <h4 className="ai-subsubtitle">🔍 Key Differences</h4>
//         <ul className="ai-bullet-list">
//           {aiSummaries.comparison.differences?.map((d, i) => <li key={i}>{d}</li>)}
//         </ul>

//         <h4 className="ai-subsubtitle">🏁 Verdict</h4>
//         <p className="ai-text">{aiSummaries.comparison.verdict}</p>
//       </div>

//     </div>
//   )}

// </section>


//         </div>
//       )}
//       {renderModal()}
//     </>
//   );
// };

// export default StreetAnalysis;



// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
// import './AnalysisPage.css';
// import { BASE_URL } from '../constants';
// import ReactDOM from 'react-dom';
// import ErrorComponent from '../components/ErrorComponent';

// const StreetAnalysis = () => {
//   useEffect(() => { window.scrollTo(0, 0); }, []);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user } = useAuth();

//   // Primary data
//   const [streetData, setStreetData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // UI / comparison state
//   // prefixed unused state variables with _ to silence lint while keeping setters available
//   const [_activeCategory, setActiveCategory] = useState(null);
//   const [compareInput, setCompareInput] = useState('');
//   const [compareSuggestions, setCompareSuggestions] = useState([]);
//   const [showCompareSuggestions, setShowCompareSuggestions] = useState(false);
//   const [_compareLoading, setCompareLoading] = useState(false);
//   const [compareSelectedId, setCompareSelectedId] = useState(null); // id selected from suggestions
//   const [comparisonData, setComparisonData] = useState(null);
//   const [comparisonAmenities, setComparisonAmenities] = useState(null);
//   const [showComparison, setShowComparison] = useState(false);

//   // modal state
//   const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
//   const [modalCategory, setModalCategory] = useState(null);
//   const [_modalStreetName, setModalStreetName] = useState('');

//   // AI summaries state
//   const [aiSummaries, setAiSummaries] = useState({
//     area1: null,
//     area2: null,
//     comparison: null,
//   });
//   const [aiLoading, setAiLoading] = useState(false);
//   const [aiError, setAiError] = useState(null);

//   const compareRef = useRef(null); // to close suggestions on outside click
//   const scrollPositionRef = useRef(0); // to remember scroll position when modal opens
//   const modalRef = useRef(null); // reference to the modal for click outside detection

//   // accept both 'street_id' and 'id' query params for compatibility
//   const queryParams = new URLSearchParams(location.search);
//   const streetIdFromUrl = queryParams.get('street_id') || queryParams.get('id') || null;

//   // left in but prefixed to silence unused-var lint (you can remove if not needed)
//   const _BAR_COLORS = {
//     Education: '#34D169',
//     Transport: '#3B82F6',
//     'Parks & Recreation': '#F59E0B',
//   };

//   const amenityCategories = [
//     { id: 'school', name: 'School', icon: '🏫' },
//     { id: 'university', name: 'University', icon: '🎓' },
//     { id: 'library', name: 'Library', icon: '📚' },
//     { id: 'hospital', name: 'Hospital', icon: '🏥' },
//     { id: 'doctor', name: 'Doctor', icon: '👨‍⚕️' },
//     { id: 'pharmacy', name: 'Pharmacy', icon: '💊' },
//     { id: 'restaurant', name: 'Restaurant', icon: '🍽️' },
//     { id: 'cafe', name: 'Café', icon: '☕' },
//     { id: 'bakery', name: 'Bakery', icon: '🥐' },
//     { id: 'bar', name: 'Bar', icon: '🍻' },
//     { id: 'grocery_or_supermarket', name: 'Grocery Store', icon: '🛒' },
//     { id: 'supermarket', name: 'Supermarket', icon: '🛍️' },
//     { id: 'bank', name: 'Bank', icon: '🏦' },
//     { id: 'atm', name: 'ATM', icon: '💳' },
//     { id: 'post_office', name: 'Post Office', icon: '📮' },
//     { id: 'gas_station', name: 'Petrol Station', icon: '⛽' },
//     { id: 'airport', name: 'Airport', icon: '✈️' },
//     { id: 'electric_vehicle_charging_station', name: 'EV Charging', icon: '🔌' },
//     { id: 'transport', name: 'Transport', icon: '🚆' },
//     { id: 'park', name: 'Park', icon: '🌳' },
//     { id: 'gym', name: 'Gym', icon: '💪' },
//     { id: 'stadium', name: 'Stadium', icon: '🏟️' },
//     { id: 'museum', name: 'Museum', icon: '🏛️' },
//     { id: 'art_gallery', name: 'Art Gallery', icon: '🎨' },
//     { id: 'movie_theater', name: 'Cinema', icon: '🎬' },
//   ];

//   const categoryToApiKey = {
//     school: 'schools',
//     university: 'university',
//     library: 'library',
//     hospital: 'hospitals',
//     doctor: 'doctor',
//     pharmacy: 'pharmacies',
//     restaurant: 'restaurants',
//     cafe: 'cafe',
//     bakery: 'bakery',
//     bar: 'bar',
//     grocery_or_supermarket: 'grocery_or_supermarket',
//     supermarket: 'supermarket',
//     bank: 'banks',
//     atm: 'atm',
//     post_office: 'post_office',
//     gas_station: 'gas_station',
//     park: 'park',
//     gym: 'gym',
//     stadium: 'stadium',
//     museum: 'museum',
//     art_gallery: 'art_gallery',
//     movie_theater: 'movie_theater',
//     airport: 'airport',
//     electric_vehicle_charging_station: 'electric_vehicle_charging_station',
//     transport: 'transports'
//   };

//   const transportIcons = {
//     bikepoint: '🚲', bus: '🚌', dlr: '🚈',
//     'national-rail': '🚆', overground: '🚇', tube: '🚇',
//     tram: '🚊', ferry: '⛴️', cable_car: '🚡', default: '📍'
//   };

//   // -------------------------
//   // New helpers for directions
//   // -------------------------
//   const buildDirectionsUrl = ({ startLat, startLon, endLat, endLon }) => {
//     // If any of the start or end coords are missing, fallback to a simple place query
//     const hasStart = startLat !== undefined && startLon !== undefined && startLat !== null && startLon !== null;
//     const hasEnd = endLat !== undefined && endLon !== undefined && endLat !== null && endLon !== null;

//     if (!hasEnd) return '#';

//     if (!hasStart) {
//       // Open end place in Maps if we don't have origin coords
//       return `https://maps.google.com/?q=${encodeURIComponent(endLat + ',' + endLon)}`;
//     }

//     // Normal directions URL
//     const origin = `${startLat},${startLon}`;
//     const destination = `${endLat},${endLon}`;
//     return `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}`;
//   };

//   const extractLatLonFromStreetObj = (streetObj) => {
//     if (!streetObj) return { lat: null, lon: null };
//     // Accept multiple possible field names returned by backend
//     const lat = streetObj.latitude ?? streetObj.lat ?? streetObj.location_lat ?? null;
//     const lon = streetObj.longitude ?? streetObj.lon ?? streetObj.lng ?? streetObj.location_lon ?? null;
//     return { lat, lon };
//   };

//   // kept but prefixed to avoid lint warning (not used right now)
//   const _getStreetCoordsForName = (streetName) => {
//     if (streetName === streetData?.street) {
//       return extractLatLonFromStreetObj(streetData?.amenities?.street || {});
//     }

//     if (comparisonAmenities && comparisonData) {
//       if (streetName === comparisonData.area1.street) {
//         return extractLatLonFromStreetObj(comparisonAmenities.area1?.street || {});
//       }
//       if (streetName === comparisonData.area2.street) {
//         return extractLatLonFromStreetObj(comparisonAmenities.area2?.street || {});
//       }
//     }

//     return { lat: null, lon: null };
//   };

//   // Close compare suggestions when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (compareRef.current && !compareRef.current.contains(e.target)) {
//         setShowCompareSuggestions(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   // Handle click outside modal
//   useEffect(() => {
//     const handleClickOutsideModal = (e) => {
//       if (isCategoryModalOpen && modalRef.current && !modalRef.current.contains(e.target)) {
//         closeCategoryModal();
//       }
//     };

//     const handleEscapeKey = (e) => {
//       if (isCategoryModalOpen && e.key === 'Escape') {
//         closeCategoryModal();
//       }
//     };

//     if (isCategoryModalOpen) {
//       document.addEventListener('mousedown', handleClickOutsideModal);
//       document.addEventListener('keydown', handleEscapeKey);
//     }

//     return () => {
//       document.removeEventListener('mousedown', handleClickOutsideModal);
//       document.removeEventListener('keydown', handleEscapeKey);
//     };
//   }, [isCategoryModalOpen]);

//   // Fetch main street rating + amenities using street_id
//   useEffect(() => {
//     const fetchStreet = async () => {
//       if (!streetIdFromUrl) {
//         navigate('/');
//         return;
//       }
//       setLoading(true);
//       setError(null);

//       try {
//         const token = localStorage.getItem('token');
//         const headers = token ? { Authorization: `Token ${token}` } : {};

//         // rating-summary expects street_id param (your backend)
//         const ratingRes = await fetch(
//           `${BASE_URL}api/streets/rating-summary/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
//           { headers }
//         );
//         if (!ratingRes.ok) throw new Error('Failed to fetch rating summary');
//         const ratingJson = await ratingRes.json();

//         // places-by-name supports street_id (preferred)
//         const placesRes = await fetch(
//           `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
//           { headers }
//         );
//         if (!placesRes.ok) throw new Error('Failed to fetch amenities');
//         const placesJson = await placesRes.json();

//         // Combine and keep rating id too
//         setStreetData({
//           id: ratingJson.id ?? streetIdFromUrl,
//           ...ratingJson,
//           amenities: placesJson,
//         });

//         if (ratingJson.top_3_attributes?.length > 0) {
//           setActiveCategory(ratingJson.top_3_attributes[0].name);
//         }
//       } catch (err) {
//         console.error(err);
//         setError(err.message || 'Failed to load street data');
//       } finally {
//         setLoading(false);
//       }
//     };

//     // only fetch when user is present (your pattern) — if you want public access, remove user guard
//     if (user && streetIdFromUrl) fetchStreet();
//     else setLoading(false);
//   }, [user, streetIdFromUrl, navigate]);

//   // Helper: fetch amenities by street id (uses street_id param)
//   const fetchAmenitiesById = async (id) => {
//     try {
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};
//       const res = await fetch(
//         `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(id)}`,
//         { headers }
//       );
//       if (!res.ok) throw new Error('Failed to fetch amenities');
//       return await res.json();
//     } catch (err) {
//       console.error('fetchAmenitiesById error:', err);
//       return { transports: {}, categories: {} };
//     }
//   };

//   // -------------------------
//   // Enhanced AI Summary Handler
//   // -------------------------
//   const fetchAISummaries = useCallback(async (forceRegenerate = false) => {
//     if (!streetData) return;
    
//     // Don't regenerate if we already have data and not forcing
//     if (!forceRegenerate && aiSummaries.area1 && !showComparison) return;
    
//     setAiLoading(true);
//     setAiError(null);

//     try {
//       // Prepare payload based on backend expected format
//       const buildAmenitiesPayload = (data) => {
//         if (!data || !data.top_3_attributes) return [];
        
//         return data.top_3_attributes.map(attr => ({
//           name: attr.name,
//           score: attr.score
//         }));
//       };

//       const payload = {
//         area1: {
//           name: streetData.street,
//           overall_score: streetData.overall_score,
//           amenities: buildAmenitiesPayload(streetData)
//         }
//       };

//       // Add area2 if in comparison mode
//       if (showComparison && comparisonData) {
//         payload.area2 = {
//           name: comparisonData.area2.street,
//           overall_score: comparisonData.area2.overall_score,
//           amenities: buildAmenitiesPayload(comparisonData.area2)
//         };
//       }

//       console.log('Sending AI request:', payload);

//       const res = await fetch(`${BASE_URL}api/ai/summary/`, {
//         method: 'POST',
//         headers: { 
//           'Content-Type': 'application/json',
//           ...(user?.token ? { 'Authorization': `Token ${user.token}` } : {})
//         },
//         body: JSON.stringify(payload),
//       });

//       if (!res.ok) {
//         const errorText = await res.text();
//         throw new Error(`AI API error: ${res.status} - ${errorText}`);
//       }

//       const result = await res.json();
//       console.log('AI response received:', result);

//       // Handle different response formats from AWS Bedrock
//       const handleAIResponse = (response) => {
//         // Case 1: Direct structured response
//         if (response.area1 && response.area2 && response.comparison) {
//           return response;
//         }
        
//         // Case 2: Single area response with new format
//         if (response.one_liner || response.summary || response.highlights) {
//           return {
//             area1: response,
//             area2: null,
//             comparison: null
//           };
//         }
        
//         // Case 3: Raw string response (Claude sometimes returns raw JSON string)
//         if (response.raw) {
//           try {
//             const parsed = JSON.parse(response.raw);
//             return handleAIResponse(parsed);
//           } catch (e) {
//             // If it's not JSON, treat it as plain text
//             return {
//               area1: { 
//                 summary: response.raw,
//                 one_liner: response.raw.split('.')[0] + '.',
//                 highlights: response.raw.split('.').filter(s => s.trim()).slice(0, 3)
//               },
//               area2: null,
//               comparison: null
//             };
//           }
//         }
        
//         // Case 4: Fallback to showing the whole response
//         return {
//           area1: { 
//             summary: typeof response === 'string' ? response : JSON.stringify(response, null, 2),
//             one_liner: "AI analysis generated successfully.",
//             highlights: ["Analysis based on amenity scores", "Generated by Claude 3 Sonnet", "Professional property insights"]
//           },
//           area2: null,
//           comparison: null
//         };
//       };

//       const processedResponse = handleAIResponse(result);
//       setAiSummaries(processedResponse);

//     } catch (err) {
//       console.error('AI summary error:', err);
//       setAiError(err.message || 'Failed to generate AI summary. Please try again.');
      
//       // Provide helpful fallback content
//       const fallbackContent = {
//         area1: {
//           one_liner: `${streetData?.street?.split(',')[0]} offers a well-rounded urban living experience with strong amenity access.`,
//           summary: `This area scores ${streetData?.overall_score}/100 overall, indicating a balanced mix of amenities and services. The top categories include ${streetData?.top_3_attributes?.map(a => a.name).join(', ')}. The street provides good access to essential services and leisure facilities suitable for various lifestyles.`,
//           highlights: [
//             'Strong amenity coverage across multiple categories',
//             'Good balance of essential services and leisure options',
//             'Accessible location with reasonable transportation options'
//           ],
//           history: `${streetData?.street?.split(',')[0]} has developed as a residential area with consistent growth in local amenities. The area benefits from ongoing urban development while maintaining its neighborhood character.`
//         }
//       };

//       if (showComparison && comparisonData) {
//         fallbackContent.area2 = {
//           one_liner: `${comparisonData.area2.street.split(',')[0]} presents a contrasting urban profile with different amenity strengths.`,
//           summary: `With an overall score of ${comparisonData.area2.overall_score}/100, this area shows different strengths including ${comparisonData.area2.top_3_attributes?.map(a => a.name).join(', ')}. The street offers unique advantages depending on specific lifestyle needs.`,
//           highlights: [
//             'Specialized amenity offerings in key categories',
//             'Distinct neighborhood character and services',
//             'Different transportation and access patterns'
//           ],
//           history: `${comparisonData.area2.street.split(',')[0]} has evolved with its own distinct development pattern, offering different urban characteristics compared to other areas.`
//         };
        
//         fallbackContent.comparison = {
//           summary: `Comparing ${streetData?.street?.split(',')[0]} (${streetData?.overall_score}/100) with ${comparisonData.area2.street.split(',')[0]} (${comparisonData.area2.overall_score}/100) reveals different urban living propositions.`,
//           differences: [
//             `Score difference of ${Math.abs(streetData?.overall_score - comparisonData.area2.overall_score)} points overall`,
//             'Different top amenity categories and strengths',
//             'Varied neighborhood characteristics and service availability'
//           ],
//           verdict: 'Each area offers unique advantages depending on specific lifestyle priorities and amenity preferences.'
//         };
//       }

//       setAiSummaries(fallbackContent);
//     } finally {
//       setAiLoading(false);
//     }
//   }, [streetData, showComparison, comparisonData, user, aiSummaries.area1]);

//   // Auto-fetch AI summary when street data loads
//   useEffect(() => {
//     if (streetData && !aiSummaries.area1) {
//       const timer = setTimeout(() => {
//         fetchAISummaries();
//       }, 500);
//       return () => clearTimeout(timer);
//     }
//   }, [streetData, fetchAISummaries]);

//   // Auto-fetch AI summary when comparison changes
//   useEffect(() => {
//     if (showComparison && comparisonData) {
//       fetchAISummaries();
//     }
//   }, [showComparison, comparisonData]);

//   // Helper: search streets for compare suggestions
//   const searchStreets = async (q) => {
//     try {
//       if (!q || !q.trim()) return [];
//       setCompareLoading(true);
//       const res = await fetch(`${BASE_URL}api/streets/search-streets/?q=${encodeURIComponent(q.trim())}`);
//       if (!res.ok) return [];
//       const data = await res.json(); // expects [{id,name,postcode}, ...]
//       return Array.isArray(data) ? data : [];
//     } catch (err) {
//       console.error('searchStreets error:', err);
//       return [];
//     } finally {
//       setCompareLoading(false);
//     }
//   };

//   // Debounce compare input to fetch suggestions
//   useEffect(() => {
//     if (!compareInput) {
//       setCompareSuggestions([]);
//       setShowCompareSuggestions(false);
//       setCompareSelectedId(null);
//       return;
//     }
//     const t = setTimeout(async () => {
//       const results = await searchStreets(compareInput);
//       setCompareSuggestions(results);
//       setShowCompareSuggestions(results.length > 0);
//     }, 300);
//     return () => clearTimeout(t);
//   }, [compareInput]);

//   // When user clicks a suggestion — set input, set selected id and immediately compare
//   const handleCompareSuggestionClick = async (suggestion) => {
//     setCompareInput(suggestion.name);
//     setCompareSelectedId(suggestion.id);
//     setShowCompareSuggestions(false);

//     // trigger compare by id (preferred)
//     await performCompareByIds(streetData?.id, suggestion.id);
//   };

//   // Perform compare with preferred id1/id2. If ids not available, fallback to q1/q2 name based compare
//   const performCompareByIds = async (id1, id2) => {
//     if (!id1 || !id2) {
//       setError('Both street IDs are required for comparison.');
//       return;
//     }
//     setLoading(true);
//     setError(null);

//     try {
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};

//       const res = await fetch(`${BASE_URL}api/streets/compare/?id1=${encodeURIComponent(id1)}&id2=${encodeURIComponent(id2)}`, { headers });
//       if (!res.ok) {
//         // fallback: if backend returns 404 or bad request, try name-based compare as a last resort
//         if (res.status === 404) throw new Error('One of the streets was not found for comparison.');
//         throw new Error('Failed to fetch comparison data');
//       }
//       const comp = await res.json();

//       // fetch amenities for both sides using returned ids (backend returns area1.id/area2.id)
//       const area1Id = comp?.area1?.id ?? id1;
//       const area2Id = comp?.area2?.id ?? id2;

//       const [amen1, amen2] = await Promise.all([fetchAmenitiesById(area1Id), fetchAmenitiesById(area2Id)]);

//       setComparisonData(comp);
//       setComparisonAmenities({ area1: amen1, area2: amen2 });
//       setShowComparison(true);

//       // scroll to results
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     } catch (err) {
//       console.error('performCompareByIds error:', err);
//       setError(err.message || 'Comparison failed');
//       setShowComparison(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // User pressed Enter in compare input — prefer selectedId, else attempt to find first match and compare by id,
//   // else fallback to name-based compare using q1/q2 endpoint.
//   const handleCompareSubmit = async (e) => {
//     e?.preventDefault?.();
//     if (!compareInput?.trim()) {
//       setError('Please enter a street name or pick a suggestion to compare.');
//       return;
//     }
//     setError(null);

//     if (compareSelectedId) {
//       return performCompareByIds(streetData?.id, compareSelectedId);
//     }

//     // Try to find a suggestion programmatically
//     const results = await searchStreets(compareInput);
//     if (results.length > 0) {
//       return performCompareByIds(streetData?.id, results[0].id);
//     }

//     // Last resort: name-based compare (q1/q2) — backend still supports this for backward compat
//     try {
//       setLoading(true);
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};
//       const res = await fetch(`${BASE_URL}api/streets/compare/?q1=${encodeURIComponent(streetData.street)}&q2=${encodeURIComponent(compareInput.trim())}`, { headers });
//       if (!res.ok) {
//         if (res.status === 404) throw new Error('Comparison street not found');
//         throw new Error('Comparison failed');
//       }
//       const comp = await res.json();
//       // fetch amenities using area names returned by compare (fallback)
//       const [amen1, amen2] = await Promise.all([fetchAmenitiesById(comp.area1.id || streetData.id), fetchAmenitiesById(comp.area2.id)]);
//       setComparisonData(comp);
//       setComparisonAmenities({ area1: amen1, area2: amen2 });
//       setShowComparison(true);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     } catch (err) {
//       console.error('fallback name compare error:', err);
//       setError(err.message || 'Comparison failed');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Utilities used by UI (counts, ratings, places lists)
//   const countAmenities = (category) => {
//     if (!streetData?.amenities) return 0;
//     if (category === 'transport') {
//       const transport = streetData.amenities.transports || {};
//       return Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
//     }
//     const apiKey = categoryToApiKey[category];
//     if (!apiKey) return 0;
//     return streetData.amenities[apiKey]?.length || 0;
//   };

//   const getCategoryRating = (categoryId, data = streetData) => {
//     if (!data?.attributes || !data.attributes[0]) return 0;
//     return data.attributes[0][categoryId] || 0;
//   };

//   // kept but prefixed to avoid lint warning (not used right now)
//   const _getNearbyPlaces = (category) => {
//     if (!streetData?.amenities) return [];
//     if (category === 'transport') {
//       const transport = streetData.amenities.transports || {};
//       return Object.values(transport).flat().slice(0, 5);
//     }
//     const apiKey = categoryToApiKey[category];
//     if (!apiKey) return [];
//     return streetData.amenities[apiKey]?.slice(0, 5) || [];
//   };

//   const getAllPlacesForCategory = (category, streetNameParam) => {
//     // If streetNameParam === streetData.street => return from streetData
//     if (!streetNameParam) return [];
//     if (streetNameParam === streetData?.street) {
//       if (category === 'transport') {
//         const transport = streetData.amenities?.transports || {};
//         return Object.values(transport).flat();
//       }
//       const apiKey = categoryToApiKey[category];
//       if (!apiKey) return [];
//       return streetData.amenities?.[apiKey] || [];
//     }

//     // If comparisonAmenities present, pick the correct one
//     if (comparisonAmenities) {
//       const amenities = streetNameParam === comparisonData?.area1.street ? comparisonAmenities.area1 : comparisonAmenities.area2;
//       if (category === 'transport') {
//         const transport = amenities?.transports || {};
//         return Object.values(transport).flat();
//       }
//       const apiKey = categoryToApiKey[category];
//       if (!apiKey) return [];
//       return amenities?.[apiKey] || [];
//     }

//     return [];
//   };

//   // Modals and UI helpers
//   const openCategoryModal = (category, streetName = '') => {
//     // Store current scroll position before opening modal
//     scrollPositionRef.current = window.scrollY;
//     setModalCategory(category);
//     setModalStreetName(streetName || streetData?.street || '');
//     setIsCategoryModalOpen(true);

//     // Prevent body scrolling when modal is open
//     document.body.style.overflow = 'hidden';
//   };

//   const closeCategoryModal = () => {
//     setIsCategoryModalOpen(false);
//     setModalCategory(null);
//     // Restore body scrolling
//     document.body.style.overflow = 'unset';

//     // Restore scroll position after a short delay to allow modal to close
//     setTimeout(() => {
//       window.scrollTo(0, scrollPositionRef.current);
//     }, 10);
//   };

//   // Remove the problematic useEffect for modal body class
//   useEffect(() => {
//     return () => {
//       // Cleanup: ensure body scrolling is restored when component unmounts
//       document.body.style.overflow = 'unset';
//     };
//   }, []);

//   useEffect(() => {
//     if (showComparison) {
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   }, [showComparison]);

//   function getScoreClass(score) {
//     if (score < 8) return 'low';
//     if (score < 9) return 'medium';
//     return 'high';
//   }

//   // -------------------------
//   // AI Summary UI Components
//   // -------------------------
//   const renderAIHighlights = (highlights) => {
//     if (!highlights) return null;
    
//     if (Array.isArray(highlights)) {
//       return (
//         <ul className="ai-bullet-list">
//           {highlights.map((item, index) => (
//             <li key={index} className="ai-bullet-item">
//               <span className="ai-bullet-icon">•</span>
//               <span className="ai-bullet-text">{item}</span>
//             </li>
//           ))}
//         </ul>
//       );
//     }
    
//     if (typeof highlights === 'string') {
//       const items = highlights.split(/\n|;|\.(?=\s+[A-Z])/).filter(item => item.trim().length > 0);
//       if (items.length > 1) {
//         return (
//           <ul className="ai-bullet-list">
//             {items.map((item, index) => (
//               <li key={index} className="ai-bullet-item">
//                 <span className="ai-bullet-icon">•</span>
//                 <span className="ai-bullet-text">{item.trim()}</span>
//               </li>
//             ))}
//           </ul>
//         );
//       }
//       return <p className="ai-text">{highlights}</p>;
//     }
    
//     return null;
//   };

//   const renderAICard = (title, data, areaKey, isComparison = false) => {
//     if (!data) return null;

//     return (
//       <div className={`ai-summary-card ${isComparison ? 'comparison-card' : ''}`}>
//         <div className="ai-card-header">
//           <h3 className="ai-card-title">{title}</h3>
          
//           {data.one_liner && (
//             <div className="ai-one-liner-section">
//               <div className="ai-section-header">
//                 <h4 className="ai-subtitle">🧭 Quick Summary</h4>
//               </div>
//               <div className="ai-one-liner">
//                 <div className="ai-quote-icon">"</div>
//                 <p className="ai-one-liner-text">{data.one_liner}</p>
//                 <div className="ai-quote-icon">"</div>
//               </div>
//             </div>
//           )}

//           {data.summary && (
//             <div className="ai-section">
//               <div className="ai-section-header">
//                 <h4 className="ai-subtitle">📋 Detailed Analysis</h4>
//               </div>
//               <div className="ai-summary-content">
//                 <p className="ai-text">{data.summary}</p>
//               </div>
//             </div>
//           )}

//           {data.highlights && (
//             <div className="ai-section">
//               <div className="ai-section-header">
//                 <h4 className="ai-subtitle">⭐ Key Highlights</h4>
//               </div>
//               <div className="ai-highlights-content">
//                 {renderAIHighlights(data.highlights)}
//               </div>
//             </div>
//           )}

//           {data.history && (
//             <div className="ai-section">
//               <div className="ai-section-header">
//                 <h4 className="ai-subtitle">🏛️ Area Background</h4>
//               </div>
//               <div className="ai-history-content">
//                 <p className="ai-text">{data.history}</p>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     );
//   };

//   const renderComparisonAISection = () => {
//     if (!aiSummaries.area1 || !aiSummaries.area2 || !aiSummaries.comparison) {
//       return null;
//     }

//     return (
//       <div className="ai-comparison-grid">
//         <div className="ai-comparison-row">
//           {renderAICard(
//             streetData?.street?.split(',')[0], 
//             aiSummaries.area1, 
//             'area1', 
//             true
//           )}
//           {renderAICard(
//             comparisonData?.area2?.street?.split(',')[0], 
//             aiSummaries.area2, 
//             'area2', 
//             true
//           )}
//         </div>
        
//         <div className="ai-comparison-summary">
//           <div className="ai-section">
//             <div className="ai-section-header">
//               <h4 className="ai-subtitle">📊 Comparison Overview</h4>
//             </div>
//             <div className="ai-summary-content">
//               <p className="ai-text">{aiSummaries.comparison.summary}</p>
//             </div>
//           </div>

//           {aiSummaries.comparison.differences && (
//             <div className="ai-section">
//               <div className="ai-section-header">
//                 <h4 className="ai-subtitle">🔍 Key Differences</h4>
//               </div>
//               <div className="ai-highlights-content">
//                 {renderAIHighlights(aiSummaries.comparison.differences)}
//               </div>
//             </div>
//           )}

//           {aiSummaries.comparison.verdict && (
//             <div className="ai-section">
//               <div className="ai-section-header">
//                 <h4 className="ai-subtitle">⚖️ Final Verdict</h4>
//               </div>
//               <div className="ai-verdict-content">
//                 <div className="ai-verdict-box">
//                   <p className="ai-verdict-text">{aiSummaries.comparison.verdict}</p>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     );
//   };

//   // UI components: PlaceItem, StreetDetailCard, modal renderer
//   const PlaceItem = ({ place, category, startCoords }) => {
//     // startCoords should be an object with { lat, lon }
//     const endLat = place.latitude ?? place.lat ?? place.location_lat ?? null;
//     const endLon = place.longitude ?? place.lon ?? place.location_lon ?? null;

//     const startLat = startCoords?.lat ?? null;
//     const startLon = startCoords?.lon ?? null;

//     const directionsUrl = buildDirectionsUrl({ startLat, startLon, endLat, endLon });

//     return (
//       <div className="place-item">
//         <div className="place-name">
//           {category === 'transport' && place.stop_type && (
//             <span className="transport-icon">{transportIcons[place.stop_type] || transportIcons.default}</span>
//           )}
//           {place.name}
//         </div>
//         {place.final_rating && <div className="place-rating">Rating: {place.final_rating}</div>}
//         <div className="place-links">
//           {endLat && endLon && (
//             <a href={directionsUrl} target="_blank" rel="noopener noreferrer" className="map-link">View on Map</a>
//           )}
//         </div>
//       </div>
//     );
//   };

//   const StreetDetailCard = ({ street, amenities, overallScore, top3, streetType = 'primary' }) => {
//     const streetNameShort = (typeof street === 'string') ? street.split(',')[0] : '';
//     const postcode = amenities?.street?.postcode || 'London';

//     const totalAmenities = Object.keys(amenities || {})
//       .filter(key => key !== 'street')
//       .reduce((total, key) => {
//         if (key === 'transports') {
//           const transport = amenities.transports || {};
//           return total + Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
//         }
//         return total + (amenities[key]?.length || 0);
//       }, 0);

//     // Determine CSS class based on streetType
//     const streetColorClass = streetType === 'primary' ? 'primary-street' : 'comparison-street';

//     return (
//       <div className="street-detail-card">
//         <div className="location-info">
//           <h2 className={streetColorClass}>{streetNameShort}</h2> {/* Add color class here */}
//           <p>{postcode}</p>
//         </div>

//         <div className="scores-container">
//           <div className="score-item main-score">
//             <div className={`score-value ${streetColorClass}`}>{overallScore}/100</div> {/* Add color class here */}
//             <div className="score-label">Lifestyle Score</div>
//           </div>
//         </div>

//         <div className="top-3-inline">
//           <h3 className="subsection-title">Top 3 Amenity Categories</h3>
//           <ul className="top3-list">
//             {(top3 || []).map((attr, i) => {
//               const key = attr.name.toLowerCase();
//               const cat = amenityCategories.find(c => c.id === key);
//               const icon = cat ? cat.icon : '📍';
//               const label = cat ? cat.name : attr.name;
//               const score = +attr.score.toFixed(1);
//               const pct = (score / 10) * 100;
//               const cls = getScoreClass(score);

//               return (
//                 <li key={i} className="top3-item" style={{ '--i': i }}>
//                   <span className="top3-icon">{icon}</span>
//                   <span className="top3-label">{label}</span>
//                   <div className="top3-bar">
//                     <div className={`top3-fill ${cls}`} style={{ width: `${pct}%` }} />
//                   </div>
//                   <span className="top3-score">{score}/10</span>
//                 </li>
//               );
//             })}
//           </ul>
//         </div>

//         <div className="stats-container">
//           <div className="stat-item">
//             <div className="stat-value">{totalAmenities}</div>
//             <div className="stat-label">Total Amenities</div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderModal = () => {
//     if (!isCategoryModalOpen || !modalCategory) return null;

//     // Determine start coords for primary and comparison columns
//     const primaryStreetCoords = extractLatLonFromStreetObj(streetData?.amenities?.street || {});
//     const comparisonStreetCoords = comparisonAmenities ? extractLatLonFromStreetObj(comparisonAmenities.area2?.street || {}) : { lat: null, lon: null };

//     return ReactDOM.createPortal(
//       <div className="modal-overlay">
//         <div
//           className="places-modal compare"
//           ref={modalRef}
//           onClick={(e) => e.stopPropagation()}
//         >
//           <div className="modal-header">
//             <h3>{amenityCategories.find(cat => cat.id === modalCategory)?.name || modalCategory}</h3>
//             <div className="modal-subtitle">
//               {showComparison && comparisonData && (
//                 <></>
//               )}
//             </div>
//             <button
//               className="close-detail"
//               onClick={closeCategoryModal}
//               aria-label="Close"
//             >
//               ×
//             </button>
//           </div>

//           <div className="modal-stats">
//             <div className="stat-group">
//               <div className="stat-label">Performance Score</div>
//               <div className="stat-value">{getCategoryRating(modalCategory).toFixed(1)}/10</div>
//             </div>
//             <p className="scoring-note">
//               Each amenity is scored based on a combination of proximity and quality.
//             </p>
//           </div>

//           <div className="modal-content compare">
//             <div className="modal-column">
//               <h4 className="primary-street">{streetData?.street?.split(',')[0]}</h4>
//               <div className="places-scrollable">
//                 {getAllPlacesForCategory(modalCategory, streetData?.street).length > 0 ? (
//                   getAllPlacesForCategory(modalCategory, streetData?.street).map((place, index) => (
//                     <PlaceItem key={index} place={place} category={modalCategory} startCoords={primaryStreetCoords} />
//                   ))
//                 ) : (
//                   <div className="no-places-message">No places found in this category</div>
//                 )}
//               </div>
//             </div>

//             {showComparison && comparisonData && (
//               <div className="modal-column">
//                 <h4 className="comparison-street">{comparisonData.area2.street.split(',')[0]}</h4>
//                 <div className="places-scrollable">
//                   {getAllPlacesForCategory(modalCategory, comparisonData.area2.street).length > 0 ? (
//                     getAllPlacesForCategory(modalCategory, comparisonData.area2.street).map((place, index) => (
//                       <PlaceItem key={index} place={place} category={modalCategory} startCoords={comparisonStreetCoords} />
//                     ))
//                   ) : (
//                     <div className="no-places-message">No places found in this category</div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>,
//       document.body
//     );
//   };

//   // Loading & error handling
//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="loading-spinner" />
//         <p>Loading street data...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return <ErrorComponent error={error} onRetry={() => { setError(null); setLoading(true); }} />;
//   }

//   if (!streetData) {
//     return <ErrorComponent error="No Data Available" onRetry={() => { setError(null); setLoading(true); }} />;
//   }

//   // Main render
//   return (
//     <>
//       {!isCategoryModalOpen && (
//         <div className="analysis-container">
//           <header className="analysis-header">
//             <button onClick={() => {
//               if (showComparison) {
//                 setShowComparison(false);
//                 navigate(`/analysis?street_id=${encodeURIComponent(streetData.id)}`, { replace: true });
//               } else {
//                 navigate(-1);
//               }
//             }} className="back-button">← Back</button>
//           </header>

//           <section className={`detailed-analysis-compare ${showComparison ? 'two-cards' : ''}`}>
//             <StreetDetailCard
//               street={streetData.street}
//               amenities={streetData.amenities}
//               overallScore={streetData.overall_score}
//               top3={streetData.top_3_attributes}
//               streetType="primary" // This makes it blue
//             />

//             {showComparison && comparisonData && (
//               <StreetDetailCard
//                 street={comparisonData.area2.street}
//                 amenities={comparisonAmenities?.area2}
//                 overallScore={comparisonData.area2.overall_score}
//                 top3={comparisonData.area2.top_3_attributes}
//                 streetType="comparison" // This makes it green
//               />
//             )}
//           </section>

//           <section className="compare-area">
//             <h2 className="section-title">Compare with Another Area</h2>
//             <div className="compare-card">
//               <div className="input-group" ref={compareRef} style={{ position: 'relative' }}>
//                 <input
//                   type="text"
//                   placeholder="Enter street name"
//                   className="compare-input"
//                   value={compareInput}
//                   onChange={(e) => {
//                     setCompareInput(e.target.value);
//                     setCompareSelectedId(null);
//                     setShowCompareSuggestions(true);
//                     setError(null);
//                   }}
//                   onKeyDown={(e) => {
//                     if (e.key === 'Enter') handleCompareSubmit(e);
//                     if (e.key === 'Escape') {
//                       setShowCompareSuggestions(false);
//                     }
//                   }}
//                 />
//                 <button className="compare-button" onClick={handleCompareSubmit}>Compare Areas</button>

//                 {/* Suggestions dropdown */}
//                 {showCompareSuggestions && compareSuggestions.length > 0 && (
//                   <div className="suggestions-dropdown compare-suggestions">
//                     {compareSuggestions.map(s => (
//                       <div key={s.id} className="suggestion-item" onClick={() => handleCompareSuggestionClick(s)}>
//                         <div className="suggestion-name">{s.name}</div>
//                         <div className="suggestion-postcode">{s.postcode}</div>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               <p className="compare-description">Compare {streetData.street.split(',')[0]} with any other area to see side-by-side amenity analysis</p>
//             </div>
//           </section>

//           {showComparison && comparisonData && (
//             <>
//               <section className="comparison-results">
//                 <h2 className="section-title">Comparison Results</h2>

//                 <div className="attribute-comparison">
//                   <h3>Attribute Scores</h3>
//                   <div className="attribute-grid">
//                     {Object.entries(comparisonData.area1.attributes).map(([attr, score]) => (
//                       <div key={attr} className="attribute-item">
//                         <div className="attribute-name">{amenityCategories.find(c => c.id === attr)?.name || attr}</div>
//                         <div className="attribute-scores">
//                           <span className="score1 primary-street">{score}</span> {/* Add class */}
//                           <span className="score-divider">:</span>
//                           <span className="score2 comparison-street">{comparisonData.area2.attributes[attr]}</span> {/* Add class */}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <button className="close-comparison" onClick={() => setShowComparison(false)}>Close Comparison</button>
//               </section>

//               <section className="amenity-comparison-container">
//                 <h2 className="section-title comparison-title">Amenity Comparison</h2>
//                 <p className="comparison-description">
//                   Scores are based on proximity and quality of amenities.
//                 </p>
//                 <div className="categories-grid comparison">
//                   {amenityCategories.map(category => {
//                     const street1Count = countAmenities(category.id);
//                     const street1Score = getCategoryRating(category.id);
//                     const street2Count = comparisonData.area2.category_counts[category.id] || 0;
//                     const street2Score = comparisonData.area2.attributes[category.id] || 0;

//                     if (street1Count === 0 && street2Count === 0) return null;

//                     return (
//                       <div key={category.id} className="category-card comparison" onClick={() => openCategoryModal(category.id)}>
//                         <div className="category-header">
//                           <div className="category-icon">{category.icon}</div>
//                           <h3 className="category-name">{category.name}</h3>
//                         </div>

//                         <div className="street-comparison">
//                           <div className="street-row">
//                             <div className="street-name primary-street">{comparisonData.area1.street.split(',')[0]}</div> {/* Add class */}
//                             <div className="score-display">
//                               <div className="street-score primary-street">{street1Score.toFixed(1)}/10</div> {/* Add class */}
//                               <div className="street-count">({street1Count} locations)</div>
//                             </div>
//                           </div>

//                           <div className="street-row">
//                             <div className="street-name comparison-street">{comparisonData.area2.street.split(',')[0]}</div> {/* Add class */}
//                             <div className="score-display">
//                               <div className="street-score comparison-street">{street2Score.toFixed(1)}/10</div> {/* Add class */}
//                               <div className="street-count">({street2Count} locations)</div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </section>
//             </>
//           )}

//           {!showComparison && (
//             <section className="amenity-categories">
//               <h2 className="section-title">All Amenity Categories</h2>
//               <div className="categories-grid">
//                 {amenityCategories.map(category => {
//                   const count = countAmenities(category.id);
//                   if (count === 0) return null;
//                   const score = getCategoryRating(category.id);

//                   return (
//                     <div key={category.id} className="category-card" onClick={() => openCategoryModal(category.id)}>
//                       <div className="category-header">
//                         <div className="category-icon">{category.icon}</div>
//                         <h3 className="category-name">{category.name}</h3>
//                       </div>
//                       <div className="street-row">
//                         <div className="score-display">
//                           <div className="street-score primary-street">{score.toFixed(1)}/10</div> {/* Add class */}
//                           <div className="street-count">({count} {count === 1 ? 'location' : 'locations'})</div>
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </section>
//           )}

//           {/* Enhanced AI Insights Section */}
//           <section className="ai-insights-section">
//             <div className="ai-header-container">
//               <div className="ai-header-left">
//                 <h2 className="section-title">AI-Powered Analysis</h2>
//                 <p className="ai-subtitle-description">
//                   {showComparison 
//                     ? 'AI-generated comparison of both streets' 
//                     : 'AI-generated insights about this street'
//                   }
//                 </p>
//               </div>
//               <div className="ai-header-right">
//                 <button 
//                   className="ai-action-btn regenerate-btn"
//                   onClick={() => fetchAISummaries(true)}
//                   disabled={aiLoading}
//                 >
//                   {aiLoading ? (
//                     <>
//                       <span className="spinner"></span>
//                       Generating...
//                     </>
//                   ) : (
//                     '🔄 Regenerate'
//                   )}
//                 </button>
//                 <button 
//                   className="ai-action-btn info-btn"
//                   onClick={() => {
//                     alert('This AI analysis is generated using Claude 3 Sonnet via AWS Bedrock. It analyzes amenity scores, location data, and provides lifestyle insights.');
//                   }}
//                   title="About AI Analysis"
//                 >
//                   ℹ️ Info
//                 </button>
//               </div>
//             </div>

//             {aiError && (
//               <div className="ai-error-alert">
//                 <div className="error-icon">⚠️</div>
//                 <div className="error-content">
//                   <p className="error-title">AI Generation Error</p>
//                   <p className="error-message">{aiError}</p>
//                   <button 
//                     className="error-retry-btn"
//                     onClick={() => fetchAISummaries(true)}
//                   >
//                     Try Again
//                   </button>
//                 </div>
//               </div>
//             )}

//             {/* AI Content Area */}
//             <div className="ai-content-area">
//               {aiLoading ? (
//                 <div className="ai-loading-state">
//                   <div className="ai-loading-spinner"></div>
//                   <p className="ai-loading-text">
//                     {showComparison 
//                       ? 'Generating AI comparison analysis...' 
//                       : 'Generating AI street analysis...'
//                     }
//                   </p>
//                   <p className="ai-loading-subtext">
//                     Analyzing amenity scores and generating insights...
//                   </p>
//                 </div>
//               ) : showComparison ? (
//                 renderComparisonAISection()
//               ) : aiSummaries.area1 ? (
//                 <div className="ai-single-street">
//                   {renderAICard(
//                     streetData?.street?.split(',')[0] || 'Street Analysis',
//                     aiSummaries.area1,
//                     'area1'
//                   )}
//                 </div>
//               ) : (
//                 <div className="ai-empty-state">
//                   <div className="ai-empty-icon">🤖</div>
//                   <p className="ai-empty-title">AI Analysis Not Generated</p>
//                   <p className="ai-empty-description">
//                     Click "Regenerate" to generate AI insights for this street.
//                     {showComparison && ' Or compare with another street to get a detailed comparison.'}
//                   </p>
//                   <button 
//                     className="ai-generate-btn"
//                     onClick={() => fetchAISummaries()}
//                   >
//                     Generate AI Analysis
//                   </button>
//                 </div>
//               )}
//             </div>

//             {/* AI Generation Info */}
//             {(aiSummaries.area1 || aiSummaries.comparison) && (
//               <div className="ai-footer-note">
//                 <p className="ai-note-text">
//                   <span className="ai-note-icon">💡</span>
//                   AI analysis generated using Claude 3 Sonnet. Insights are based on amenity scores and location data.
//                   {showComparison && ' Comparison highlights key differences and recommendations.'}
//                 </p>
//               </div>
//             )}
//           </section>
//         </div>
//       )}
//       {renderModal()}
//     </>
//   );
// };

// export default StreetAnalysis;







// import React, { useState, useEffect, useRef, useCallback } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
// import './AnalysisPage.css';
// import { BASE_URL } from '../constants';
// import ReactDOM from 'react-dom';
// import ErrorComponent from '../components/ErrorComponent';

// const StreetAnalysis = () => {
//   useEffect(() => { window.scrollTo(0, 0); }, []);

//   const navigate = useNavigate();
//   const location = useLocation();
//   const { user } = useAuth();

//   // Primary data
//   const [streetData, setStreetData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // UI / comparison state
//   // prefixed unused state variables with _ to silence lint while keeping setters available
//   const [_activeCategory, setActiveCategory] = useState(null);
//   const [compareInput, setCompareInput] = useState('');
//   const [compareSuggestions, setCompareSuggestions] = useState([]);
//   const [showCompareSuggestions, setShowCompareSuggestions] = useState(false);
//   const [_compareLoading, setCompareLoading] = useState(false);
//   const [compareSelectedId, setCompareSelectedId] = useState(null); // id selected from suggestions
//   const [comparisonData, setComparisonData] = useState(null);
//   const [comparisonAmenities, setComparisonAmenities] = useState(null);
//   const [showComparison, setShowComparison] = useState(false);

//   // modal state
//   const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
//   const [modalCategory, setModalCategory] = useState(null);
//   const [_modalStreetName, setModalStreetName] = useState('');

//   // AI summaries state
//   const [aiSummaries, setAiSummaries] = useState({
//     area1: null,
//     area2: null,
//     comparison: null,
//   });
//   const [aiLoading, setAiLoading] = useState(false);
//   const [aiError, setAiError] = useState(null);

//   const compareRef = useRef(null); // to close suggestions on outside click
//   const scrollPositionRef = useRef(0); // to remember scroll position when modal opens
//   const modalRef = useRef(null); // reference to the modal for click outside detection

//   // accept both 'street_id' and 'id' query params for compatibility
//   const queryParams = new URLSearchParams(location.search);
//   const streetIdFromUrl = queryParams.get('street_id') || queryParams.get('id') || null;

//   // left in but prefixed to silence unused-var lint (you can remove if not needed)
//   const _BAR_COLORS = {
//     Education: '#34D169',
//     Transport: '#3B82F6',
//     'Parks & Recreation': '#F59E0B',
//   };

//   const amenityCategories = [
//     { id: 'school', name: 'School', icon: '🏫' },
//     { id: 'university', name: 'University', icon: '🎓' },
//     { id: 'library', name: 'Library', icon: '📚' },
//     { id: 'hospital', name: 'Hospital', icon: '🏥' },
//     { id: 'doctor', name: 'Doctor', icon: '👨‍⚕️' },
//     { id: 'pharmacy', name: 'Pharmacy', icon: '💊' },
//     { id: 'restaurant', name: 'Restaurant', icon: '🍽️' },
//     { id: 'cafe', name: 'Café', icon: '☕' },
//     { id: 'bakery', name: 'Bakery', icon: '🥐' },
//     { id: 'bar', name: 'Bar', icon: '🍻' },
//     { id: 'grocery_or_supermarket', name: 'Grocery Store', icon: '🛒' },
//     { id: 'supermarket', name: 'Supermarket', icon: '🛍️' },
//     { id: 'bank', name: 'Bank', icon: '🏦' },
//     { id: 'atm', name: 'ATM', icon: '💳' },
//     { id: 'post_office', name: 'Post Office', icon: '📮' },
//     { id: 'gas_station', name: 'Petrol Station', icon: '⛽' },
//     { id: 'airport', name: 'Airport', icon: '✈️' },
//     { id: 'electric_vehicle_charging_station', name: 'EV Charging', icon: '🔌' },
//     { id: 'transport', name: 'Transport', icon: '🚆' },
//     { id: 'park', name: 'Park', icon: '🌳' },
//     { id: 'gym', name: 'Gym', icon: '💪' },
//     { id: 'stadium', name: 'Stadium', icon: '🏟️' },
//     { id: 'museum', name: 'Museum', icon: '🏛️' },
//     { id: 'art_gallery', name: 'Art Gallery', icon: '🎨' },
//     { id: 'movie_theater', name: 'Cinema', icon: '🎬' },
//   ];

//   const categoryToApiKey = {
//     school: 'schools',
//     university: 'university',
//     library: 'library',
//     hospital: 'hospitals',
//     doctor: 'doctor',
//     pharmacy: 'pharmacies',
//     restaurant: 'restaurants',
//     cafe: 'cafe',
//     bakery: 'bakery',
//     bar: 'bar',
//     grocery_or_supermarket: 'grocery_or_supermarket',
//     supermarket: 'supermarket',
//     bank: 'banks',
//     atm: 'atm',
//     post_office: 'post_office',
//     gas_station: 'gas_station',
//     park: 'park',
//     gym: 'gym',
//     stadium: 'stadium',
//     museum: 'museum',
//     art_gallery: 'art_gallery',
//     movie_theater: 'movie_theater',
//     airport: 'airport',
//     electric_vehicle_charging_station: 'electric_vehicle_charging_station',
//     transport: 'transports'
//   };

//   const transportIcons = {
//     bikepoint: '🚲', bus: '🚌', dlr: '🚈',
//     'national-rail': '🚆', overground: '🚇', tube: '🚇',
//     tram: '🚊', ferry: '⛴️', cable_car: '🚡', default: '📍'
//   };

//   // -------------------------
//   // New helpers for directions
//   // -------------------------
//   const buildDirectionsUrl = ({ startLat, startLon, endLat, endLon }) => {
//     // If any of the start or end coords are missing, fallback to a simple place query
//     const hasStart = startLat !== undefined && startLon !== undefined && startLat !== null && startLon !== null;
//     const hasEnd = endLat !== undefined && endLon !== undefined && endLat !== null && endLon !== null;

//     if (!hasEnd) return '#';

//     if (!hasStart) {
//       // Open end place in Maps if we don't have origin coords
//       return `https://maps.google.com/?q=${encodeURIComponent(endLat + ',' + endLon)}`;
//     }

//     // Normal directions URL
//     const origin = `${startLat},${startLon}`;
//     const destination = `${endLat},${endLon}`;
//     return `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}`;
//   };

//   const extractLatLonFromStreetObj = (streetObj) => {
//     if (!streetObj) return { lat: null, lon: null };
//     // Accept multiple possible field names returned by backend
//     const lat = streetObj.latitude ?? streetObj.lat ?? streetObj.location_lat ?? null;
//     const lon = streetObj.longitude ?? streetObj.lon ?? streetObj.lng ?? streetObj.location_lon ?? null;
//     return { lat, lon };
//   };

//   // kept but prefixed to avoid lint warning (not used right now)
//   const _getStreetCoordsForName = (streetName) => {
//     if (streetName === streetData?.street) {
//       return extractLatLonFromStreetObj(streetData?.amenities?.street || {});
//     }

//     if (comparisonAmenities && comparisonData) {
//       if (streetName === comparisonData.area1.street) {
//         return extractLatLonFromStreetObj(comparisonAmenities.area1?.street || {});
//       }
//       if (streetName === comparisonData.area2.street) {
//         return extractLatLonFromStreetObj(comparisonAmenities.area2?.street || {});
//       }
//     }

//     return { lat: null, lon: null };
//   };

//   // Close compare suggestions when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (compareRef.current && !compareRef.current.contains(e.target)) {
//         setShowCompareSuggestions(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   // Handle click outside modal
//   useEffect(() => {
//     const handleClickOutsideModal = (e) => {
//       if (isCategoryModalOpen && modalRef.current && !modalRef.current.contains(e.target)) {
//         closeCategoryModal();
//       }
//     };

//     const handleEscapeKey = (e) => {
//       if (isCategoryModalOpen && e.key === 'Escape') {
//         closeCategoryModal();
//       }
//     };

//     if (isCategoryModalOpen) {
//       document.addEventListener('mousedown', handleClickOutsideModal);
//       document.addEventListener('keydown', handleEscapeKey);
//     }

//     return () => {
//       document.removeEventListener('mousedown', handleClickOutsideModal);
//       document.removeEventListener('keydown', handleEscapeKey);
//     };
//   }, [isCategoryModalOpen]);

//   // Fetch main street rating + amenities using street_id
//   useEffect(() => {
//     const fetchStreet = async () => {
//       if (!streetIdFromUrl) {
//         navigate('/');
//         return;
//       }
//       setLoading(true);
//       setError(null);

//       try {
//         const token = localStorage.getItem('token');
//         const headers = token ? { Authorization: `Token ${token}` } : {};

//         // rating-summary expects street_id param (your backend)
//         const ratingRes = await fetch(
//           `${BASE_URL}api/streets/rating-summary/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
//           { headers }
//         );
//         if (!ratingRes.ok) throw new Error('Failed to fetch rating summary');
//         const ratingJson = await ratingRes.json();

//         // places-by-name supports street_id (preferred)
//         const placesRes = await fetch(
//           `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
//           { headers }
//         );
//         if (!placesRes.ok) throw new Error('Failed to fetch amenities');
//         const placesJson = await placesRes.json();

//         // Combine and keep rating id too
//         setStreetData({
//           id: ratingJson.id ?? streetIdFromUrl,
//           ...ratingJson,
//           amenities: placesJson,
//         });

//         if (ratingJson.top_3_attributes?.length > 0) {
//           setActiveCategory(ratingJson.top_3_attributes[0].name);
//         }
//       } catch (err) {
//         console.error(err);
//         setError(err.message || 'Failed to load street data');
//       } finally {
//         setLoading(false);
//       }
//     };

//     // only fetch when user is present (your pattern) — if you want public access, remove user guard
//     if (user && streetIdFromUrl) fetchStreet();
//     else setLoading(false);
//   }, [user, streetIdFromUrl, navigate]);

//   // Helper: fetch amenities by street id (uses street_id param)
//   const fetchAmenitiesById = async (id) => {
//     try {
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};
//       const res = await fetch(
//         `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(id)}`,
//         { headers }
//       );
//       if (!res.ok) throw new Error('Failed to fetch amenities');
//       return await res.json();
//     } catch (err) {
//       console.error('fetchAmenitiesById error:', err);
//       return { transports: {}, categories: {} };
//     }
//   };

//   // -------------------------
//   // Enhanced AI Summary Handler
//   // -------------------------
//    const fetchAISummaries = useCallback(async (forceRegenerate = false) => {
//     if (!streetData) return;
    
//     // Reset AI summaries when toggling comparison mode
//     if (forceRegenerate) {
//       setAiSummaries({ primary: null, secondary: null, comparison: null });
//     }
    
//     // Don't regenerate if we already have data and not forcing
//     if (!forceRegenerate && aiSummaries.primary && !showComparison) return;
    
//     setAiLoading(true);
//     setAiError(null);

//     try {
//       // Prepare payload based on backend expected format
//       const buildAmenitiesPayload = (data) => {
//         if (!data || !data.top_3_attributes) return [];
        
//         return data.top_3_attributes.map(attr => ({
//           name: attr.name,
//           score: attr.score
//         }));
//       };

//       const payload = {
//         area1: {
//           name: streetData.street,
//           overall_score: streetData.overall_score,
//           amenities: buildAmenitiesPayload(streetData)
//         }
//       };

//       // Add area2 if in comparison mode
//       if (showComparison && comparisonData) {
//         payload.area2 = {
//           name: comparisonData.area2.street,
//           overall_score: comparisonData.area2.overall_score,
//           amenities: buildAmenitiesPayload(comparisonData.area2)
//         };
//       }

//       console.log('Sending AI request:', payload);

//       const res = await fetch(`${BASE_URL}api/ai/summary/`, {
//         method: 'POST',
//         headers: { 
//           'Content-Type': 'application/json',
//           ...(user?.token ? { 'Authorization': `Token ${user.token}` } : {})
//         },
//         body: JSON.stringify(payload),
//       });

//       if (!res.ok) {
//         const errorText = await res.text();
//         throw new Error(`AI API error: ${res.status} - ${errorText}`);
//       }

//       const result = await res.json();
//       console.log('AI response received:', result);

//       // Handle different response formats from AWS Bedrock
//       const handleAIResponse = (response) => {
//         console.log('Processing AI response format:', response);
        
//         // Case 1: Backend returns direct structured response with area1, area2, comparison
//         if (response.area1 && response.area2 && response.comparison) {
//           return {
//             primary: response.area1,
//             secondary: response.area2,
//             comparison: response.comparison
//           };
//         }
        
//         // Case 2: Backend returns area1 only (single street response wrapped in area1)
//         if (response.area1 && !response.area2 && !response.comparison) {
//           return {
//             primary: response.area1,
//             secondary: null,
//             comparison: null
//           };
//         }
        
//         // Case 3: Backend returns simple single street response (one_liner, summary, etc.)
//         if (response.one_liner || response.summary || response.highlights) {
//           return {
//             primary: response,
//             secondary: null,
//             comparison: null
//           };
//         }
        
//         // Case 4: Raw string response (Claude sometimes returns raw JSON string)
//         if (response.raw) {
//           try {
//             const parsed = JSON.parse(response.raw);
//             return handleAIResponse(parsed);
//           } catch (e) {
//             console.log('Could not parse raw response as JSON:', e);
//             // If it's not JSON, treat it as plain text
//             return {
//               primary: { 
//                 summary: response.raw,
//                 one_liner: response.raw.split('.')[0] + '.',
//                 highlights: response.raw.split('.').filter(s => s.trim()).slice(0, 3)
//               },
//               secondary: null,
//               comparison: null
//             };
//           }
//         }
        
//         // Case 5: Fallback - show the whole response
//         console.log('Using fallback AI response format');
//         return {
//           primary: { 
//             summary: typeof response === 'string' ? response : JSON.stringify(response, null, 2),
//             one_liner: "AI analysis generated successfully.",
//             highlights: ["Analysis based on amenity scores", "Generated by Claude 3 Sonnet", "Professional property insights"]
//           },
//           secondary: null,
//           comparison: null
//         };
//       };

//       const processedResponse = handleAIResponse(result);
//       console.log('Processed AI response:', processedResponse);
//       setAiSummaries(processedResponse);

//     } catch (err) {
//       console.error('AI summary error:', err);
//       setAiError(err.message || 'Failed to generate AI summary. Please try again.');
      
//       // Provide helpful fallback content
//       const fallbackContent = {
//         primary: {
//           one_liner: `${streetData?.street?.split(',')[0]} offers a well-rounded urban living experience with strong amenity access.`,
//           summary: `This area scores ${streetData?.overall_score}/100 overall, indicating a balanced mix of amenities and services. The top categories include ${streetData?.top_3_attributes?.map(a => a.name).join(', ')}. The street provides good access to essential services and leisure facilities suitable for various lifestyles.`,
//           highlights: [
//             'Strong amenity coverage across multiple categories',
//             'Good balance of essential services and leisure options',
//             'Accessible location with reasonable transportation options'
//           ],
//           history: `${streetData?.street?.split(',')[0]} has developed as a residential area with consistent growth in local amenities. The area benefits from ongoing urban development while maintaining its neighborhood character.`
//         },
//         secondary: null,
//         comparison: null
//       };

//       if (showComparison && comparisonData) {
//         fallbackContent.secondary = {
//           one_liner: `${comparisonData.area2.street.split(',')[0]} presents a contrasting urban profile with different amenity strengths.`,
//           summary: `With an overall score of ${comparisonData.area2.overall_score}/100, this area shows different strengths including ${comparisonData.area2.top_3_attributes?.map(a => a.name).join(', ')}. The street offers unique advantages depending on specific lifestyle needs.`,
//           highlights: [
//             'Specialized amenity offerings in key categories',
//             'Distinct neighborhood character and services',
//             'Different transportation and access patterns'
//           ],
//           history: `${comparisonData.area2.street.split(',')[0]} has evolved with its own distinct development pattern, offering different urban characteristics compared to other areas.`
//         };
        
//         fallbackContent.comparison = {
//           summary: `Comparing ${streetData?.street?.split(',')[0]} (${streetData?.overall_score}/100) with ${comparisonData.area2.street.split(',')[0]} (${comparisonData.area2.overall_score}/100) reveals different urban living propositions.`,
//           differences: [
//             `Score difference of ${Math.abs(streetData?.overall_score - comparisonData.area2.overall_score)} points overall`,
//             'Different top amenity categories and strengths',
//             'Varied neighborhood characteristics and service availability'
//           ],
//           verdict: 'Each area offers unique advantages depending on specific lifestyle priorities and amenity preferences.'
//         };
//       }

//       setAiSummaries(fallbackContent);
//     } finally {
//       setAiLoading(false);
//     }
//   }, [streetData, showComparison, comparisonData, user, aiSummaries.primary]);

//   // Auto-fetch AI summary when street data loads
//   useEffect(() => {
//     if (streetData && !aiSummaries.primary) {
//       const timer = setTimeout(() => {
//         fetchAISummaries();
//       }, 500);
//       return () => clearTimeout(timer);
//     }
//   }, [streetData, fetchAISummaries]);

//   // Auto-fetch AI summary when comparison changes
//   useEffect(() => {
//     if (showComparison && comparisonData) {
//       // Reset and fetch fresh AI summary when entering comparison mode
//       setAiSummaries({ primary: null, secondary: null, comparison: null });
//       fetchAISummaries();
//     } else if (!showComparison && streetData && !aiSummaries.primary) {
//       // Fetch AI summary when exiting comparison mode
//       fetchAISummaries();
//     }
//   }, [showComparison, comparisonData]);
//   // Auto-fetch AI summary when street data loads
//   useEffect(() => {
//     if (streetData && !aiSummaries.area1) {
//       const timer = setTimeout(() => {
//         fetchAISummaries();
//       }, 500);
//       return () => clearTimeout(timer);
//     }
//   }, [streetData, fetchAISummaries]);

//   // Auto-fetch AI summary when comparison changes
//   useEffect(() => {
//     if (showComparison && comparisonData) {
//       fetchAISummaries();
//     }
//   }, [showComparison, comparisonData]);

//   // Helper: search streets for compare suggestions
//   const searchStreets = async (q) => {
//     try {
//       if (!q || !q.trim()) return [];
//       setCompareLoading(true);
//       const res = await fetch(`${BASE_URL}api/streets/search-streets/?q=${encodeURIComponent(q.trim())}`);
//       if (!res.ok) return [];
//       const data = await res.json(); // expects [{id,name,postcode}, ...]
//       return Array.isArray(data) ? data : [];
//     } catch (err) {
//       console.error('searchStreets error:', err);
//       return [];
//     } finally {
//       setCompareLoading(false);
//     }
//   };

//   // Debounce compare input to fetch suggestions
//   useEffect(() => {
//     if (!compareInput) {
//       setCompareSuggestions([]);
//       setShowCompareSuggestions(false);
//       setCompareSelectedId(null);
//       return;
//     }
//     const t = setTimeout(async () => {
//       const results = await searchStreets(compareInput);
//       setCompareSuggestions(results);
//       setShowCompareSuggestions(results.length > 0);
//     }, 300);
//     return () => clearTimeout(t);
//   }, [compareInput]);

//   // When user clicks a suggestion — set input, set selected id and immediately compare
//   const handleCompareSuggestionClick = async (suggestion) => {
//     setCompareInput(suggestion.name);
//     setCompareSelectedId(suggestion.id);
//     setShowCompareSuggestions(false);

//     // trigger compare by id (preferred)
//     await performCompareByIds(streetData?.id, suggestion.id);
//   };

//   // Perform compare with preferred id1/id2. If ids not available, fallback to q1/q2 name based compare
//   const performCompareByIds = async (id1, id2) => {
//     if (!id1 || !id2) {
//       setError('Both street IDs are required for comparison.');
//       return;
//     }
//     setLoading(true);
//     setError(null);

//     try {
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};

//       const res = await fetch(`${BASE_URL}api/streets/compare/?id1=${encodeURIComponent(id1)}&id2=${encodeURIComponent(id2)}`, { headers });
//       if (!res.ok) {
//         // fallback: if backend returns 404 or bad request, try name-based compare as a last resort
//         if (res.status === 404) throw new Error('One of the streets was not found for comparison.');
//         throw new Error('Failed to fetch comparison data');
//       }
//       const comp = await res.json();

//       // fetch amenities for both sides using returned ids (backend returns area1.id/area2.id)
//       const area1Id = comp?.area1?.id ?? id1;
//       const area2Id = comp?.area2?.id ?? id2;

//       const [amen1, amen2] = await Promise.all([fetchAmenitiesById(area1Id), fetchAmenitiesById(area2Id)]);

//       setComparisonData(comp);
//       setComparisonAmenities({ area1: amen1, area2: amen2 });
//       setShowComparison(true);

//       // scroll to results
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     } catch (err) {
//       console.error('performCompareByIds error:', err);
//       setError(err.message || 'Comparison failed');
//       setShowComparison(false);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // User pressed Enter in compare input — prefer selectedId, else attempt to find first match and compare by id,
//   // else fallback to name-based compare using q1/q2 endpoint.
//   const handleCompareSubmit = async (e) => {
//     e?.preventDefault?.();
//     if (!compareInput?.trim()) {
//       setError('Please enter a street name or pick a suggestion to compare.');
//       return;
//     }
//     setError(null);

//     if (compareSelectedId) {
//       return performCompareByIds(streetData?.id, compareSelectedId);
//     }

//     // Try to find a suggestion programmatically
//     const results = await searchStreets(compareInput);
//     if (results.length > 0) {
//       return performCompareByIds(streetData?.id, results[0].id);
//     }

//     // Last resort: name-based compare (q1/q2) — backend still supports this for backward compat
//     try {
//       setLoading(true);
//       const token = localStorage.getItem('token');
//       const headers = token ? { Authorization: `Token ${token}` } : {};
//       const res = await fetch(`${BASE_URL}api/streets/compare/?q1=${encodeURIComponent(streetData.street)}&q2=${encodeURIComponent(compareInput.trim())}`, { headers });
//       if (!res.ok) {
//         if (res.status === 404) throw new Error('Comparison street not found');
//         throw new Error('Comparison failed');
//       }
//       const comp = await res.json();
//       // fetch amenities using area names returned by compare (fallback)
//       const [amen1, amen2] = await Promise.all([fetchAmenitiesById(comp.area1.id || streetData.id), fetchAmenitiesById(comp.area2.id)]);
//       setComparisonData(comp);
//       setComparisonAmenities({ area1: amen1, area2: amen2 });
//       setShowComparison(true);
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     } catch (err) {
//       console.error('fallback name compare error:', err);
//       setError(err.message || 'Comparison failed');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Utilities used by UI (counts, ratings, places lists)
//   const countAmenities = (category) => {
//     if (!streetData?.amenities) return 0;
//     if (category === 'transport') {
//       const transport = streetData.amenities.transports || {};
//       return Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
//     }
//     const apiKey = categoryToApiKey[category];
//     if (!apiKey) return 0;
//     return streetData.amenities[apiKey]?.length || 0;
//   };

//   const getCategoryRating = (categoryId, data = streetData) => {
//     if (!data?.attributes || !data.attributes[0]) return 0;
//     return data.attributes[0][categoryId] || 0;
//   };

//   // kept but prefixed to avoid lint warning (not used right now)
//   const _getNearbyPlaces = (category) => {
//     if (!streetData?.amenities) return [];
//     if (category === 'transport') {
//       const transport = streetData.amenities.transports || {};
//       return Object.values(transport).flat().slice(0, 5);
//     }
//     const apiKey = categoryToApiKey[category];
//     if (!apiKey) return [];
//     return streetData.amenities[apiKey]?.slice(0, 5) || [];
//   };

//   const getAllPlacesForCategory = (category, streetNameParam) => {
//     // If streetNameParam === streetData.street => return from streetData
//     if (!streetNameParam) return [];
//     if (streetNameParam === streetData?.street) {
//       if (category === 'transport') {
//         const transport = streetData.amenities?.transports || {};
//         return Object.values(transport).flat();
//       }
//       const apiKey = categoryToApiKey[category];
//       if (!apiKey) return [];
//       return streetData.amenities?.[apiKey] || [];
//     }

//     // If comparisonAmenities present, pick the correct one
//     if (comparisonAmenities) {
//       const amenities = streetNameParam === comparisonData?.area1.street ? comparisonAmenities.area1 : comparisonAmenities.area2;
//       if (category === 'transport') {
//         const transport = amenities?.transports || {};
//         return Object.values(transport).flat();
//       }
//       const apiKey = categoryToApiKey[category];
//       if (!apiKey) return [];
//       return amenities?.[apiKey] || [];
//     }

//     return [];
//   };

//   // Modals and UI helpers
//   const openCategoryModal = (category, streetName = '') => {
//     // Store current scroll position before opening modal
//     scrollPositionRef.current = window.scrollY;
//     setModalCategory(category);
//     setModalStreetName(streetName || streetData?.street || '');
//     setIsCategoryModalOpen(true);

//     // Prevent body scrolling when modal is open
//     document.body.style.overflow = 'hidden';
//   };

//   const closeCategoryModal = () => {
//     setIsCategoryModalOpen(false);
//     setModalCategory(null);
//     // Restore body scrolling
//     document.body.style.overflow = 'unset';

//     // Restore scroll position after a short delay to allow modal to close
//     setTimeout(() => {
//       window.scrollTo(0, scrollPositionRef.current);
//     }, 10);
//   };

//   // Remove the problematic useEffect for modal body class
//   useEffect(() => {
//     return () => {
//       // Cleanup: ensure body scrolling is restored when component unmounts
//       document.body.style.overflow = 'unset';
//     };
//   }, []);

//   useEffect(() => {
//     if (showComparison) {
//       window.scrollTo({ top: 0, behavior: 'smooth' });
//     }
//   }, [showComparison]);

//   function getScoreClass(score) {
//     if (score < 8) return 'low';
//     if (score < 9) return 'medium';
//     return 'high';
//   }

//   // -------------------------
//   // AI Summary UI Components
//   // -------------------------
//   const renderAIHighlights = (highlights) => {
//     if (!highlights) return null;
    
//     if (Array.isArray(highlights)) {
//       return (
//         <ul className="ai-bullet-list">
//           {highlights.map((item, index) => (
//             <li key={index} className="ai-bullet-item">
//               <span className="ai-bullet-icon">•</span>
//               <span className="ai-bullet-text">{item}</span>
//             </li>
//           ))}
//         </ul>
//       );
//     }
    
//     if (typeof highlights === 'string') {
//       const items = highlights.split(/\n|;|\.(?=\s+[A-Z])/).filter(item => item.trim().length > 0);
//       if (items.length > 1) {
//         return (
//           <ul className="ai-bullet-list">
//             {items.map((item, index) => (
//               <li key={index} className="ai-bullet-item">
//                 <span className="ai-bullet-icon">•</span>
//                 <span className="ai-bullet-text">{item.trim()}</span>
//               </li>
//             ))}
//           </ul>
//         );
//       }
//       return <p className="ai-text">{highlights}</p>;
//     }
    
//     return null;
//   };

//   const renderAICard = (title, data, areaKey, isComparison = false) => {
//     if (!data) return null;

//     return (
//       <div className={`ai-summary-card ${isComparison ? 'comparison-card' : ''}`}>
//         <div className="ai-card-header">
//           <h3 className="ai-card-title">{title}</h3>
          
//           {data.one_liner && (
//             <div className="ai-one-liner-section">
//               <div className="ai-section-header">
//                 <h4 className="ai-subtitle">🧭 Quick Summary</h4>
//               </div>
//               <div className="ai-one-liner">
//                 <div className="ai-quote-icon">"</div>
//                 <p className="ai-one-liner-text">{data.one_liner}</p>
//                 <div className="ai-quote-icon">"</div>
//               </div>
//             </div>
//           )}

//           {data.summary && (
//             <div className="ai-section">
//               <div className="ai-section-header">
//                 <h4 className="ai-subtitle">📋 Detailed Analysis</h4>
//               </div>
//               <div className="ai-summary-content">
//                 <p className="ai-text">{data.summary}</p>
//               </div>
//             </div>
//           )}

//           {data.highlights && (
//             <div className="ai-section">
//               <div className="ai-section-header">
//                 <h4 className="ai-subtitle">⭐ Key Highlights</h4>
//               </div>
//               <div className="ai-highlights-content">
//                 {renderAIHighlights(data.highlights)}
//               </div>
//             </div>
//           )}

//           {data.history && (
//             <div className="ai-section">
//               <div className="ai-section-header">
//                 <h4 className="ai-subtitle">🏛️ Area Background</h4>
//               </div>
//               <div className="ai-history-content">
//                 <p className="ai-text">{data.history}</p>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     );
//   };

//    const renderComparisonAISection = () => {
//     // When in comparison mode, we should have primary, secondary, and comparison
//     if (showComparison && aiSummaries.primary && aiSummaries.secondary && aiSummaries.comparison) {
//       return (
//         <div className="ai-comparison-grid">
//           <div className="ai-comparison-row">
//             {renderAICard(
//               streetData?.street?.split(',')[0], 
//               aiSummaries.primary, 
//               'primary', 
//               true
//             )}
//             {renderAICard(
//               comparisonData?.area2?.street?.split(',')[0], 
//               aiSummaries.secondary, 
//               'secondary', 
//               true
//             )}
//           </div>
          
//           <div className="ai-comparison-summary">
//             <div className="ai-section">
//               <div className="ai-section-header">
//                 <h4 className="ai-subtitle">📊 Comparison Overview</h4>
//               </div>
//               <div className="ai-summary-content">
//                 <p className="ai-text">{aiSummaries.comparison.summary}</p>
//               </div>
//             </div>

//             {aiSummaries.comparison.differences && (
//               <div className="ai-section">
//                 <div className="ai-section-header">
//                   <h4 className="ai-subtitle">🔍 Key Differences</h4>
//                 </div>
//                 <div className="ai-highlights-content">
//                   {renderAIHighlights(aiSummaries.comparison.differences)}
//                 </div>
//               </div>
//             )}

//             {aiSummaries.comparison.verdict && (
//               <div className="ai-section">
//                 <div className="ai-section-header">
//                   <h4 className="ai-subtitle">⚖️ Final Verdict</h4>
//                 </div>
//                 <div className="ai-verdict-content">
//                   <div className="ai-verdict-box">
//                     <p className="ai-verdict-text">{aiSummaries.comparison.verdict}</p>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       );
//     }
    
//     // When in comparison mode but AI data isn't ready yet
//     if (showComparison) {
//       return (
//         <div className="ai-loading-state">
//           <div className="ai-loading-spinner"></div>
//           <p className="ai-loading-text">Generating AI comparison analysis...</p>
//         </div>
//       );
//     }
    
//     return null;
//   };

//     const renderAIInsightsContent = () => {
//     if (aiLoading) {
//       return (
//         <div className="ai-loading-state">
//           <div className="ai-loading-spinner"></div>
//           <p className="ai-loading-text">
//             {showComparison 
//               ? 'Generating AI comparison analysis...' 
//               : 'Generating AI street analysis...'
//             }
//           </p>
//           <p className="ai-loading-subtext">
//             Analyzing amenity scores and generating insights...
//           </p>
//         </div>
//       );
//     }

//     if (aiError) {
//       return (
//         <div className="ai-error-alert">
//           <div className="error-icon">⚠️</div>
//           <div className="error-content">
//             <p className="error-title">AI Generation Error</p>
//             <p className="error-message">{aiError}</p>
//             <button 
//               className="error-retry-btn"
//               onClick={() => fetchAISummaries(true)}
//             >
//               Try Again
//             </button>
//           </div>
//         </div>
//       );
//     }

//     if (showComparison) {
//       return renderComparisonAISection();
//     }

//     // Single street mode - check for primary summary
//     if (aiSummaries.primary) {
//       return (
//         <div className="ai-single-street">
//           {renderAICard(
//             streetData?.street?.split(',')[0] || 'Street Analysis',
//             aiSummaries.primary,
//             'primary'
//           )}
//         </div>
//       );
//     }

//     // No AI data yet
//     return (
//       <div className="ai-empty-state">
//         <div className="ai-empty-icon">🤖</div>
//         <p className="ai-empty-title">AI Analysis Not Generated</p>
//         <p className="ai-empty-description">
//           Click "Regenerate" to generate AI insights for this street.
//           {showComparison && ' Or compare with another street to get a detailed comparison.'}
//         </p>
//         <button 
//           className="ai-generate-btn"
//           onClick={() => fetchAISummaries()}
//         >
//           Generate AI Analysis
//         </button>
//       </div>
//     );
//   };
//   // UI components: PlaceItem, StreetDetailCard, modal renderer
//   const PlaceItem = ({ place, category, startCoords }) => {
//     // startCoords should be an object with { lat, lon }
//     const endLat = place.latitude ?? place.lat ?? place.location_lat ?? null;
//     const endLon = place.longitude ?? place.lon ?? place.location_lon ?? null;

//     const startLat = startCoords?.lat ?? null;
//     const startLon = startCoords?.lon ?? null;

//     const directionsUrl = buildDirectionsUrl({ startLat, startLon, endLat, endLon });

//     return (
//       <div className="place-item">
//         <div className="place-name">
//           {category === 'transport' && place.stop_type && (
//             <span className="transport-icon">{transportIcons[place.stop_type] || transportIcons.default}</span>
//           )}
//           {place.name}
//         </div>
//         {place.final_rating && <div className="place-rating">Rating: {place.final_rating}</div>}
//         <div className="place-links">
//           {endLat && endLon && (
//             <a href={directionsUrl} target="_blank" rel="noopener noreferrer" className="map-link">View on Map</a>
//           )}
//         </div>
//       </div>
//     );
//   };

//   const StreetDetailCard = ({ street, amenities, overallScore, top3, streetType = 'primary' }) => {
//     const streetNameShort = (typeof street === 'string') ? street.split(',')[0] : '';
//     const postcode = amenities?.street?.postcode || 'London';

//     const totalAmenities = Object.keys(amenities || {})
//       .filter(key => key !== 'street')
//       .reduce((total, key) => {
//         if (key === 'transports') {
//           const transport = amenities.transports || {};
//           return total + Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
//         }
//         return total + (amenities[key]?.length || 0);
//       }, 0);

//     // Determine CSS class based on streetType
//     const streetColorClass = streetType === 'primary' ? 'primary-street' : 'comparison-street';

//     return (
//       <div className="street-detail-card">
//         <div className="location-info">
//           <h2 className={streetColorClass}>{streetNameShort}</h2> {/* Add color class here */}
//           <p>{postcode}</p>
//         </div>

//         <div className="scores-container">
//           <div className="score-item main-score">
//             <div className={`score-value ${streetColorClass}`}>{overallScore}/100</div> {/* Add color class here */}
//             <div className="score-label">Lifestyle Score</div>
//           </div>
//         </div>

//         <div className="top-3-inline">
//           <h3 className="subsection-title">Top 3 Amenity Categories</h3>
//           <ul className="top3-list">
//             {(top3 || []).map((attr, i) => {
//               const key = attr.name.toLowerCase();
//               const cat = amenityCategories.find(c => c.id === key);
//               const icon = cat ? cat.icon : '📍';
//               const label = cat ? cat.name : attr.name;
//               const score = +attr.score.toFixed(1);
//               const pct = (score / 10) * 100;
//               const cls = getScoreClass(score);

//               return (
//                 <li key={i} className="top3-item" style={{ '--i': i }}>
//                   <span className="top3-icon">{icon}</span>
//                   <span className="top3-label">{label}</span>
//                   <div className="top3-bar">
//                     <div className={`top3-fill ${cls}`} style={{ width: `${pct}%` }} />
//                   </div>
//                   <span className="top3-score">{score}/10</span>
//                 </li>
//               );
//             })}
//           </ul>
//         </div>

//         <div className="stats-container">
//           <div className="stat-item">
//             <div className="stat-value">{totalAmenities}</div>
//             <div className="stat-label">Total Amenities</div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderModal = () => {
//     if (!isCategoryModalOpen || !modalCategory) return null;

//     // Determine start coords for primary and comparison columns
//     const primaryStreetCoords = extractLatLonFromStreetObj(streetData?.amenities?.street || {});
//     const comparisonStreetCoords = comparisonAmenities ? extractLatLonFromStreetObj(comparisonAmenities.area2?.street || {}) : { lat: null, lon: null };

//     return ReactDOM.createPortal(
//       <div className="modal-overlay">
//         <div
//           className="places-modal compare"
//           ref={modalRef}
//           onClick={(e) => e.stopPropagation()}
//         >
//           <div className="modal-header">
//             <h3>{amenityCategories.find(cat => cat.id === modalCategory)?.name || modalCategory}</h3>
//             <div className="modal-subtitle">
//               {showComparison && comparisonData && (
//                 <></>
//               )}
//             </div>
//             <button
//               className="close-detail"
//               onClick={closeCategoryModal}
//               aria-label="Close"
//             >
//               ×
//             </button>
//           </div>

//           <div className="modal-stats">
//             <div className="stat-group">
//               <div className="stat-label">Performance Score</div>
//               <div className="stat-value">{getCategoryRating(modalCategory).toFixed(1)}/10</div>
//             </div>
//             <p className="scoring-note">
//               Each amenity is scored based on a combination of proximity and quality.
//             </p>
//           </div>

//           <div className="modal-content compare">
//             <div className="modal-column">
//               <h4 className="primary-street">{streetData?.street?.split(',')[0]}</h4>
//               <div className="places-scrollable">
//                 {getAllPlacesForCategory(modalCategory, streetData?.street).length > 0 ? (
//                   getAllPlacesForCategory(modalCategory, streetData?.street).map((place, index) => (
//                     <PlaceItem key={index} place={place} category={modalCategory} startCoords={primaryStreetCoords} />
//                   ))
//                 ) : (
//                   <div className="no-places-message">No places found in this category</div>
//                 )}
//               </div>
//             </div>

//             {showComparison && comparisonData && (
//               <div className="modal-column">
//                 <h4 className="comparison-street">{comparisonData.area2.street.split(',')[0]}</h4>
//                 <div className="places-scrollable">
//                   {getAllPlacesForCategory(modalCategory, comparisonData.area2.street).length > 0 ? (
//                     getAllPlacesForCategory(modalCategory, comparisonData.area2.street).map((place, index) => (
//                       <PlaceItem key={index} place={place} category={modalCategory} startCoords={comparisonStreetCoords} />
//                     ))
//                   ) : (
//                     <div className="no-places-message">No places found in this category</div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>,
//       document.body
//     );
//   };

//   // Loading & error handling
//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div className="loading-spinner" />
//         <p>Loading street data...</p>
//       </div>
//     );
//   }

//   if (error) {
//     return <ErrorComponent error={error} onRetry={() => { setError(null); setLoading(true); }} />;
//   }

//   if (!streetData) {
//     return <ErrorComponent error="No Data Available" onRetry={() => { setError(null); setLoading(true); }} />;
//   }

//   // Main render
//   return (
//     <>
//       {!isCategoryModalOpen && (
//         <div className="analysis-container">
//           <header className="analysis-header">
//             <button onClick={() => {
//               if (showComparison) {
//                 setShowComparison(false);
//                 navigate(`/analysis?street_id=${encodeURIComponent(streetData.id)}`, { replace: true });
//               } else {
//                 navigate(-1);
//               }
//             }} className="back-button">← Back</button>
//           </header>

//           <section className={`detailed-analysis-compare ${showComparison ? 'two-cards' : ''}`}>
//             <StreetDetailCard
//               street={streetData.street}
//               amenities={streetData.amenities}
//               overallScore={streetData.overall_score}
//               top3={streetData.top_3_attributes}
//               streetType="primary" // This makes it blue
//             />

//             {showComparison && comparisonData && (
//               <StreetDetailCard
//                 street={comparisonData.area2.street}
//                 amenities={comparisonAmenities?.area2}
//                 overallScore={comparisonData.area2.overall_score}
//                 top3={comparisonData.area2.top_3_attributes}
//                 streetType="comparison" // This makes it green
//               />
//             )}
//           </section>

//           <section className="compare-area">
//             <h2 className="section-title">Compare with Another Area</h2>
//             <div className="compare-card">
//               <div className="input-group" ref={compareRef} style={{ position: 'relative' }}>
//                 <input
//                   type="text"
//                   placeholder="Enter street name"
//                   className="compare-input"
//                   value={compareInput}
//                   onChange={(e) => {
//                     setCompareInput(e.target.value);
//                     setCompareSelectedId(null);
//                     setShowCompareSuggestions(true);
//                     setError(null);
//                   }}
//                   onKeyDown={(e) => {
//                     if (e.key === 'Enter') handleCompareSubmit(e);
//                     if (e.key === 'Escape') {
//                       setShowCompareSuggestions(false);
//                     }
//                   }}
//                 />
//                 <button className="compare-button" onClick={handleCompareSubmit}>Compare Areas</button>

//                 {/* Suggestions dropdown */}
//                 {showCompareSuggestions && compareSuggestions.length > 0 && (
//                   <div className="suggestions-dropdown compare-suggestions">
//                     {compareSuggestions.map(s => (
//                       <div key={s.id} className="suggestion-item" onClick={() => handleCompareSuggestionClick(s)}>
//                         <div className="suggestion-name">{s.name}</div>
//                         <div className="suggestion-postcode">{s.postcode}</div>
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>

//               <p className="compare-description">Compare {streetData.street.split(',')[0]} with any other area to see side-by-side amenity analysis</p>
//             </div>
//           </section>

//           {showComparison && comparisonData && (
//             <>
//               <section className="comparison-results">
//                 <h2 className="section-title">Comparison Results</h2>

//                 <div className="attribute-comparison">
//                   <h3>Attribute Scores</h3>
//                   <div className="attribute-grid">
//                     {Object.entries(comparisonData.area1.attributes).map(([attr, score]) => (
//                       <div key={attr} className="attribute-item">
//                         <div className="attribute-name">{amenityCategories.find(c => c.id === attr)?.name || attr}</div>
//                         <div className="attribute-scores">
//                           <span className="score1 primary-street">{score}</span> {/* Add class */}
//                           <span className="score-divider">:</span>
//                           <span className="score2 comparison-street">{comparisonData.area2.attributes[attr]}</span> {/* Add class */}
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>

//                 <button className="close-comparison" onClick={() => setShowComparison(false)}>Close Comparison</button>
//               </section>

//               <section className="amenity-comparison-container">
//                 <h2 className="section-title comparison-title">Amenity Comparison</h2>
//                 <p className="comparison-description">
//                   Scores are based on proximity and quality of amenities.
//                 </p>
//                 <div className="categories-grid comparison">
//                   {amenityCategories.map(category => {
//                     const street1Count = countAmenities(category.id);
//                     const street1Score = getCategoryRating(category.id);
//                     const street2Count = comparisonData.area2.category_counts[category.id] || 0;
//                     const street2Score = comparisonData.area2.attributes[category.id] || 0;

//                     if (street1Count === 0 && street2Count === 0) return null;

//                     return (
//                       <div key={category.id} className="category-card comparison" onClick={() => openCategoryModal(category.id)}>
//                         <div className="category-header">
//                           <div className="category-icon">{category.icon}</div>
//                           <h3 className="category-name">{category.name}</h3>
//                         </div>

//                         <div className="street-comparison">
//                           <div className="street-row">
//                             <div className="street-name primary-street">{comparisonData.area1.street.split(',')[0]}</div> {/* Add class */}
//                             <div className="score-display">
//                               <div className="street-score primary-street">{street1Score.toFixed(1)}/10</div> {/* Add class */}
//                               <div className="street-count">({street1Count} locations)</div>
//                             </div>
//                           </div>

//                           <div className="street-row">
//                             <div className="street-name comparison-street">{comparisonData.area2.street.split(',')[0]}</div> {/* Add class */}
//                             <div className="score-display">
//                               <div className="street-score comparison-street">{street2Score.toFixed(1)}/10</div> {/* Add class */}
//                               <div className="street-count">({street2Count} locations)</div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })}
//                 </div>
//               </section>
//             </>
//           )}

//           {!showComparison && (
//             <section className="amenity-categories">
//               <h2 className="section-title">All Amenity Categories</h2>
//               <div className="categories-grid">
//                 {amenityCategories.map(category => {
//                   const count = countAmenities(category.id);
//                   if (count === 0) return null;
//                   const score = getCategoryRating(category.id);

//                   return (
//                     <div key={category.id} className="category-card" onClick={() => openCategoryModal(category.id)}>
//                       <div className="category-header">
//                         <div className="category-icon">{category.icon}</div>
//                         <h3 className="category-name">{category.name}</h3>
//                       </div>
//                       <div className="street-row">
//                         <div className="score-display">
//                           <div className="street-score primary-street">{score.toFixed(1)}/10</div> {/* Add class */}
//                           <div className="street-count">({count} {count === 1 ? 'location' : 'locations'})</div>
//                         </div>
//                       </div>
//                     </div>
//                   );
//                 })}
//               </div>
//             </section>
//           )}

//           {/* Enhanced AI Insights Section */}
//           <section className="ai-insights-section">
//             <div className="ai-header-container">
//               <div className="ai-header-left">
//                 <h2 className="section-title">AI-Powered Analysis</h2>
//                 <p className="ai-subtitle-description">
//                   {showComparison 
//                     ? 'AI-generated comparison of both streets' 
//                     : 'AI-generated insights about this street'
//                   }
//                 </p>
//               </div>
//               <div className="ai-header-right">
//                 <button 
//                   className="ai-action-btn regenerate-btn"
//                   onClick={() => fetchAISummaries(true)}
//                   disabled={aiLoading}
//                 >
//                   {aiLoading ? (
//                     <>
//                       <span className="spinner"></span>
//                       Generating...
//                     </>
//                   ) : (
//                     '🔄 Regenerate'
//                   )}
//                 </button>
//                 <button 
//                   className="ai-action-btn info-btn"
//                   onClick={() => {
//                     alert('This AI analysis is generated using Claude 3 Sonnet via AWS Bedrock. It analyzes amenity scores, location data, and provides lifestyle insights.');
//                   }}
//                   title="About AI Analysis"
//                 >
//                   ℹ️ Info
//                 </button>
//               </div>
//             </div>

//             {/* Use the new render function */}
//             <div className="ai-content-area">
//               {renderAIInsightsContent()}
//             </div>

//             {/* AI Generation Info */}
//             {(aiSummaries.primary || aiSummaries.comparison) && (
//               <div className="ai-footer-note">
//                 <p className="ai-note-text">
//                   <span className="ai-note-icon">💡</span>
//                   AI analysis generated using Claude 3 Sonnet. Insights are based on amenity scores and location data.
//                   {showComparison && ' Comparison highlights key differences and recommendations.'}
//                 </p>
//               </div>
//             )}
//           </section>
//         </div>
//       )}
//       {renderModal()}
//     </>
//   );
// };

// export default StreetAnalysis;


import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AnalysisPage.css';
import { BASE_URL } from '../constants';
import ReactDOM from 'react-dom';
import ErrorComponent from '../components/ErrorComponent';

const StreetAnalysis = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  // Primary data
  const [streetData, setStreetData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // UI / comparison state
  const [_activeCategory, setActiveCategory] = useState(null);
  const [compareInput, setCompareInput] = useState('');
  const [compareSuggestions, setCompareSuggestions] = useState([]);
  const [showCompareSuggestions, setShowCompareSuggestions] = useState(false);
  const [_compareLoading, setCompareLoading] = useState(false);
  const [compareSelectedId, setCompareSelectedId] = useState(null);
  const [comparisonData, setComparisonData] = useState(null);
  const [comparisonAmenities, setComparisonAmenities] = useState(null);
  const [showComparison, setShowComparison] = useState(false);

  // modal state
  const [isCategoryModalOpen, setIsCategoryModalOpen] = useState(false);
  const [modalCategory, setModalCategory] = useState(null);
  const [_modalStreetName, setModalStreetName] = useState('');

  // AI summaries state - FIXED: Use consistent structure
  const [aiSummaries, setAiSummaries] = useState({
    primary: null,    // For main street (always)
    secondary: null,  // For comparison street (only in comparison mode)
    comparison: null  // For comparison summary (only in comparison mode)
  });
  const [aiLoading, setAiLoading] = useState(false);
  const [aiError, setAiError] = useState(null);

  const compareRef = useRef(null);
  const scrollPositionRef = useRef(0);
  const modalRef = useRef(null);

  // accept both 'street_id' and 'id' query params for compatibility
  const queryParams = new URLSearchParams(location.search);
  const streetIdFromUrl = queryParams.get('street_id') || queryParams.get('id') || null;

  const _BAR_COLORS = {
    Education: '#34D169',
    Transport: '#3B82F6',
    'Parks & Recreation': '#F59E0B',
  };

  const amenityCategories = [
    { id: 'school', name: 'School', icon: '🏫' },
    { id: 'university', name: 'University', icon: '🎓' },
    { id: 'library', name: 'Library', icon: '📚' },
    { id: 'hospital', name: 'Hospital', icon: '🏥' },
    { id: 'doctor', name: 'Doctor', icon: '👨‍⚕️' },
    { id: 'pharmacy', name: 'Pharmacy', icon: '💊' },
    { id: 'restaurant', name: 'Restaurant', icon: '🍽️' },
    { id: 'cafe', name: 'Café', icon: '☕' },
    { id: 'bakery', name: 'Bakery', icon: '🥐' },
    { id: 'bar', name: 'Bar', icon: '🍻' },
    { id: 'grocery_or_supermarket', name: 'Grocery Store', icon: '🛒' },
    { id: 'supermarket', name: 'Supermarket', icon: '🛍️' },
    { id: 'bank', name: 'Bank', icon: '🏦' },
    { id: 'atm', name: 'ATM', icon: '💳' },
    { id: 'post_office', name: 'Post Office', icon: '📮' },
    { id: 'gas_station', name: 'Petrol Station', icon: '⛽' },
    { id: 'airport', name: 'Airport', icon: '✈️' },
    { id: 'electric_vehicle_charging_station', name: 'EV Charging', icon: '🔌' },
    { id: 'transport', name: 'Transport', icon: '🚆' },
    { id: 'park', name: 'Park', icon: '🌳' },
    { id: 'gym', name: 'Gym', icon: '💪' },
    { id: 'stadium', name: 'Stadium', icon: '🏟️' },
    { id: 'museum', name: 'Museum', icon: '🏛️' },
    { id: 'art_gallery', name: 'Art Gallery', icon: '🎨' },
    { id: 'movie_theater', name: 'Cinema', icon: '🎬' },
  ];

  const categoryToApiKey = {
    school: 'schools',
    university: 'university',
    library: 'library',
    hospital: 'hospitals',
    doctor: 'doctor',
    pharmacy: 'pharmacies',
    restaurant: 'restaurants',
    cafe: 'cafe',
    bakery: 'bakery',
    bar: 'bar',
    grocery_or_supermarket: 'grocery_or_supermarket',
    supermarket: 'supermarket',
    bank: 'banks',
    atm: 'atm',
    post_office: 'post_office',
    gas_station: 'gas_station',
    park: 'park',
    gym: 'gym',
    stadium: 'stadium',
    museum: 'museum',
    art_gallery: 'art_gallery',
    movie_theater: 'movie_theater',
    airport: 'airport',
    electric_vehicle_charging_station: 'electric_vehicle_charging_station',
    transport: 'transports'
  };

  const transportIcons = {
    bikepoint: '🚲', bus: '🚌', dlr: '🚈',
    'national-rail': '🚆', overground: '🚇', tube: '🚇',
    tram: '🚊', ferry: '⛴️', cable_car: '🚡', default: '📍'
  };

  // -------------------------
  // Helper functions
  // -------------------------
  const buildDirectionsUrl = ({ startLat, startLon, endLat, endLon }) => {
    const hasStart = startLat !== undefined && startLon !== undefined && startLat !== null && startLon !== null;
    const hasEnd = endLat !== undefined && endLon !== undefined && endLat !== null && endLon !== null;

    if (!hasEnd) return '#';

    if (!hasStart) {
      return `https://maps.google.com/?q=${encodeURIComponent(endLat + ',' + endLon)}`;
    }

    const origin = `${startLat},${startLon}`;
    const destination = `${endLat},${endLon}`;
    return `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}`;
  };

  const extractLatLonFromStreetObj = (streetObj) => {
    if (!streetObj) return { lat: null, lon: null };
    const lat = streetObj.latitude ?? streetObj.lat ?? streetObj.location_lat ?? null;
    const lon = streetObj.longitude ?? streetObj.lon ?? streetObj.lng ?? streetObj.location_lon ?? null;
    return { lat, lon };
  };

  const _getStreetCoordsForName = (streetName) => {
    if (streetName === streetData?.street) {
      return extractLatLonFromStreetObj(streetData?.amenities?.street || {});
    }

    if (comparisonAmenities && comparisonData) {
      if (streetName === comparisonData.area1.street) {
        return extractLatLonFromStreetObj(comparisonAmenities.area1?.street || {});
      }
      if (streetName === comparisonData.area2.street) {
        return extractLatLonFromStreetObj(comparisonAmenities.area2?.street || {});
      }
    }

    return { lat: null, lon: null };
  };

  // Close compare suggestions when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (compareRef.current && !compareRef.current.contains(e.target)) {
        setShowCompareSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Handle click outside modal
  useEffect(() => {
    const handleClickOutsideModal = (e) => {
      if (isCategoryModalOpen && modalRef.current && !modalRef.current.contains(e.target)) {
        closeCategoryModal();
      }
    };

    const handleEscapeKey = (e) => {
      if (isCategoryModalOpen && e.key === 'Escape') {
        closeCategoryModal();
      }
    };

    if (isCategoryModalOpen) {
      document.addEventListener('mousedown', handleClickOutsideModal);
      document.addEventListener('keydown', handleEscapeKey);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutsideModal);
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isCategoryModalOpen]);

  // Fetch main street rating + amenities using street_id
  useEffect(() => {
    const fetchStreet = async () => {
      if (!streetIdFromUrl) {
        navigate('/');
        return;
      }
      setLoading(true);
      setError(null);

      try {
        const token = localStorage.getItem('token');
        const headers = token ? { Authorization: `Token ${token}` } : {};

        const ratingRes = await fetch(
          `${BASE_URL}api/streets/rating-summary/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
          { headers }
        );
        if (!ratingRes.ok) throw new Error('Failed to fetch rating summary');
        const ratingJson = await ratingRes.json();

        const placesRes = await fetch(
          `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(streetIdFromUrl)}`,
          { headers }
        );
        if (!placesRes.ok) throw new Error('Failed to fetch amenities');
        const placesJson = await placesRes.json();

        setStreetData({
          id: ratingJson.id ?? streetIdFromUrl,
          ...ratingJson,
          amenities: placesJson,
        });

        if (ratingJson.top_3_attributes?.length > 0) {
          setActiveCategory(ratingJson.top_3_attributes[0].name);
        }
      } catch (err) {
        console.error(err);
        setError(err.message || 'Failed to load street data');
      } finally {
        setLoading(false);
      }
    };

    if (user && streetIdFromUrl) fetchStreet();
    else setLoading(false);
  }, [user, streetIdFromUrl, navigate]);

  // Helper: fetch amenities by street id
  const fetchAmenitiesById = async (id) => {
    try {
      const token = localStorage.getItem('token');
      const headers = token ? { Authorization: `Token ${token}` } : {};
      const res = await fetch(
        `${BASE_URL}api/streets/places-by-name/?street_id=${encodeURIComponent(id)}`,
        { headers }
      );
      if (!res.ok) throw new Error('Failed to fetch amenities');
      return await res.json();
    } catch (err) {
      console.error('fetchAmenitiesById error:', err);
      return { transports: {}, categories: {} };
    }
  };

  // -------------------------
  // FIXED AI Summary Handler - No infinite loops
  // -------------------------
  const fetchAISummaries = useCallback(async (forceRegenerate = false) => {
    if (!streetData) return;
    
    setAiLoading(true);
    setAiError(null);

    try {
      // const buildAmenitiesPayload = (data) => {
      //   if (!data || !data.attributes) return [];
      //   return data.attributes.map((key,value) => ({
      //     name: key,
      //     score: value
      //   }));
      // };

      const buildAmenitiesPayload = (data, { sortByScore = false, descending = true } = {}) => {
  if (!data || !data.attributes) return [];

  // ensure attributes is treated as an array of objects
  const attrsArray = Array.isArray(data.attributes) ? data.attributes : [data.attributes];

  // merge all attribute objects into one (if there's only one, this is just that object)
  const merged = attrsArray.reduce((acc, obj) => {
    if (obj && typeof obj === 'object') return { ...acc, ...obj };
    return acc;
  }, {});

  // convert object entries to [{ name, score }, ...], filter non-numeric scores
  const result = Object.entries(merged)
    .filter(([, score]) => typeof score === 'number' && !Number.isNaN(score))
    .map(([name, score]) => ({ name, score }));

  // optional sorting
  if (sortByScore) {
    result.sort((a, b) => (descending ? b.score - a.score : a.score - b.score));
  }

  return result;
};

      const payload = {
        area1: {
          name: streetData.street,
          postcode: streetData.postcode,
          overall_score: streetData.overall_score,
          amenities: buildAmenitiesPayload(streetData)
        }
      };

      if (showComparison && comparisonData) {
        payload.area2 = {
          name: comparisonData.area2.street,
          postcode: comparisonData.area2.postcode,
          overall_score: comparisonData.area2.overall_score,
          amenities: buildAmenitiesPayload(comparisonData.area2)
        };
      }

      console.log('Sending AI request:', payload);

      const res = await fetch(`${BASE_URL}api/ai/summary/`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          ...(user?.token ? { 'Authorization': `Token ${user.token}` } : {})
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errorText = await res.text();
        throw new Error(`AI API error: ${res.status} - ${errorText}`);
      }

      const result = await res.json();
      console.log('AI response received:', result);

      // Handle different response formats
      const handleAIResponse = (response) => {
        // Case 1: Full comparison response
        if (response.area1 && response.area2 && response.comparison) {
          return {
            primary: response.area1,
            secondary: response.area2,
            comparison: response.comparison
          };
        }
        
        // Case 2: Single street response wrapped in area1
        if (response.area1 && (!response.area2 || !response.comparison)) {
          return {
            primary: response.area1,
            secondary: null,
            comparison: null
          };
        }
        
        // Case 3: Direct single street response
        if (response.one_liner || response.summary || response.highlights) {
          return {
            primary: response,
            secondary: null,
            comparison: null
          };
        }
        
        // Case 4: Raw response
        if (response.raw) {
          try {
            const parsed = JSON.parse(response.raw);
            return handleAIResponse(parsed);
          } catch (e) {
            console.log('Could not parse raw response as JSON:', e);
            return {
              primary: { 
                summary: response.raw,
                one_liner: response.raw.split('.')[0] + '.',
                highlights: response.raw.split('.').filter(s => s.trim()).slice(0, 3)
              },
              secondary: null,
              comparison: null
            };
          }
        }
        
        // Case 5: Fallback
        return {
          primary: { 
            summary: typeof response === 'string' ? response : JSON.stringify(response, null, 2),
            one_liner: "AI analysis generated successfully.",
            highlights: ["Analysis based on amenity scores", "Generated by Claude Sonnet 4.5 with Tavily", "Professional property insights"]
          },
          secondary: null,
          comparison: null
        };
      };

      const processedResponse = handleAIResponse(result);
      console.log('Processed AI response:', processedResponse);
      
      // Check if this is a fallback response from the backend
      if (result._fallback) {
        console.log('Received fallback response from backend:', result._message);
        setAiError(result._message || 'AI analysis temporarily unavailable. Showing basic summary.');
      }
      
      setAiSummaries(processedResponse);

    } catch (err) {
      console.error('AI summary error:', err);
      
      // Determine if this is a network error or API error
      const isNetworkError = err.message?.includes('Failed to fetch') || 
                             err.message?.includes('NetworkError') ||
                             err.message?.includes('net::ERR');
      
      const errorMessage = isNetworkError 
        ? 'Unable to connect to AI service. Showing basic analysis.'
        : (err.message || 'AI analysis temporarily unavailable.');
      
      setAiError(errorMessage);
      
      // Fallback content - generated client-side when API completely fails
      const fallbackContent = {
        primary: {
          one_liner: `${streetData?.street?.split(',')[0]} in ${streetData?.postcode || 'London'} - amenity score ${streetData?.overall_score}/100.`,
          summary: `This area scores ${streetData?.overall_score}/100 overall, indicating a balanced mix of amenities and services. ${streetData?.top_3_attributes?.length > 0 ? `Top categories include ${streetData?.top_3_attributes?.map(a => a.name).join(', ')}.` : ''} Full AI analysis will be available shortly.`,
          highlights: [
            `Overall score: ${streetData?.overall_score}/100`,
            streetData?.postcode ? `Located in ${streetData.postcode}` : 'London location',
            streetData?.top_3_attributes?.[0] ? `Top category: ${streetData.top_3_attributes[0].name}` : 'Multiple amenities available'
          ],
          history: 'Detailed historical information will be available when AI service reconnects.',
          _fallback: true
        },
        secondary: null,
        comparison: null,
        _fallback: true,
        _clientFallback: true
      };

      if (showComparison && comparisonData) {
        fallbackContent.secondary = {
          one_liner: `${comparisonData.area2.street.split(',')[0]} in ${comparisonData.area2.postcode || 'London'} - amenity score ${comparisonData.area2.overall_score}/100.`,
          summary: `With an overall score of ${comparisonData.area2.overall_score}/100, this area offers different amenity strengths. ${comparisonData.area2.top_3_attributes?.length > 0 ? `Top categories: ${comparisonData.area2.top_3_attributes?.map(a => a.name).join(', ')}.` : ''}`,
          highlights: [
            `Overall score: ${comparisonData.area2.overall_score}/100`,
            comparisonData.area2.postcode ? `Located in ${comparisonData.area2.postcode}` : 'London location',
            comparisonData.area2.top_3_attributes?.[0] ? `Top category: ${comparisonData.area2.top_3_attributes[0].name}` : 'Multiple amenities'
          ],
          history: 'Detailed historical information temporarily unavailable.',
          _fallback: true
        };
        
        const scoreDiff = Math.abs((streetData?.overall_score || 0) - (comparisonData.area2.overall_score || 0));
        fallbackContent.comparison = {
          summary: `Comparing ${streetData?.street?.split(',')[0]} (${streetData?.overall_score}/100) with ${comparisonData.area2.street.split(',')[0]} (${comparisonData.area2.overall_score}/100).`,
          differences: [
            `Score difference: ${scoreDiff} points`,
            'Review individual category scores for detailed comparison',
            'Full AI comparison will be available shortly'
          ],
          verdict: 'Detailed AI verdict temporarily unavailable. Compare the amenity scores above.',
          _fallback: true
        };
      }

      setAiSummaries(fallbackContent);
    } finally {
      setAiLoading(false);
    }
  }, [streetData, showComparison, comparisonData, user]); // REMOVED aiSummaries.primary from dependencies

  // Trigger AI generation immediately when street data loads (no delay)
  useEffect(() => {
    if (streetData && !aiSummaries.primary && !aiLoading) {
      // Start AI generation immediately - no delay for faster UX
      fetchAISummaries();
    }
  }, [streetData]); // Only depend on streetData

  // Handle comparison mode changes - trigger immediately
  useEffect(() => {
    if (showComparison && comparisonData && !aiLoading) {
      // Reset and fetch fresh AI summary when entering comparison mode
      setAiSummaries({ primary: null, secondary: null, comparison: null });
      // Start immediately for faster UX
      fetchAISummaries();
    }
  }, [showComparison, comparisonData]); // Only depend on showComparison and comparisonData

  // Helper: search streets for compare suggestions
  const searchStreets = async (q) => {
    try {
      if (!q || !q.trim()) return [];
      setCompareLoading(true);
      const res = await fetch(`${BASE_URL}api/streets/search-streets/?q=${encodeURIComponent(q.trim())}`);
      if (!res.ok) return [];
      const data = await res.json();
      return Array.isArray(data) ? data : [];
    } catch (err) {
      console.error('searchStreets error:', err);
      return [];
    } finally {
      setCompareLoading(false);
    }
  };

  // Debounce compare input to fetch suggestions
  useEffect(() => {
    if (!compareInput) {
      setCompareSuggestions([]);
      setShowCompareSuggestions(false);
      setCompareSelectedId(null);
      return;
    }
    const t = setTimeout(async () => {
      const results = await searchStreets(compareInput);
      setCompareSuggestions(results);
      setShowCompareSuggestions(results.length > 0);
    }, 300);
    return () => clearTimeout(t);
  }, [compareInput]);

  // When user clicks a suggestion
  const handleCompareSuggestionClick = async (suggestion) => {
    setCompareInput(suggestion.name);
    setCompareSelectedId(suggestion.id);
    setShowCompareSuggestions(false);
    await performCompareByIds(streetData?.id, suggestion.id);
  };

  // Perform compare with preferred id1/id2
  const performCompareByIds = async (id1, id2) => {
    if (!id1 || !id2) {
      setError('Both street IDs are required for comparison.');
      return;
    }
    setLoading(true);
    setError(null);

    try {
      const token = localStorage.getItem('token');
      const headers = token ? { Authorization: `Token ${token}` } : {};

      const res = await fetch(`${BASE_URL}api/streets/compare/?id1=${encodeURIComponent(id1)}&id2=${encodeURIComponent(id2)}`, { headers });
      if (!res.ok) {
        if (res.status === 404) throw new Error('One of the streets was not found for comparison.');
        throw new Error('Failed to fetch comparison data');
      }
      const comp = await res.json();

      const area1Id = comp?.area1?.id ?? id1;
      const area2Id = comp?.area2?.id ?? id2;

      const [amen1, amen2] = await Promise.all([fetchAmenitiesById(area1Id), fetchAmenitiesById(area2Id)]);

      setComparisonData(comp);
      setComparisonAmenities({ area1: amen1, area2: amen2 });
      setShowComparison(true);

      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      console.error('performCompareByIds error:', err);
      setError(err.message || 'Comparison failed');
      setShowComparison(false);
    } finally {
      setLoading(false);
    }
  };

  // User pressed Enter in compare input
  const handleCompareSubmit = async (e) => {
    e?.preventDefault?.();
    if (!compareInput?.trim()) {
      setError('Please enter a street name or pick a suggestion to compare.');
      return;
    }
    setError(null);

    if (compareSelectedId) {
      return performCompareByIds(streetData?.id, compareSelectedId);
    }

    const results = await searchStreets(compareInput);
    if (results.length > 0) {
      return performCompareByIds(streetData?.id, results[0].id);
    }

    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const headers = token ? { Authorization: `Token ${token}` } : {};
      const res = await fetch(`${BASE_URL}api/streets/compare/?q1=${encodeURIComponent(streetData.street)}&q2=${encodeURIComponent(compareInput.trim())}`, { headers });
      if (!res.ok) {
        if (res.status === 404) throw new Error('Comparison street not found');
        throw new Error('Comparison failed');
      }
      const comp = await res.json();
      const [amen1, amen2] = await Promise.all([fetchAmenitiesById(comp.area1.id || streetData.id), fetchAmenitiesById(comp.area2.id)]);
      setComparisonData(comp);
      setComparisonAmenities({ area1: amen1, area2: amen2 });
      setShowComparison(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err) {
      console.error('fallback name compare error:', err);
      setError(err.message || 'Comparison failed');
    } finally {
      setLoading(false);
    }
  };

  // Utilities used by UI
  const countAmenities = (category) => {
    if (!streetData?.amenities) return 0;
    if (category === 'transport') {
      const transport = streetData.amenities.transports || {};
      return Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
    }
    const apiKey = categoryToApiKey[category];
    if (!apiKey) return 0;
    return streetData.amenities[apiKey]?.length || 0;
  };

  const getCategoryRating = (categoryId, data = streetData) => {
    if (!data?.attributes || !data.attributes[0]) return 0;
    return data.attributes[0][categoryId] || 0;
  };

  const _getNearbyPlaces = (category) => {
    if (!streetData?.amenities) return [];
    if (category === 'transport') {
      const transport = streetData.amenities.transports || {};
      return Object.values(transport).flat().slice(0, 5);
    }
    const apiKey = categoryToApiKey[category];
    if (!apiKey) return [];
    return streetData.amenities[apiKey]?.slice(0, 5) || [];
  };

  const getAllPlacesForCategory = (category, streetNameParam) => {
    if (!streetNameParam) return [];
    if (streetNameParam === streetData?.street) {
      if (category === 'transport') {
        const transport = streetData.amenities?.transports || {};
        return Object.values(transport).flat();
      }
      const apiKey = categoryToApiKey[category];
      if (!apiKey) return [];
      return streetData.amenities?.[apiKey] || [];
    }

    if (comparisonAmenities) {
      const amenities = streetNameParam === comparisonData?.area1.street ? comparisonAmenities.area1 : comparisonAmenities.area2;
      if (category === 'transport') {
        const transport = amenities?.transports || {};
        return Object.values(transport).flat();
      }
      const apiKey = categoryToApiKey[category];
      if (!apiKey) return [];
      return amenities?.[apiKey] || [];
    }

    return [];
  };

  // Modals and UI helpers
  const openCategoryModal = (category, streetName = '') => {
    scrollPositionRef.current = window.scrollY;
    setModalCategory(category);
    setModalStreetName(streetName || streetData?.street || '');
    setIsCategoryModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeCategoryModal = () => {
    setIsCategoryModalOpen(false);
    setModalCategory(null);
    document.body.style.overflow = 'unset';
    setTimeout(() => {
      window.scrollTo(0, scrollPositionRef.current);
    }, 10);
  };

  useEffect(() => {
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  useEffect(() => {
    if (showComparison) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [showComparison]);

  function getScoreClass(score) {
    if (score < 8) return 'low';
    if (score < 9) return 'medium';
    return 'high';
  }

  // -------------------------
  // AI Summary UI Components
  // -------------------------
  const renderAIHighlights = (highlights) => {
    if (!highlights) return null;
    
    if (Array.isArray(highlights)) {
      return (
        <ul className="ai-bullet-list">
          {highlights.map((item, index) => (
            <li key={index} className="ai-bullet-item">
              <span className="ai-bullet-icon">•</span>
              <span className="ai-bullet-text">{item}</span>
            </li>
          ))}
        </ul>
      );
    }
    
    if (typeof highlights === 'string') {
      const items = highlights.split(/\n|;|\.(?=\s+[A-Z])/).filter(item => item.trim().length > 0);
      if (items.length > 1) {
        return (
          <ul className="ai-bullet-list">
            {items.map((item, index) => (
              <li key={index} className="ai-bullet-item">
                <span className="ai-bullet-icon">•</span>
                <span className="ai-bullet-text">{item.trim()}</span>
              </li>
            ))}
          </ul>
        );
      }
      return <p className="ai-text">{highlights}</p>;
    }
    
    return null;
  };

  const renderAICard = (title, data, areaKey, isComparison = false) => {
    if (!data) return null;

    return (
      <div className={`ai-summary-card ${isComparison ? 'comparison-card' : ''}`}>
        <div className="ai-card-header">
          <h3 className="ai-card-title">{title}</h3>
          
          {data.one_liner && (
            <div className="ai-one-liner-section">
              <div className="ai-section-header">
                <h4 className="ai-subtitle">🧭 Quick Summary</h4>
              </div>
              <div className="ai-one-liner">
                <div className="ai-quote-icon">"</div>
                <p className="ai-one-liner-text">{data.one_liner}</p>
                <div className="ai-quote-icon">"</div>
              </div>
            </div>
          )}

          {data.summary && (
            <div className="ai-section">
              <div className="ai-section-header">
                <h4 className="ai-subtitle">📋 Detailed Analysis</h4>
              </div>
              <div className="ai-summary-content">
                <p className="ai-text">{data.summary}</p>
              </div>
            </div>
          )}

          {data.highlights && (
            <div className="ai-section">
              <div className="ai-section-header">
                <h4 className="ai-subtitle">⭐ Key Highlights</h4>
              </div>
              <div className="ai-highlights-content">
                {renderAIHighlights(data.highlights)}
              </div>
            </div>
          )}

          {data.history && (
            <div className="ai-section">
              <div className="ai-section-header">
                <h4 className="ai-subtitle">🏛️ Area Background</h4>
              </div>
              <div className="ai-history-content">
                <p className="ai-text">{data.history}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderComparisonAISection = () => {
    if (showComparison && aiSummaries.primary && aiSummaries.secondary && aiSummaries.comparison) {
      return (
        <div className="ai-comparison-grid">
          <div className="ai-comparison-row">
            {renderAICard(
              streetData?.street?.split(',')[0], 
              aiSummaries.primary, 
              'primary', 
              true
            )}
            {renderAICard(
              comparisonData?.area2?.street?.split(',')[0], 
              aiSummaries.secondary, 
              'secondary', 
              true
            )}
          </div>
          
          <div className="ai-comparison-summary">
            <div className="ai-section">
              <div className="ai-section-header">
                <h4 className="ai-subtitle">📊 Comparison Overview</h4>
              </div>
              <div className="ai-summary-content">
                <p className="ai-text">{aiSummaries.comparison.summary}</p>
              </div>
            </div>

            {aiSummaries.comparison.differences && (
              <div className="ai-section">
                <div className="ai-section-header">
                  <h4 className="ai-subtitle">🔍 Key Differences</h4>
                </div>
                <div className="ai-highlights-content">
                  {renderAIHighlights(aiSummaries.comparison.differences)}
                </div>
              </div>
            )}

            {aiSummaries.comparison.verdict && (
              <div className="ai-section">
                <div className="ai-section-header">
                  <h4 className="ai-subtitle">⚖️ Final Verdict</h4>
                </div>
                <div className="ai-verdict-content">
                  <div className="ai-verdict-box">
                    <p className="ai-verdict-text">{aiSummaries.comparison.verdict}</p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      );
    }
    
    if (showComparison) {
      return (
        <div className="ai-loading-state">
          <div className="ai-loading-spinner"></div>
          <p className="ai-loading-text">Generating AI comparison analysis...</p>
        </div>
      );
    }
    
    return null;
  };

  const renderAIInsightsContent = () => {
    if (aiLoading) {
      return (
        <div className="ai-loading-state">
          <div className="ai-loading-spinner"></div>
          <p className="ai-loading-text">
            {showComparison 
              ? 'Generating AI comparison analysis...' 
              : 'Generating AI street analysis...'
            }
          </p>
          <p className="ai-loading-subtext">
            Analyzing amenity scores and generating insights...
          </p>
        </div>
      );
    }

    if (aiError) {
      return (
        <div className="ai-error-alert">
          <div className="error-icon">⚠️</div>
          <div className="error-content">
            <p className="error-title">AI Generation Error</p>
            <p className="error-message">{aiError}</p>
            <button 
              className="error-retry-btn"
              onClick={() => fetchAISummaries(true)}
            >
              Try Again
            </button>
          </div>
        </div>
      );
    }

    if (showComparison) {
      return renderComparisonAISection();
    }

    // Single street mode
    if (aiSummaries.primary) {
      return (
        <div className="ai-single-street">
          {renderAICard(
            streetData?.street?.split(',')[0] || 'Street Analysis',
            aiSummaries.primary,
            'primary'
          )}
        </div>
      );
    }

    // No AI data yet
    return (
      <div className="ai-empty-state">
        <div className="ai-empty-icon">🤖</div>
        <p className="ai-empty-title">AI Analysis Not Generated</p>
        <p className="ai-empty-description">
          Click "Regenerate" to generate AI insights for this street.
          {showComparison && ' Or compare with another street to get a detailed comparison.'}
        </p>
        <button 
          className="ai-generate-btn"
          onClick={() => fetchAISummaries()}
        >
          Generate AI Analysis
        </button>
      </div>
    );
  };

  // UI components
  const PlaceItem = ({ place, category, startCoords }) => {
    const endLat = place.latitude ?? place.lat ?? place.location_lat ?? null;
    const endLon = place.longitude ?? place.lon ?? place.location_lon ?? null;
    const startLat = startCoords?.lat ?? null;
    const startLon = startCoords?.lon ?? null;
    const directionsUrl = buildDirectionsUrl({ startLat, startLon, endLat, endLon });

    return (
      <div className="place-item">
        <div className="place-name">
          {category === 'transport' && place.stop_type && (
            <span className="transport-icon">{transportIcons[place.stop_type] || transportIcons.default}</span>
          )}
          {place.name}
        </div>
        {place.final_rating && <div className="place-rating">Rating: {place.final_rating}</div>}
        <div className="place-links">
          {endLat && endLon && (
            <a href={directionsUrl} target="_blank" rel="noopener noreferrer" className="map-link">View on Map</a>
          )}
        </div>
      </div>
    );
  };

  const StreetDetailCard = ({ street, amenities, overallScore, top3, streetType = 'primary' }) => {
    const streetNameShort = (typeof street === 'string') ? street.split(',')[0] : '';
    const postcode = amenities?.street?.postcode || 'London';

    const totalAmenities = Object.keys(amenities || {})
      .filter(key => key !== 'street')
      .reduce((total, key) => {
        if (key === 'transports') {
          const transport = amenities.transports || {};
          return total + Object.values(transport).reduce((t, arr) => t + (arr?.length || 0), 0);
        }
        return total + (amenities[key]?.length || 0);
      }, 0);

    const streetColorClass = streetType === 'primary' ? 'primary-street' : 'comparison-street';

    return (
      <div className="street-detail-card">
        <div className="location-info">
          <h2 className={streetColorClass}>{streetNameShort}</h2>
          <p>{postcode}</p>
        </div>

        <div className="scores-container">
          <div className="score-item main-score">
            <div className={`score-value ${streetColorClass}`}>{overallScore}/100</div>
            <div className="score-label">Amenity Score</div>
          </div>
        </div>

        <div className="top-3-inline">
          <h3 className="subsection-title">Top 3 Amenity Categories</h3>
          <ul className="top3-list">
            {(top3 || []).map((attr, i) => {
              const key = attr.name.toLowerCase();
              const cat = amenityCategories.find(c => c.id === key);
              const icon = cat ? cat.icon : '📍';
              const label = cat ? cat.name : attr.name;
              const score = +attr.score.toFixed(1);
              const pct = (score / 10) * 100;
              const cls = getScoreClass(score);

              return (
                <li key={i} className="top3-item" style={{ '--i': i }}>
                  <span className="top3-icon">{icon}</span>
                  <span className="top3-label">{label}</span>
                  <div className="top3-bar">
                    <div className={`top3-fill ${cls}`} style={{ width: `${pct}%` }} />
                  </div>
                  <span className="top3-score">{score}/10</span>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="stats-container">
          <div className="stat-item">
            <div className="stat-value">{totalAmenities}</div>
            <div className="stat-label">Total Amenities</div>
          </div>
        </div>
      </div>
    );
  };

  const renderModal = () => {
    if (!isCategoryModalOpen || !modalCategory) return null;

    const primaryStreetCoords = extractLatLonFromStreetObj(streetData?.amenities?.street || {});
    const comparisonStreetCoords = comparisonAmenities ? extractLatLonFromStreetObj(comparisonAmenities.area2?.street || {}) : { lat: null, lon: null };

    return ReactDOM.createPortal(
      <div className="modal-overlay">
        <div
          className="places-modal compare"
          ref={modalRef}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-header">
            <h3>{amenityCategories.find(cat => cat.id === modalCategory)?.name || modalCategory}</h3>
            <button
              className="close-detail"
              onClick={closeCategoryModal}
              aria-label="Close"
            >
              ×
            </button>
          </div>

          <div className="modal-stats">
            <div className="stat-group">
              <div className="stat-label">Performance Score</div>
              <div className="stat-value">{getCategoryRating(modalCategory).toFixed(1)}/10</div>
            </div>
            <p className="scoring-note">
              Each amenity is scored based on a combination of proximity and quality.
            </p>
          </div>

          <div className="modal-content compare">
            <div className="modal-column">
              <h4 className="primary-street">{streetData?.street?.split(',')[0]}</h4>
              <div className="places-scrollable">
                {getAllPlacesForCategory(modalCategory, streetData?.street).length > 0 ? (
                  getAllPlacesForCategory(modalCategory, streetData?.street).map((place, index) => (
                    <PlaceItem key={index} place={place} category={modalCategory} startCoords={primaryStreetCoords} />
                  ))
                ) : (
                  <div className="no-places-message">No places found in this category</div>
                )}
              </div>
            </div>

            {showComparison && comparisonData && (
              <div className="modal-column">
                <h4 className="comparison-street">{comparisonData.area2.street.split(',')[0]}</h4>
                <div className="places-scrollable">
                  {getAllPlacesForCategory(modalCategory, comparisonData.area2.street).length > 0 ? (
                    getAllPlacesForCategory(modalCategory, comparisonData.area2.street).map((place, index) => (
                      <PlaceItem key={index} place={place} category={modalCategory} startCoords={comparisonStreetCoords} />
                    ))
                  ) : (
                    <div className="no-places-message">No places found in this category</div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>,
      document.body
    );
  };

  // Loading & error handling
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner" />
        <p>Loading street data...</p>
      </div>
    );
  }

  if (error) {
    return <ErrorComponent error={error} onRetry={() => { setError(null); setLoading(true); }} />;
  }

  if (!streetData) {
    return <ErrorComponent error="No Data Available" onRetry={() => { setError(null); setLoading(true); }} />;
  }

  // Main render
  return (
    <>
      {!isCategoryModalOpen && (
        <div className="analysis-container">
          <header className="analysis-header">
            <button onClick={() => {
              if (showComparison) {
                setShowComparison(false);
                navigate(`/analysis?street_id=${encodeURIComponent(streetData.id)}`, { replace: true });
              } else {
                navigate(-1);
              }
            }} className="back-button">← Back</button>
          </header>

          <section className={`detailed-analysis-compare ${showComparison ? 'two-cards' : ''}`}>
            <StreetDetailCard
              street={streetData.street}
              amenities={streetData.amenities}
              overallScore={streetData.overall_score}
              top3={streetData.top_3_attributes}
              streetType="primary"
            />

            {showComparison && comparisonData && (
              <StreetDetailCard
                street={comparisonData.area2.street}
                amenities={comparisonAmenities?.area2}
                overallScore={comparisonData.area2.overall_score}
                top3={comparisonData.area2.top_3_attributes}
                streetType="comparison"
              />
            )}
          </section>

          <section className="compare-area">
            <h2 className="section-title">Compare with Another Area</h2>
            <div className="compare-card">
              <div className="input-group" ref={compareRef} style={{ position: 'relative' }}>
                <input
                  type="text"
                  placeholder="Enter street name"
                  className="compare-input"
                  value={compareInput}
                  onChange={(e) => {
                    setCompareInput(e.target.value);
                    setCompareSelectedId(null);
                    setShowCompareSuggestions(true);
                    setError(null);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') handleCompareSubmit(e);
                    if (e.key === 'Escape') {
                      setShowCompareSuggestions(false);
                    }
                  }}
                />
                <button className="compare-button" onClick={handleCompareSubmit}>Compare Areas</button>

                {showCompareSuggestions && compareSuggestions.length > 0 && (
                  <div className="suggestions-dropdown compare-suggestions">
                    {compareSuggestions.map(s => (
                      <div key={s.id} className="suggestion-item" onClick={() => handleCompareSuggestionClick(s)}>
                        <div className="suggestion-name">{s.name}</div>
                        <div className="suggestion-postcode">{s.postcode}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <p className="compare-description">Compare {streetData.street.split(',')[0]} with any other area to see side-by-side amenity analysis</p>
            </div>
          </section>

          {showComparison && comparisonData && (
            <>
              <section className="comparison-results">
                <h2 className="section-title">Comparison Results</h2>

                <div className="attribute-comparison">
                  <h3>Attribute Scores</h3>
                  <div className="attribute-grid">
                    {Object.entries(comparisonData.area1.attributes).map(([attr, score]) => (
                      <div key={attr} className="attribute-item">
                        <div className="attribute-name">{amenityCategories.find(c => c.id === attr)?.name || attr}</div>
                        <div className="attribute-scores">
                          <span className="score1 primary-street">{score}</span>
                          <span className="score-divider">:</span>
                          <span className="score2 comparison-street">{comparisonData.area2.attributes[attr]}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <button className="close-comparison" onClick={() => setShowComparison(false)}>Close Comparison</button>
              </section>

              <section className="amenity-comparison-container">
                <h2 className="section-title comparison-title">Amenity Comparison</h2>
                <p className="comparison-description">
                  Scores are based on proximity and quality of amenities.
                </p>
                <div className="categories-grid comparison">
                  {amenityCategories.map(category => {
                    const street1Count = countAmenities(category.id);
                    const street1Score = getCategoryRating(category.id);
                    const street2Count = comparisonData.area2.category_counts[category.id] || 0;
                    const street2Score = comparisonData.area2.attributes[category.id] || 0;

                    if (street1Count === 0 && street2Count === 0) return null;

                    return (
                      <div key={category.id} className="category-card comparison" onClick={() => openCategoryModal(category.id)}>
                        <div className="category-header">
                          <div className="category-icon">{category.icon}</div>
                          <h3 className="category-name">{category.name}</h3>
                        </div>

                        <div className="street-comparison">
                          <div className="street-row">
                            <div className="street-name primary-street">{comparisonData.area1.street.split(',')[0]}</div>
                            <div className="score-display">
                              <div className="street-score primary-street">{street1Score.toFixed(1)}/10</div>
                              <div className="street-count">({street1Count} locations)</div>
                            </div>
                          </div>

                          <div className="street-row">
                            <div className="street-name comparison-street">{comparisonData.area2.street.split(',')[0]}</div>
                            <div className="score-display">
                              <div className="street-score comparison-street">{street2Score.toFixed(1)}/10</div>
                              <div className="street-count">({street2Count} locations)</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </section>
            </>
          )}

          {!showComparison && (
            <section className="amenity-categories">
              <h2 className="section-title">All Amenity Categories</h2>
              <div className="categories-grid">
                {amenityCategories.map(category => {
                  const count = countAmenities(category.id);
                  if (count === 0) return null;
                  const score = getCategoryRating(category.id);

                  return (
                    <div key={category.id} className="category-card" onClick={() => openCategoryModal(category.id)}>
                      <div className="category-header">
                        <div className="category-icon">{category.icon}</div>
                        <h3 className="category-name">{category.name}</h3>
                      </div>
                      <div className="street-row">
                        <div className="score-display">
                          <div className="street-score primary-street">{score.toFixed(1)}/10</div>
                          <div className="street-count">({count} {count === 1 ? 'location' : 'locations'})</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </section>
          )}

          {/* Enhanced AI Insights Section */}
          <section className="ai-insights-section">
            <div className="ai-header-container">
              <div className="ai-header-left">
                <h2 className="section-title">AI-Powered Analysis</h2>
                <p className="ai-subtitle-description">
                  {showComparison 
                    ? 'AI-generated comparison of both streets' 
                    : 'AI-generated insights about this street'
                  }
                </p>
              </div>
              <div className="ai-header-right">
                <button 
                  className="ai-action-btn regenerate-btn"
                  onClick={() => fetchAISummaries(true)}
                  disabled={aiLoading}
                >
                  {aiLoading ? (
                    <>
                      <span className="spinner"></span>
                      Generating...
                    </>
                  ) : (
                    '🔄 Regenerate'
                  )}
                </button>
                <button 
                  className="ai-action-btn info-btn"
                  onClick={() => {
                    alert('This AI analysis is powered by Claude Sonnet 4.5 via AWS Bedrock, with neighbourhood research from Tavily. It analyzes amenity scores, location data, and provides lifestyle insights based on real web sources.');
                  }}
                  title="About AI Analysis"
                >
                  ℹ️ Info
                </button>
              </div>
            </div>

            <div className="ai-content-area">
              {renderAIInsightsContent()}
            </div>

            {(aiSummaries.primary || aiSummaries.comparison) && (
              <div className="ai-footer-note">
                <p className="ai-note-text">
                  <span className="ai-note-icon">💡</span>
                  AI analysis powered by Claude Sonnet 4.5 and Tavily. Insights are based on amenity scores, location data, and real neighbourhood research.
                  {showComparison && ' Comparison highlights key differences and recommendations.'}
                </p>
              </div>
            )}
          </section>
        </div>
      )}
      {renderModal()}
    </>
  );
};

export default StreetAnalysis;